import { Dispatch, AnyAction } from 'redux';
import { AppState } from '../redux';
import {
  STORE_COMPLETEORDERDATA,
  STORE_COMPLETEDATA_ORDERNO,
  ViewCompletedOrder,
  STORE_VIEWCOMPLETEDORDER,
  RowDataCompleted,
  STORE_PROGRESS_DOWNLOADING,
  RedesignReasons,
  STORE_REDESIGN_REASONS,
  CompOrderFilterData,
  ViewFeedback,
  STORE_VIEWFEEDBACK,
  STORE_MANUFACTCOMPLETEORDERDATA,
  ManuCompOrderFilterData,
  // dialog
  STORE_FAILED_FILES,
  // STORE_FAILED_FILES_MESSAGE,
  SHOW_FAILED_FILES_DIALOG

} from '../reducers/completeorderfile';

import axios, { AxiosResponse, AxiosError } from 'axios';
import { push } from 'react-router-redux';
import { STORE_LIVEDATA_ORDERID } from 'src/reducers/liveorderfile';
import { STORE_SEARCHTRUE, STORE_SEARCHNAME, STORE_LOADER } from 'src/reducers/landingPage';
import { clearDataOnOpen, getRxOrderData, messageObjectTransform } from './rxformAction';
import {
  GetAllFileData,
  UserRxFormData,
  STORE_RXORDERDATA,
  STORE_DESIGNTYPE_RXFORM,
  STORE_GETDATAFILES,
  STORE_GETMESSAGES,
  STORE_MODEL_RXFORM,
  STORE_NOTATIONS_RXFORM,
  STORE_PRODUCTNAME_RXFORM,
  STORE_PRODUCT_RXFORM,
  GetUserMessage,
  GetFileData,

} from 'src/reducers/rxForm';
import { STORE_ERROR_FILES_UPLOADED, STORE_ERROR_FILES_UPLOADED_MSG } from 'src/reducers/errors';
import { commonDateFormat } from './completedOrderDateAction';

export const defaultDesignReadyData = {
  pdownload: 'Not Downloaded',
  prange: 'all',
  pqc_required: 'all',
  fdate: new Date(new Date().getTime() - (7 * 24 * 60 * 60 * 1000)),
  tdate: new Date()
};

export const maxDayCount = (sdate: Date, edate: Date) => {
  if (Math.abs(sdate.getTime() - edate.getTime()) < (8 * 24 * 60 * 60 * 1000)) {
    return false;
  }
  return true;
};

export const getCompleteOrderData = async (dispatch: Dispatch<AppState>, getState: () => AppState) => {

  dispatch({ type: STORE_LOADER, loader: true } as AnyAction);

  await axios({
    method: 'post',
    url: `${getState().environment.API_URL
      }loadOrderData?listType=ccmpton&userCode=${encodeURIComponent(getState().user.userDetails.userName)}`,
    headers: {
      'Access-Control-Allow-Origin': '*',
      'Content-Type': 'application/json',
      sessionid: getState().user.userDetails.s || ''
    }
  }).then(function (response: AxiosResponse) {

    dispatch({ type: STORE_LOADER, loader: false } as AnyAction);

    if (response.data.length === 1) {
      if (response.data[0].orderno !== '') {
        const completeOrderData: RowDataCompleted[] = response.data;
        dispatch({ type: STORE_COMPLETEORDERDATA, completeOrderData } as AnyAction);
      } else {
        const completeOrderData: RowDataCompleted[] = [];
        dispatch({ type: STORE_COMPLETEORDERDATA, completeOrderData } as AnyAction);
      }
    } else {
      const completeOrderData: RowDataCompleted[] = response.data;
      dispatch({ type: STORE_COMPLETEORDERDATA, completeOrderData } as AnyAction);
    }

  }).catch(function (error: AxiosError) {

    dispatch({ type: STORE_LOADER, loader: false } as AnyAction);

    const completeOrderData: RowDataCompleted[] = [];
    dispatch({ type: STORE_COMPLETEORDERDATA, completeOrderData } as AnyAction);
  });

};
export const onFilterCompletedData = (data: CompOrderFilterData) => {
  return async (dispatch: Dispatch<AppState>, getState: () => AppState) => {

    dispatch({ type: STORE_LOADER, loader: true } as AnyAction);

    await axios({
      method: 'post',
      url: `${getState().environment.API_URL}getfilterdata`,
      headers: {
        'Access-Control-Allow-Origin': '*',
        'Content-Type': 'application/json',
        sessionid: getState().user.userDetails.s || ''
      },
      data: {
        listType: 'ccmpton2',
        data: {
          ...data, ...{
            fdate: commonDateFormat(data.fdate, 'date') || null,
            tdate: commonDateFormat(data.tdate, 'date') || null,
            pusername: getState().user.userDetails.userName
          }
        }
      }
    }).then(function (response: AxiosResponse) {

      dispatch({ type: STORE_LOADER, loader: false } as AnyAction);

      if (response.data.length === 1) {
        if (response.data[0].orderno !== '') {
          const completeOrderData: RowDataCompleted[] = response.data;
          dispatch({ type: STORE_COMPLETEORDERDATA, completeOrderData } as AnyAction);
        } else {
          const completeOrderData: RowDataCompleted[] = [];
          dispatch({ type: STORE_COMPLETEORDERDATA, completeOrderData } as AnyAction);
        }
      } else {
        const completeOrderData: RowDataCompleted[] = response.data;
        dispatch({ type: STORE_COMPLETEORDERDATA, completeOrderData } as AnyAction);
      }

    }).catch(function (error: AxiosError) {

      dispatch({ type: STORE_LOADER, loader: false } as AnyAction);

      const completeOrderData: RowDataCompleted[] = [];
      dispatch({ type: STORE_COMPLETEORDERDATA, completeOrderData } as AnyAction);
    });
    
  };
};
export const getRedesignReasons = async (dispatch: Dispatch<AppState>, getState: () => AppState) => {

  await axios({
    method: 'post',
    url: `${getState().environment.API_URL
      }loadOrderData?listType=redicode`,
    headers: {
      'Access-Control-Allow-Origin': '*',
      'Content-Type': 'application/json',
      sessionid: getState().user.userDetails.s || ''
    }
  }).then(function (response: AxiosResponse) {

    if (response.data.length === 1) {
      if (response.data[0].description !== '') {
        const redesignReasons: RedesignReasons[] = response.data;
        dispatch({ type: STORE_REDESIGN_REASONS, redesignReasons } as AnyAction);
      } else {
        const redesignReasons: RedesignReasons[] = [];
        dispatch({ type: STORE_REDESIGN_REASONS, redesignReasons } as AnyAction);
      }
    } else {
      const redesignReasons: RedesignReasons[] = response.data;
      dispatch({ type: STORE_REDESIGN_REASONS, redesignReasons } as AnyAction);
    }

  }).catch(function (error: AxiosError) {
    console.error(error);
  });

};

export const updateColorCode = (orderno: string) => {
  return async (dispatch: Dispatch<AppState>, getState: () => AppState) => {

    const sessionid = getState().user.userDetails.s || '';
    dispatch({ type: STORE_COMPLETEDATA_ORDERNO, orderno } as AnyAction);

    axios({
      method: 'post',
      url: `${getState().environment.API_URL
        }getOrderDetails?orderId=${getState().completeOrder.orderno}`,
      headers: {
        'Access-Control-Allow-Origin': '*',
        'Content-Type': 'application/json',
        sessionid: sessionid
      }
    }).then(async function (response: AxiosResponse) {
      const viewCompleteOrder: ViewCompletedOrder[] = response.data;
      dispatch({ type: STORE_VIEWCOMPLETEDORDER, viewCompleteOrder } as AnyAction);
      dispatch({ type: STORE_LOADER, loader: false } as AnyAction);
    }).catch(function (error: AxiosError) {
      dispatch({ type: STORE_LOADER, loader: false } as AnyAction);
    });
  };
};

export const rowClick = (orderid: string, orderno: string, feedback?: string) => {
  return async (dispatch: Dispatch<AppState>, getState: () => AppState) => {
    const sessionid = getState().user.userDetails.s || '';

    const searchName = '';
    dispatch({ type: STORE_SEARCHNAME, searchName } as AnyAction);

    const searchTrue = false;
    dispatch({ type: STORE_SEARCHTRUE, searchTrue } as AnyAction);
    dispatch({ type: STORE_COMPLETEDATA_ORDERNO, orderno } as AnyAction);
    dispatch({ type: STORE_LIVEDATA_ORDERID, orderid } as AnyAction);

    const userRxdata: UserRxFormData[] = [];
    dispatch({ type: STORE_RXORDERDATA, userRxdata } as AnyAction);

    clearDataOnOpen(dispatch, getState);

    dispatch({ type: STORE_LOADER, loader: true } as AnyAction);

    await axios({
      method: 'post',
      url: `${getState().environment.API_URL
        }getOrderDetails?orderId=${getState().completeOrder.orderno}`,
      headers: {
        'Access-Control-Allow-Origin': '*',
        'Content-Type': 'application/json',
        sessionid: sessionid
      }
    }).then(async function (response: AxiosResponse) {
      const viewCompleteOrder: ViewCompletedOrder[] = response.data;
      console.log(viewCompleteOrder, 'viewCompleteOrder');
      
      dispatch({ type: STORE_VIEWCOMPLETEDORDER, viewCompleteOrder } as AnyAction);

      if (getState().landingPage.verticalViewScreen) {

        for (const arr of [1]) {

          await axios({
            method: 'post',
            url: `${getState().environment.API_URL}getRxOrderDetails?orderId=${getState().liveOrder.orderid}`,
            headers: {
              type: arr,
              sessionid: sessionid || ''
            },
          }).then(function (resp: AxiosResponse) {

            dispatch({ type: STORE_RXORDERDATA, userRxdata: resp.data } as AnyAction);

            const designtype = getState().UserRxFormData.userRxdata[0].designtype;
            const notations = getState().UserRxFormData.userRxdata[0].notations;
            const product = getState().UserRxFormData.userRxdata[0].product;
            const productname = getState().UserRxFormData.userRxdata[0].productname;
            const model = getState().UserRxFormData.userRxdata[0].model;
                 
            dispatch({ type: STORE_DESIGNTYPE_RXFORM, designtype } as AnyAction);
            dispatch({ type: STORE_NOTATIONS_RXFORM, notations } as AnyAction);
            dispatch({ type: STORE_PRODUCT_RXFORM, product } as AnyAction);
            dispatch({ type: STORE_PRODUCTNAME_RXFORM, productname } as AnyAction);
            dispatch({ type: STORE_MODEL_RXFORM, model } as AnyAction);

            return true;

          }).catch(error => {

            const errorFileUploadedOpen = true;
            const errorfilemsg = error.response.data.msg;
            dispatch({ type: STORE_ERROR_FILES_UPLOADED_MSG, errorfilemsg } as AnyAction);
            dispatch({ type: STORE_ERROR_FILES_UPLOADED, errorFileUploadedOpen } as AnyAction);

            return true;

          });

          await axios({
            method: 'post',
            url: `${getState().environment.API_URL}getOrderMessage?messageType=0&pid=${getState().liveOrder.orderid}`,
            headers: {
              type: arr,
              sessionid: sessionid || ''
            },
          }).then(function (resp: AxiosResponse) {

            const getUserMessage: GetUserMessage[] = resp.data;
            dispatch({ type: STORE_GETMESSAGES, getUserMessage: messageObjectTransform(getUserMessage) } as AnyAction);

          }).catch(error => {
            dispatch({ type: STORE_GETMESSAGES, getUserMessage: [] } as AnyAction);
            const errorFileUploadedOpen = true;
            const errorfilemsg = error.response.data.msg;
            dispatch({ type: STORE_ERROR_FILES_UPLOADED_MSG, errorfilemsg } as AnyAction);
            dispatch({ type: STORE_ERROR_FILES_UPLOADED, errorFileUploadedOpen } as AnyAction);
          });

          await axios({
            method: 'post',
            url: `${getState().environment.API_URL}getFiles?orderId=${getState().liveOrder.orderid}`,
            headers: {
              type: arr,
              sessionid: sessionid || ''
            },
          }).then(function (resp: AxiosResponse) {
            const getFileData: GetFileData[] = resp.data;
            dispatch({ type: STORE_GETDATAFILES, getFileData } as AnyAction);

          }).catch(function (error: AxiosError) {
            dispatch({ type: STORE_GETDATAFILES, getFileData: [] } as AnyAction);
          });

        }
        dispatch({ type: STORE_LOADER, loader: false } as AnyAction);

        dispatch(push('/app/rxform'));
        // if (feedback === '1') {
        //   dispatch(push('/app/viewfeedback'));
        // } else {
        //   dispatch(push('/app/rxform'));
        // }

      } else {
        if (dispatch(getRxOrderData)) {

          dispatch({ type: STORE_LOADER, loader: false } as AnyAction);

          dispatch(push('/app/rxform'));
          // if (feedback === '1') {
          //   dispatch(push('/app/viewfeedback'));
          // } else {
          //   dispatch(push('/app/rxform'));
          // }
          // setInterval(getMessage, 5000);
        }
      }

    }).catch(function (error: AxiosError) {

      dispatch({ type: STORE_LOADER, loader: false } as AnyAction);

      const viewCompleteOrder: ViewCompletedOrder[] = [];
      dispatch({ type: STORE_VIEWCOMPLETEDORDER, viewCompleteOrder } as AnyAction);
    });

    return true;
  };
};

export const rowFbStatusClick = (
  orderid: string,
  orderno: string,
  feedbackreview: string
) => {
  return async (dispatch: Dispatch<AppState>, getState: () => AppState) => {

    const sessionid = getState().user.userDetails.s || '';
    const submitApiUrl = `${getState().environment.API_URL}getOrderDetails?orderId=${encodeURIComponent(orderno || '')}`;
    const viewCmptApiUrl = `${getState().environment.API_URL}updateviewcmpt`;
    const ViewApiUrl = `${getState().environment.API_URL}getFeedbackData?porderno=${encodeURIComponent(orderid || '')}`;

    // Dispatch initial actions
    dispatch({ type: STORE_SEARCHNAME, searchName: '' } as AnyAction);
    dispatch({ type: STORE_SEARCHTRUE, searchTrue: false } as AnyAction);
    dispatch({ type: STORE_COMPLETEDATA_ORDERNO, orderno } as AnyAction);
    dispatch({ type: STORE_LIVEDATA_ORDERID, orderid } as AnyAction);
    dispatch({ type: STORE_RXORDERDATA, userRxdata: [] } as AnyAction);

    // Clear data utility
    clearDataOnOpen(dispatch, getState);

    // Show loader
    dispatch({ type: STORE_LOADER, loader: true } as AnyAction);

    try {
      const response = await axios.post(submitApiUrl, null, {
        headers: {
          'Access-Control-Allow-Origin': '*',
          'Content-Type': 'application/json',
          sessionid: sessionid,
        },
      });

      const viewCompleteOrder: ViewCompletedOrder[] = response.data || [];
      dispatch({ type: STORE_VIEWCOMPLETEDORDER, viewCompleteOrder } as AnyAction);

      if (feedbackreview !== '0') {
        try {
          const feedbackResponse = await axios.get(ViewApiUrl, {
            headers: {
              'Access-Control-Allow-Origin': '*',
              'Content-Type': 'application/json',
              sessionid: sessionid,
            },
          });
          const feedbackid = feedbackResponse.data?.feedbackid || '';
          const viewFeedback: ViewFeedback = feedbackResponse.data || {};
          dispatch({ type: STORE_VIEWFEEDBACK, viewFeedback } as AnyAction);

          // Navigate to feedback page
          dispatch(push('/app/viewfeedback'));

          if (feedbackreview === '3') {
            try {
              const viewdata = {
                feedbackid: feedbackid || '',
                status: '1',
              };

              await axios.post(viewCmptApiUrl, viewdata, {
                headers: {
                  'Access-Control-Allow-Origin': '*',
                  'Content-Type': 'application/json',
                  sessionid: sessionid,
                },
              });
            } catch (error) {
              console.error('Error updating feedback status:', error.message);
            }
          }
        } catch (error) {
          console.error('Error fetching feedback details:', error.message);

          // Reset feedback state on error
          dispatch({ type: STORE_VIEWFEEDBACK, viewFeedback: {} } as AnyAction);
        }
      } else {
        // Navigate to feedback page
        dispatch(push('/app/feedback'));
      }
    } catch (error) {
      console.error('Error fetching order details:', error.message);

      // Reset state on error
      dispatch({ type: STORE_VIEWCOMPLETEDORDER, viewCompleteOrder: [] } as AnyAction);
    } finally {
      // Hide loader
      dispatch({ type: STORE_LOADER, loader: false } as AnyAction);
    }

    return true;
  };
};

export const downloadStatusUpdate = (array: Array<object>, status: string, dispatch: Dispatch<AppState>, getState: () => AppState) => {

  const request = {
    columns: array,
    status: status
  };

  axios({
    method: 'PUT',
    url: `${getState().environment.API_URL
      }downloadStatusUpdate`,
    data: request,
    headers: {
      'Access-Control-Allow-Origin': '*',
      'Content-Type': 'application/json',
      sessionid: getState().user.userDetails.s || ''
    }
  }).then(function (response: AxiosResponse) {

    if (getState().completeOrder.viewCompleteOrder[0].orderno) {
      // dispatch(rowClick(getState().liveOrder.orderid, getState().completeOrder.orderno));
      dispatch(updateColorCode(getState().completeOrder.viewCompleteOrder[0].ds_ordersid));
    }

    // getCompleteOrderData(dispatch, getState);
    // getDesignReadyOrderData(dispatch, getState);

  }).catch(error => {
    // ==> console.error(`Error - download status update failed ::: ${error.response.data.msg}`);
  });

  return true;
};

// comment for 16.05.2025 --- 11:43 AM
// export const downloadURL = (filePath: string, fileName: string, status: string) => {
//   return async (dispatch: Dispatch<AppState>, getState: () => AppState) => {

//     let fullPath = filePath;

//     let updateDownloadStatus: boolean = false;

//     if (status.includes('STL') || status.includes('Final')) {
//       updateDownloadStatus = true;
//     }

//     // if (status.includes('Final')) {

//     //   if (filePath.indexOf('/Initial') !== -1) {
//     //     fullPath = `${filePath.split('/Initial')[0]}/Final_Scan/${fileName}`;
//     //   } else if (filePath.indexOf('/Final') !== -1) {
//     //     fullPath = `${filePath}/${fileName}`;
//     //   } else {
//     //     fullPath = `${filePath}/Final_Scan/${fileName}`;
//     //   }

//     // } else {
//     //   fullPath = `${filePath}/${fileName}`;
//     // }

//     fullPath = filePath.split('/')[2];
    
//     let downloadFrom = 'getDownloadUrl';
//     if (status) {
//       downloadFrom = 'getSignerUrlforOrder';
//     }
//     const encodedFilepath = encodeURIComponent(fullPath);

//     axios(`${getState().environment.API_URL}${downloadFrom}?fullPath=${encodedFilepath}`, {
//       method: 'GET',
//       headers: {
//         'Access-Control-Allow-Origin': '*',
//         'Content-Type': 'application/json',
//         sessionid: getState().user.userDetails.s || ''
//       }
//     }).then(response => {

//       window.open(response.data.signedUrl);
//       if (updateDownloadStatus) {
//         const orderNoArr = [{
//           orderno: filePath.split('/').reverse()[1]
//         }];
//         downloadStatusUpdate(orderNoArr, '1', dispatch, getState);
//       }

//     }).catch(error => {

//       const errorFileUploadedOpen = true;
//       const errorfilemsg = 'Something went wrong!';
//       dispatch({ type: STORE_ERROR_FILES_UPLOADED, errorFileUploadedOpen } as AnyAction);
//       dispatch({ type: STORE_ERROR_FILES_UPLOADED_MSG, errorfilemsg } as AnyAction);

//       // ==> console.error(error);
//     });

//     return true;
//   };
// };

export const downloadURL = (filePath: string, fileName: string, status: string) => {
  return async (dispatch: Dispatch<AppState>, getState: () => AppState) => {

    let fullPath = filePath;

    let updateDownloadStatus: boolean = false;

    if (status.includes('STL') || status.includes('Final')) {
      updateDownloadStatus = true;
    }

    if (status.includes('Final')) {

      if (filePath.indexOf('/Initial') !== -1) {
        fullPath = `${filePath.split('/Initial')[0]}/Final_Scan/${fileName}`;
      } else if (filePath.indexOf('/Final') !== -1) {
        fullPath = `${filePath}/${fileName}`;
      } else {
        fullPath = `${filePath}/Final_Scan/${fileName}`;
      }

    } else {
      fullPath = `${filePath}/${fileName}`;
    }

    // console.log(fullPath, 'fullPathfullPath');
    
    // console.log(status, 'statusstatus');
    const downloadFrom = 'commonBucketFileCheck';
    const encodedFilepath = encodeURIComponent(fullPath);

    axios(`${getState().environment.API_URL}${downloadFrom}?fullPath=${encodedFilepath}`, {
      method: 'GET',
      headers: {
        'Access-Control-Allow-Origin': '*',
        'Content-Type': 'application/json',
        sessionid: getState().user.userDetails.s || ''
      }
    }).then(response => {

      window.open(response.data.signedUrl);
      if (updateDownloadStatus) {
        const orderNoArr = [{
          orderno: filePath.split('/').reverse()[1]
        }];
        downloadStatusUpdate(orderNoArr, '1', dispatch, getState);
      }

    }).catch(error => {

      const errorFileUploadedOpen = true;
      const errorfilemsg = 'Something went wrong!';
      dispatch({ type: STORE_ERROR_FILES_UPLOADED, errorFileUploadedOpen } as AnyAction);
      dispatch({ type: STORE_ERROR_FILES_UPLOADED_MSG, errorfilemsg } as AnyAction);

      // ==> console.error(error);
    });

    return true;
  };
};
export const approvalReqd = (array: Array<object>, status: string, dispatch: Dispatch<AppState>, getState: () => AppState) => {

  const request = {
    columns: array,
    status: status
  };

  axios({
    method: 'PUT',
    url: `${getState().environment.API_URL
      }approvalRequired`,
    data: request,
    headers: {
      'Access-Control-Allow-Origin': '*',
      'Content-Type': 'application/json',
      sessionid: getState().user.userDetails.s || ''
    }
  }).then(function (response: AxiosResponse) {

    dispatch({ type: STORE_LOADER, loader: true } as AnyAction);
    getCompleteOrderData(dispatch, getState);
    if (getState().completeOrder.viewCompleteOrder[0].orderno) {
      // dispatch(rowClick(getState().liveOrder.orderid, getState().completeOrder.orderno));
      dispatch(updateColorCode(getState().completeOrder.viewCompleteOrder[0].ds_ordersid));
    }
  }).catch(function (error: AxiosError) {

    const errorFileUploadedOpen = true;
    const errorfilemsg = 'Something went wrong!';
    dispatch({ type: STORE_ERROR_FILES_UPLOADED, errorFileUploadedOpen } as AnyAction);
    dispatch({ type: STORE_ERROR_FILES_UPLOADED_MSG, errorfilemsg } as AnyAction);

    // ==> console.error(`Error - Approval Reqd update failed ::: ${error}`);
  });

  return true;
};

export const approvalRequired = (array: Array<object>) => {
  return async (dispatch: Dispatch<AppState>, getState: () => AppState) => {
    approvalReqd(array, '', dispatch, getState);
    // using the same download api for approval also
    return true;
  };
};

// export const onbulkDownload = (allData: RowDataCompleted[] | RowDataCompleted, statusUpdate: boolean) => {
//   console.log(allData, '90000');
//   return async (dispatch: Dispatch<AppState>, getState: () => AppState) => {

//     // const allData = getState().completeOrder.completeOrderData;

//     const newArray: Array<object> = [];
//     const newArrayOrderno: Array<object> = [];
//     let fullPathAll;
//     let isDownloading = false;

//     // if (Array.isArray(allData) && allData.length > 1) {

//     //   isDownloading = true;
//     //   dispatch({ type: STORE_PROGRESS_DOWNLOADING, isDownloading } as AnyAction);

//     //   allData.map((arr, index) => {

//     //     if (arr.status === '10' || arr.status === '14') {
//     //       if (arr.fpath.indexOf('/Initial') !== -1) {
//     //         fullPathAll = `${arr.fpath.split('/Initial')[0]}/Final_Scan/${arr.fname}`;
//     //       } else {
//     //         fullPathAll = `${arr.fpath}/Final_Scan/${arr.fname}`;
//     //       }

//     //       const fileValue = {
//     //         name: arr.fname,
//     //         key: `${fullPathAll}`
//     //       };

//     //       const orderArr = {
//     //         orderno: arr.orderno
//     //       };

//     //       newArray.push(fileValue);
//     //       newArrayOrderno.push(orderArr);

//     //     } else {
//     //       fullPathAll = `${arr.fpath.split('/Initial')[0]}/Initial_Scan/${arr.fname}`;

//     //       const fileValue = {
//     //         name: arr.fname,
//     //         key: `${fullPathAll}`
//     //       };

//     //       newArray.push(fileValue);
//     //     }

//     //   });

//     //   // const apiUrl =  allData[0].filetag === 'W' ? 'getDownloadUrl' : 'downloadMultifile';
//     //   // axios(`${getState().environment.API_URL}downloadMultifile`, {
//     //   axios(`${getState().environment.API_URL}${apiUrl}`, {
//     //     method: 'POST',
//     //     headers: {
//     //       'Access-Control-Allow-Origin': '*',
//     //       'Content-Type': 'application/json',
//     //     },
//     //     data: newArray
//     //   }).then(response => {
//     //     isDownloading = false;
//     //     dispatch({ type: STORE_PROGRESS_DOWNLOADING, isDownloading } as AnyAction);
//     //     if (statusUpdate && newArrayOrderno.length > 0) {
//     //       downloadStatusUpdate(newArrayOrderno, '1', dispatch, getState);
//     //     }
//     //     getCompleteOrderData(dispatch, getState);
//     //     window.open(response.data.signedUrl);

//     //   }).catch(error => {

//     //     const errorFileUploadedOpen = true;
//     //     const errorfilemsg = 'Something went wrong!';
//     //     dispatch({ type: STORE_ERROR_FILES_UPLOADED, errorFileUploadedOpen } as AnyAction);
//     //     dispatch({ type: STORE_ERROR_FILES_UPLOADED_MSG, errorfilemsg } as AnyAction);

//     //     isDownloading = false;
//     //     dispatch({ type: STORE_PROGRESS_DOWNLOADING, isDownloading } as AnyAction);
//     //     // ==> console.error(error);
//     //   });

//     // }
//     if (Array.isArray(allData) && allData.length > 1) {
//       isDownloading = true;
//       dispatch({ type: STORE_PROGRESS_DOWNLOADING, isDownloading } as AnyAction);
//       console.log(allData, '000000000000'); 
//       allData.map((arr) => {
//         console.log(arr, 'arrarrarr');
//         if (arr.status === '10' || arr.status === '14') {
//           if (arr.fpath.indexOf('/Initial') !== -1) {
//             fullPathAll = `${arr.fpath.split('/Initial')[0]}/Final_Scan/${arr.fname}`;
//             console.log(fullPathAll, '1111111111');
//           } else {
//             fullPathAll = `${arr.fpath}/Final_Scan/${arr.fname}`;
//             console.log(fullPathAll, '2222222222');
//           }
    
//           const orderArr = {
//             orderno: arr.orderno
//           };
//           console.log(orderArr, 'orderArrorderArr');
//           newArrayOrderno.push(orderArr);
//           console.log(newArrayOrderno, 'newArrayOrderno');  
//         } else {
//           fullPathAll = `${arr.fpath.split('/Initial')[0]}/Initial_Scan/${arr.fname}`;
//           console.log(fullPathAll, '3333333333'); 
//         }
    
//         const fileValue = {
//           name: arr.fname,
//           key: `${fullPathAll}`
//         };
//         console.log(fileValue, 'fileValue'); 
//         newArray.push(fileValue);
//         console.log(newArray, 'newArray');
//       });
    
//       if (allData[0].filetag === 'W') {
//         for (const file of allData) {
//           if (file.status === '10' || file.status === '14') {
//             if (file.fpath.indexOf('/Initial') !== -1) {
//               fullPathAll = `${file.fpath.split('/Initial')[0]}/Final_Scan/${file.fname}`;
//             } else {
//               fullPathAll = `${file.fpath}/Final_Scan/${file.fname}`;
//             }
//           } else {
//             fullPathAll = `${file.fpath.split('/Initial')[0]}/Initial_Scan/${file.fname}`;
//           }
    
//           const encodedFullPathAll = encodeURIComponent(fullPathAll);
//           console.log(encodedFullPathAll, 'encodedFullPathAllencodedFullPathAll');
//           await axios(`${getState().environment.API_URL}getDownloadUrl?fullPath=${encodedFullPathAll}`, {
//             method: 'GET',
//             headers: {
//               'Access-Control-Allow-Origin': '*',
//               'Content-Type': 'application/json',
//               sessionid: getState().user.userDetails.s || ''
//             }
//           }).then(response => {
//             console.log(response, 'response test');
//             console.log(statusUpdate, 'statusUpdate test');
//             if (statusUpdate && newArrayOrderno.length > 0) {
//               downloadStatusUpdate(newArrayOrderno, '1', dispatch, getState);
//             }
//             getCompleteOrderData(dispatch, getState);
//             window.open(response.data.signedUrl);
            
//           }).catch(error => {
//             const errorFileUploadedOpen = true;
//             const errorfilemsg = 'Something went wrong!';
//             dispatch({ type: STORE_ERROR_FILES_UPLOADED, errorFileUploadedOpen } as AnyAction);
//             dispatch({ type: STORE_ERROR_FILES_UPLOADED_MSG, errorfilemsg } as AnyAction);
//           });
//         }
        
//         isDownloading = false;
//         dispatch({ type: STORE_PROGRESS_DOWNLOADING, isDownloading } as AnyAction);
//       } else {
//         axios(`${getState().environment.API_URL}downloadMultifile`, {
//           method: 'POST',
//           headers: {
//             'Access-Control-Allow-Origin': '*',
//             'Content-Type': 'application/json',
//           },
//           data: newArray
//         }).then(response => {
//           isDownloading = false;
//           dispatch({ type: STORE_PROGRESS_DOWNLOADING, isDownloading } as AnyAction);
//           if (statusUpdate && newArrayOrderno.length > 0) {
//             downloadStatusUpdate(newArrayOrderno, '1', dispatch, getState);
//           }
//           getCompleteOrderData(dispatch, getState);
//           window.open(response.data.signedUrl);
//           console.log(response, 'response2222');

//         }).catch(error => {
//           const errorFileUploadedOpen = true;
//           const errorfilemsg = 'Something went wrong!';
//           dispatch({ type: STORE_ERROR_FILES_UPLOADED, errorFileUploadedOpen } as AnyAction);
//           dispatch({ type: STORE_ERROR_FILES_UPLOADED_MSG, errorfilemsg } as AnyAction);
//           isDownloading = false;
//           dispatch({ type: STORE_PROGRESS_DOWNLOADING, isDownloading } as AnyAction);
//         });
//       }
//     } else {
        
//       if (allData && allData[0]) {

//         if (allData[0].status === '10' || allData[0].status === '14') {

//           const orderArr = {
//             orderno: allData[0].orderno
//           };

//           newArrayOrderno.push(orderArr);

//           if (allData[0].fpath.indexOf('/Initial') !== -1) {
//             fullPathAll = `${allData[0].fpath.split('/Initial')[0]}/Final_Scan/${allData[0].fname}`;
//           } else {
//             fullPathAll = `${allData[0].fpath}/Final_Scan/${allData[0].fname}`;
//           }
//         } else {
//           fullPathAll = `${allData[0].fpath.split('/Initial')[0]}/Initial_Scan/${allData[0].fname}`;
//         }

//         const encodedFullPathAll = encodeURIComponent(fullPathAll);
//         console.log(encodedFullPathAll, 'encodedFullPathAll');
        
//         // console.log(allData[0].filetag, 'allData[0]filetag');
        
//         // const apiUrl =  allData[0].filetag === 'W' ? 'getDownloadUrl' : 'getODownloadUrl';
//         const apiUrl = 
//         allData[0].filetag === 'W' ? 'getDownloadUrl' :
//         allData[0].filetag === 'O' ? 'getODownloadUrl' :
//         'getDownloadUrlLocal';
//         axios(`${getState().environment.API_URL}${apiUrl}?fullPath=${encodedFullPathAll}`, {
//         // axios(`${getState().environment.API_URL}getODownloadUrl?fullPath=${encodedFullPathAll}`, {
//           method: 'GET',
//           headers: {
//             'Access-Control-Allow-Origin': '*',
//             'Content-Type': 'application/json',
//             sessionid: getState().user.userDetails.s || ''
//           }
//         }).then(response => {
//           if (statusUpdate && newArrayOrderno.length > 0) {
//             downloadStatusUpdate(newArrayOrderno, '1', dispatch, getState);
//           }
//           getCompleteOrderData(dispatch, getState);
//           console.log(response, 'response33333');
//           window.open(response.data.signedUrl);

//         }).catch(error => {
//           const errorFileUploadedOpen = true;
//           const errorfilemsg = 'Something went wrong!';
//           dispatch({ type: STORE_ERROR_FILES_UPLOADED, errorFileUploadedOpen } as AnyAction);
//           dispatch({ type: STORE_ERROR_FILES_UPLOADED_MSG, errorfilemsg } as AnyAction);
//           // ==> console.error(error);
//         });
//       }
//     }
//     return true;
//   };
// };

// This code is correctly working. Need to control the open in Tab 13.03.25
// export const onbulkDownload = (allData: RowDataCompleted[] | RowDataCompleted, statusUpdate: boolean) => {
//   console.log(allData, 'onbulkDownloadonbulkDownload'); 
//   return async (dispatch: Dispatch<AppState>, getState: () => AppState) => {

//     // const allData = getState().completeOrder.completeOrderData;

//     const newArray: Array<object> = [];
//     const newArrayOrderno: Array<object> = [];
//     let fullPathAll;
//     let isDownloading = false;
    
//     if (Array.isArray(allData) && allData.length > 1) {
//       isDownloading = true;
//       dispatch({ type: STORE_PROGRESS_DOWNLOADING, isDownloading } as AnyAction);
//       console.log(allData, '000000000000'); 
//       allData.map((arr) => {
//         console.log(arr, 'arrarrarr');
//         if (arr.status === '10' || arr.status === '14') {
//           if (arr.fpath.indexOf('/Initial') !== -1) {
//             fullPathAll = `${arr.fpath.split('/Initial')[0]}/Final_Scan/${arr.fname}`;
//             console.log(fullPathAll, '1111111111');
//           } else {
//             fullPathAll = `${arr.fpath}/Final_Scan/${arr.fname}`;
//             console.log(fullPathAll, '2222222222');
//           }
    
//           const orderArr = {
//             orderno: arr.orderno
//           };
//           console.log(orderArr, 'orderArrorderArr');
//           newArrayOrderno.push(orderArr);
//           console.log(newArrayOrderno, 'newArrayOrderno');  
//         } else {
//           fullPathAll = `${arr.fpath.split('/Initial')[0]}/Initial_Scan/${arr.fname}`;
//           console.log(fullPathAll, '3333333333'); 
//         }
    
//         const fileValue = {
//           name: arr.fname,
//           key: `${fullPathAll}`
//         };
//         console.log(fileValue, 'fileValue'); 
//         newArray.push(fileValue);
//         console.log(newArray, 'newArray');
//       });
    
//       if (allData[0].filetag === 'W') {
//         for (const file of allData) {
//           if (file.status === '10' || file.status === '14') {
//             if (file.fpath.indexOf('/Initial') !== -1) {
//               fullPathAll = `${file.fpath.split('/Initial')[0]}/Final_Scan/${file.fname}`;
//             } else {
//               fullPathAll = `${file.fpath}/Final_Scan/${file.fname}`;
//             }
//           } else {
//             fullPathAll = `${file.fpath.split('/Initial')[0]}/Initial_Scan/${file.fname}`;
//           }
    
//           const encodedFullPathAll = encodeURIComponent(fullPathAll);
//           console.log(encodedFullPathAll, 'encodedFullPathAllencodedFullPathAll');
//           await axios(`${getState().environment.API_URL}getDownloadUrl?fullPath=${encodedFullPathAll}`, {
//             method: 'GET',
//             headers: {
//               'Access-Control-Allow-Origin': '*',
//               'Content-Type': 'application/json',
//               sessionid: getState().user.userDetails.s || ''
//             }
//           }).then(response => {
//             console.log(response, 'response test');
//             console.log(statusUpdate, 'statusUpdate test');
//             if (statusUpdate && newArrayOrderno.length > 0) {
//               downloadStatusUpdate(newArrayOrderno, '1', dispatch, getState);
//             }
//             getCompleteOrderData(dispatch, getState);
//             window.open(response.data.signedUrl);
                        
//           }).catch(error => {
//             const errorFileUploadedOpen = true;
//             const errorfilemsg = 'Something went wrong!';
//             dispatch({ type: STORE_ERROR_FILES_UPLOADED, errorFileUploadedOpen } as AnyAction);
//             dispatch({ type: STORE_ERROR_FILES_UPLOADED_MSG, errorfilemsg } as AnyAction);
//           });
//         }
        
//         isDownloading = false;
//         dispatch({ type: STORE_PROGRESS_DOWNLOADING, isDownloading } as AnyAction);
//       } else if (allData[0].filetag === 'O') {
//         // Handle 'O' filetag for multiple files
//         for (const file of allData) {
//           if (file.status === '10' || file.status === '14') {
//             if (file.fpath.indexOf('/Initial') !== -1) {
//               fullPathAll = `${file.fpath.split('/Initial')[0]}/Final_Scan/${file.fname}`;
//             } else {
//               fullPathAll = `${file.fpath}/Final_Scan/${file.fname}`;
//             }
//           } else {
//             fullPathAll = `${file.fpath.split('/Initial')[0]}/Initial_Scan/${file.fname}`;
//           }
    
//           const encodedFullPathAll = encodeURIComponent(fullPathAll);
//           console.log(encodedFullPathAll, 'encodedFullPathAll O tag');
//           await axios(`${getState().environment.API_URL}getODownloadUrl?fullPath=${encodedFullPathAll}`, {
//             method: 'GET',
//             headers: {
//               'Access-Control-Allow-Origin': '*',
//               'Content-Type': 'application/json',
//               sessionid: getState().user.userDetails.s || ''
//             }
//           }).then(response => {
//             console.log(response, 'response O test');
//             if (statusUpdate && newArrayOrderno.length > 0) {
//               downloadStatusUpdate(newArrayOrderno, '1', dispatch, getState);
//             }
//             getCompleteOrderData(dispatch, getState);
//             window.open(response.data.signedUrl);
                        
//           }).catch(error => {
//             const errorFileUploadedOpen = true;
//             const errorfilemsg = 'Something went wrong!';
//             dispatch({ type: STORE_ERROR_FILES_UPLOADED, errorFileUploadedOpen } as AnyAction);
//             dispatch({ type: STORE_ERROR_FILES_UPLOADED_MSG, errorfilemsg } as AnyAction);
//           });
//         }
        
//         isDownloading = false;
//         dispatch({ type: STORE_PROGRESS_DOWNLOADING, isDownloading } as AnyAction);
//       } else {
//         // Handle default case (neither 'W' nor 'O')
//         for (const file of allData) {
//           if (file.status === '10' || file.status === '14') {
//             if (file.fpath.indexOf('/Initial') !== -1) {
//               fullPathAll = `${file.fpath.split('/Initial')[0]}/Final_Scan/${file.fname}`;
//             } else {
//               fullPathAll = `${file.fpath}/Final_Scan/${file.fname}`;
//             }
//           } else {
//             fullPathAll = `${file.fpath.split('/Initial')[0]}/Initial_Scan/${file.fname}`;
//           }
    
//           const encodedFullPathAll = encodeURIComponent(fullPathAll);
//           console.log(encodedFullPathAll, 'encodedFullPathAll default');
//           await axios(`${getState().environment.API_URL}getDownloadUrlLocal?fullPath=${encodedFullPathAll}`, {
//             method: 'GET',
//             headers: {
//               'Access-Control-Allow-Origin': '*',
//               'Content-Type': 'application/json',
//               sessionid: getState().user.userDetails.s || ''
//             }
//           }).then(response => {
//             console.log(response, 'response default test');
//             if (statusUpdate && newArrayOrderno.length > 0) {
//               downloadStatusUpdate(newArrayOrderno, '1', dispatch, getState);
//             }
//             getCompleteOrderData(dispatch, getState);
//             window.open(response.data.signedUrl);
                        
//           }).catch(error => {
//             const errorFileUploadedOpen = true;
//             const errorfilemsg = 'Something went wrong!';
//             dispatch({ type: STORE_ERROR_FILES_UPLOADED, errorFileUploadedOpen } as AnyAction);
//             dispatch({ type: STORE_ERROR_FILES_UPLOADED_MSG, errorfilemsg } as AnyAction);
//           });
//         }
        
//         isDownloading = false;
//         dispatch({ type: STORE_PROGRESS_DOWNLOADING, isDownloading } as AnyAction);
//       }
//     } else {
        
//       if (allData && allData[0]) {

//         if (allData[0].status === '10' || allData[0].status === '14') {

//           const orderArr = {
//             orderno: allData[0].orderno
//           };

//           newArrayOrderno.push(orderArr);

//           if (allData[0].fpath.indexOf('/Initial') !== -1) {
//             fullPathAll = `${allData[0].fpath.split('/Initial')[0]}/Final_Scan/${allData[0].fname}`;
//           } else {
//             fullPathAll = `${allData[0].fpath}/Final_Scan/${allData[0].fname}`;
//           }
//         } else {
//           fullPathAll = `${allData[0].fpath.split('/Initial')[0]}/Initial_Scan/${allData[0].fname}`;
//         }

//         const encodedFullPathAll = encodeURIComponent(fullPathAll);
//         console.log(encodedFullPathAll, 'encodedFullPathAll');
        
//         // console.log(allData[0].filetag, 'allData[0]filetag');
        
//         // const apiUrl =  allData[0].filetag === 'W' ? 'getDownloadUrl' : 'getODownloadUrl';
//         const apiUrl = 
//         allData[0].filetag === 'W' ? 'getDownloadUrl' :
//         allData[0].filetag === 'O' ? 'getODownloadUrl' :
//         'getDownloadUrlLocal';
//         axios(`${getState().environment.API_URL}${apiUrl}?fullPath=${encodedFullPathAll}`, {
//         // axios(`${getState().environment.API_URL}getODownloadUrl?fullPath=${encodedFullPathAll}`, {
//           method: 'GET',
//           headers: {
//             'Access-Control-Allow-Origin': '*',
//             'Content-Type': 'application/json',
//             sessionid: getState().user.userDetails.s || ''
//           }
//         }).then(response => {
//           if (statusUpdate && newArrayOrderno.length > 0) {
//             downloadStatusUpdate(newArrayOrderno, '1', dispatch, getState);
//           }
//           getCompleteOrderData(dispatch, getState);
//           console.log(response, 'response33333');
//           window.open(response.data.signedUrl);
          
//         }).catch(error => {
//           const errorFileUploadedOpen = true;
//           const errorfilemsg = 'Something went wrong!';
//           dispatch({ type: STORE_ERROR_FILES_UPLOADED, errorFileUploadedOpen } as AnyAction);
//           dispatch({ type: STORE_ERROR_FILES_UPLOADED_MSG, errorfilemsg } as AnyAction);
//           // ==> console.error(error);
//         });
//       }
//     }
//     return true;
//   };
// };
// export const onBulkDownloadIndividual = (allData: RowDataCompleted[] | RowDataCompleted, statusUpdate: boolean) => {
//   console.log(allData, '80000');
//   return async (dispatch: Dispatch<AppState>, getState: () => AppState) => {

//     const newArray: Array<object> = [];
//     const newArrayOrderno: Array<object> = [];
//     let fullPathAll;

//     if (Array.isArray(allData) && allData.length > 1) {
//       console.log(Array.isArray(allData), 'aaaaaaaaaaaaaa');
//       dispatch({ type: STORE_PROGRESS_DOWNLOADING, isDownloading: true } as AnyAction);

//       for (const arr of allData) {
//         console.log(arr, 'bbbbbbbbb');
//         let fileValue = {
//           name: '',
//           key: ''
//         };

//         if (arr.status === '10') {
//           console.log('Processing status 10:', arr); // Logs only for status 10
//         }

//         if (arr.status === '14') {
//           console.log('Processing status 14:', arr); // Logs only for status 14
//         }

//         let orderArr = {
//           orderno: ''
//         };

//         if (arr.status === '10' || arr.status === '14') {
//           console.log(arr.status, 'ccccccccc'); 
//           if (arr.fpath.indexOf('/Initial') !== -1) {
//             fullPathAll = `${arr.fpath.split('/Initial')[0]}/Final_Scan/${arr.fname}`;
//             console.log(fullPathAll, 'dddddddd');
            
//           } else {
//             fullPathAll = `${arr.fpath}/Final_Scan/${arr.fname}`;
//             console.log(fullPathAll, 'eeeeeeee');
//           }

//           fileValue = {
//             name: arr.fname,
//             key: `${fullPathAll}`
//           };
//           console.log(fileValue, 'ffffffffff');
//           orderArr = {
//             orderno: arr.orderno
//           };
//           console.log(orderArr, 'gggggggggg');

//         } else {
//           fullPathAll = `${arr.fpath.split('/Initial')[0]}/Initial_Scan/${arr.fname}`;
//           console.log(orderArr, 'hhhhhhhhh');
//           fileValue = {
//             name: arr.fname,
//             key: `${fullPathAll}`
//           };
//           console.log(orderArr, 'iiiiiiiiii');
//           newArray.push(fileValue);
//           console.log(newArray, 'jjjjjjjjjjj');
//         }

//         const encodedFullPathAll = encodeURIComponent(fileValue.key); 
//         console.log(encodedFullPathAll, 'encodedFullPathAll111');
        
//         // const apiUrl =  allData[0].filetag === 'W' ? 'getDownloadUrl' : 'getODownloadUrl';
//         // const apiUrl =  arr.filetag === 'W' ? 'getDownloadUrl' : 'getODownloadUrl';
//         const apiUrl = 
//         arr.filetag === 'W' ? 'getDownloadUrl' :
//         arr.filetag === 'O' ? 'getODownloadUrl' :
//         'getDownloadUrlLocal';
//         axios(`${getState().environment.API_URL}${apiUrl}?fullPath=${encodedFullPathAll}`, {
//         // await axios(`${getState().environment.API_URL}getODownloadUrl?fullPath=${encodedFullPathAll}`, {
//           method: 'GET',
//           headers: {
//             'Access-Control-Allow-Origin': '*',
//             'Content-Type': 'application/json',
//             sessionid: getState().user.userDetails.s || ''
//           }
//         }).then(response => {
//           console.log(response, 'response response response');
          
//           if (statusUpdate && orderArr.orderno) {
//             downloadStatusUpdate([orderArr], '1', dispatch, getState);
            
//           }
//           window.open(response.data.signedUrl);
          
//         }).catch(error => {

//           const errorFileUploadedOpen = true;
//           const errorfilemsg = 'Something went wrong!';
//           dispatch({ type: STORE_ERROR_FILES_UPLOADED, errorFileUploadedOpen } as AnyAction);
//           dispatch({ type: STORE_ERROR_FILES_UPLOADED_MSG, errorfilemsg } as AnyAction);

//         });

//       }

//       dispatch({ type: STORE_PROGRESS_DOWNLOADING, isDownloading: false } as AnyAction);
//       getCompleteOrderData(dispatch, getState);

//     } else {

//       if (allData && allData[0]) {

//         if (allData[0].status === '10' || allData[0].status === '14') {

//           const orderArr = {
//             orderno: allData[0].orderno
//           };

//           newArrayOrderno.push(orderArr);

//           if (allData[0].fpath.indexOf('/Initial') !== -1) {
//             fullPathAll = `${allData[0].fpath.split('/Initial')[0]}/Final_Scan/${allData[0].fname}`;
//           } else {
//             fullPathAll = `${allData[0].fpath}/Final_Scan/${allData[0].fname}`;
//           }
//         } else {
//           fullPathAll = `${allData[0].fpath.split('/Initial')[0]}/Initial_Scan/${allData[0].fname}`;
//         }

//         const encodedFullPathAll = encodeURIComponent(fullPathAll);
//         console.log(encodedFullPathAll, 'encodedFullPathAll3333');
        
//         // const apiUrl =  allData[0].filetag === 'W' ? 'getDownloadUrl' : 'getODownloadUrl';
//         const apiUrl = 
//         allData[0].filetag === 'W' ? 'getDownloadUrl' :
//         allData[0].filetag === 'O' ? 'getODownloadUrl' :
//         'getDownloadUrlLocal';
//         axios(`${getState().environment.API_URL}${apiUrl}?fullPath=${encodedFullPathAll}`, {
//         // axios(`${getState().environment.API_URL}getODownloadUrl?fullPath=${encodedFullPathAll}`, {
//           method: 'GET',
//           headers: {
//             'Access-Control-Allow-Origin': '*',
//             'Content-Type': 'application/json',
//             sessionid: getState().user.userDetails.s || ''
//           }
//         }).then(response => {
//           if (statusUpdate && newArrayOrderno.length > 0) {
//             downloadStatusUpdate(newArrayOrderno, '1', dispatch, getState);
//           }
//           getCompleteOrderData(dispatch, getState);
//           console.log(response, 'response2222');
//           window.open(response.data.signedUrl);
//         }).catch(error => {
//           const errorFileUploadedOpen = true;
//           const errorfilemsg = 'Something went wrong!';
//           dispatch({ type: STORE_ERROR_FILES_UPLOADED, errorFileUploadedOpen } as AnyAction);
//           dispatch({ type: STORE_ERROR_FILES_UPLOADED_MSG, errorfilemsg } as AnyAction);
//           // ==> console.error(error);
//         });
//       }
//     }
//     return true;
//   };
// };

// const showErrorWithFailedFiles = (
//   failedFiles: Array<string | { caseno?: string; orderno?: string; name?: string; fname?: string }>,
//   dispatch: Dispatch<AppState>
// ) => {
//   const errorFileUploadedOpen = true;
//   let errorfilemsg = 'Something went wrong!';
//   console.log(failedFiles, 'failedFiles');
  
//   if (failedFiles && failedFiles.length > 0) {
//     const failedFilesList = failedFiles
//       .map(file => typeof file === 'string' ? file : `${file.caseno || ''}${file.orderno ? file.orderno : ''}_${file.name || file.fname || ''}`)
//       .filter(name => name.trim() !== '_')
//       .join(', ');
//     console.log(failedFilesList, 'failedFilesList');
//     errorfilemsg = `The following files could not be downloaded: ${failedFilesList}`;
//   }
  
//   dispatch({ type: STORE_ERROR_FILES_UPLOADED, errorFileUploadedOpen } as AnyAction);
//   dispatch({ type: STORE_ERROR_FILES_UPLOADED_MSG, errorfilemsg } as AnyAction);
  
//   // Hide the error message automatically after 25 seconds
//   setTimeout(
//     () => {
//       dispatch({ type: STORE_ERROR_FILES_UPLOADED, errorFileUploadedOpen: false } as AnyAction);
//     }, 
//     25000
//   );
// };

// comment 21.03.2025
// const showErrorWithFailedFiles = (
//   failedFiles: Array<{fname: string, orderno: string}>,
//   dispatch: Dispatch<AppState>
// ) => {
//   let errorfilemsg = 'Something went wrong!';
  
//   if (failedFiles && failedFiles.length > 0) {
//     const failedFilesList = failedFiles
//       .map(file => `${file.orderno || ''}_${file.fname || ''}`)
//       .filter(name => name.trim() !== '_')
//       .join(', ');
    
//     errorfilemsg = `The following files could not be downloaded: ${failedFilesList}`;
//   }
  
//   dispatch({ type: STORE_FAILED_FILES, failedFiles } as AnyAction);
//   // dispatch({ type: STORE_FAILED_FILES_MESSAGE, failedFilesMessage: errorfilemsg } as AnyAction);
//   dispatch({ type: SHOW_FAILED_FILES_DIALOG, showFailedFilesDialog: true } as AnyAction);
  
//  // dispatch({ type: STORE_ERROR_FILES_UPLOADED, errorFileUploadedOpen: true } as AnyAction);
//   dispatch({ type: STORE_ERROR_FILES_UPLOADED_MSG, errorfilemsg } as AnyAction);
  
//   // setTimeout(
//   //   () => {
//   //     dispatch({ type: STORE_ERROR_FILES_UPLOADED, errorFileUploadedOpen: false } as AnyAction);
//   //   }, 
//   //   25000
//   // );
// };
const showErrorWithFailedFiles = (
  failedFiles: Array<{fname: string, orderno: string, reason?: string}>,
  dispatch: Dispatch<AppState>
) => {
  let errorfilemsg = 'Something went wrong!';
  
  if (failedFiles && failedFiles.length > 0) {
    const failedFilesList = failedFiles
      .map(file => `${file.orderno || ''}_${file.fname || ''}`)
      .filter(name => name.trim() !== '_')
      .join(', ');
    
    errorfilemsg = `The following files could not be downloaded: ${failedFilesList}`;
    
    // Add more specific error information if available
    if (failedFiles.some(file => file.reason)) {
      errorfilemsg += `. Reason: ${failedFiles[0].reason || 'Unknown error'}`;
    }
  }
  dispatch({ type: STORE_FAILED_FILES, failedFiles } as AnyAction);
  dispatch({ type: SHOW_FAILED_FILES_DIALOG, showFailedFilesDialog: true } as AnyAction);
  dispatch({ type: STORE_ERROR_FILES_UPLOADED_MSG, errorfilemsg } as AnyAction);
};
// update code comment for 03.04.2025 // 10:12 AM // 09.04.2025 / 11.04.2025 // working fine
// export const onbulkDownload = (allData: RowDataCompleted[] | RowDataCompleted, statusUpdate: boolean) => {
//   return async (dispatch: Dispatch<AppState>, getState: () => AppState) => {

//     const newArray: Array<object> = [];
//     const newArrayOrderno: Array<object> = [];
//     let fullPathAll;
//     let isDownloading = false;
//     const failedFiles: Array<{fname: string, orderno: string}> = [];
    
//     if (Array.isArray(allData) && allData.length > 1) {
//       isDownloading = true;
//       dispatch({ type: STORE_PROGRESS_DOWNLOADING, isDownloading } as AnyAction);
//       allData.map((arr) => {
//         if (arr.status === '10' || arr.status === '14') {
//           if (arr.fpath.indexOf('/Initial') !== -1) {
//             fullPathAll = `${arr.fpath.split('/Initial')[0]}/Final_Scan/${arr.fname}`;
//           } else {
//             fullPathAll = `${arr.fpath}/Final_Scan/${arr.fname}`;
//           }
    
//           const orderArr = {
//             orderno: arr.orderno
//           };
//           newArrayOrderno.push(orderArr);
//         } else {
//           fullPathAll = `${arr.fpath.split('/Initial')[0]}/Initial_Scan/${arr.fname}`;
//         }
    
//         const fileValue = {
//           name: arr.fname,
//           key: `${fullPathAll}`
//         };
//         newArray.push(fileValue);
//       });
    
//       if (allData[0].filetag === 'W') {
//         for (const file of allData) {
//           if (file.status === '10' || file.status === '14') {
//             if (file.fpath.indexOf('/Initial') !== -1) {
//               fullPathAll = `${file.fpath.split('/Initial')[0]}/Final_Scan/${file.fname}`;
//             } else {
//               fullPathAll = `${file.fpath}/Final_Scan/${file.fname}`;
//             }
//           } else {
//             fullPathAll = `${file.fpath.split('/Initial')[0]}/Initial_Scan/${file.fname}`;
//           }
    
//           const encodedFullPathAll = encodeURIComponent(fullPathAll);
//           try {
//             const response = await axios(`${getState().environment.API_URL}getDownloadUrl?fullPath=${encodedFullPathAll}`, {
//               method: 'GET',
//               headers: {
//                 'Access-Control-Allow-Origin': '*',
//                 'Content-Type': 'application/json',
//                 sessionid: getState().user.userDetails.s || ''
//               }
//             });
            
//             if (statusUpdate && newArrayOrderno.length > 0) {
//               downloadStatusUpdate(newArrayOrderno, '1', dispatch, getState);
//             }
//             getCompleteOrderData(dispatch, getState);
//             window.open(response.data.signedUrl);
//           } catch (error) {
//             failedFiles.push({
//               fname: file.fname,
//               orderno: file.orderno
//             });
//           }
//         }
        
//         isDownloading = false;
//         dispatch({ type: STORE_PROGRESS_DOWNLOADING, isDownloading } as AnyAction);
        
//         // Show any failed files
//         if (failedFiles.length > 0) {
//           showErrorWithFailedFiles(failedFiles, dispatch);
//         }
//       } else if (allData[0].filetag === 'O') {
//         // Handle 'O' filetag for multiple files
//         for (const file of allData) {
//           if (file.status === '10' || file.status === '14') {
//             if (file.fpath.indexOf('/Initial') !== -1) {
//               fullPathAll = `${file.fpath.split('/Initial')[0]}/Final_Scan/${file.fname}`;
//             } else {
//               fullPathAll = `${file.fpath}/Final_Scan/${file.fname}`;
//             }
//           } else {
//             fullPathAll = `${file.fpath.split('/Initial')[0]}/Initial_Scan/${file.fname}`;
//           }
    
//           const encodedFullPathAll = encodeURIComponent(fullPathAll);
//           try {
//             const response = await axios(`${getState().environment.API_URL}getODownloadUrl?fullPath=${encodedFullPathAll}`, {
//               method: 'GET',
//               headers: {
//                 'Access-Control-Allow-Origin': '*',
//                 'Content-Type': 'application/json',
//                 sessionid: getState().user.userDetails.s || ''
//               }
//             });
            
//             if (statusUpdate && newArrayOrderno.length > 0) {
//               downloadStatusUpdate(newArrayOrderno, '1', dispatch, getState);
//             }
//             getCompleteOrderData(dispatch, getState);
//             window.open(response.data.signedUrl);
//           } catch (error) {
            
//             failedFiles.push({
//               fname: file.fname,
//               orderno: file.orderno
//             });
//           }
//         }
        
//         isDownloading = false;
//         dispatch({ type: STORE_PROGRESS_DOWNLOADING, isDownloading } as AnyAction);
        
//         // Show any failed files
//         if (failedFiles.length > 0) {
//           showErrorWithFailedFiles(failedFiles, dispatch);
//         }
//       } else if (allData[0].filetag === 'OW') {
//         // Handle 'O' filetag for multiple files
//         for (const file of allData) {
//           if (file.status === '10' || file.status === '14') {
//             if (file.fpath.indexOf('/Initial') !== -1) {
//               fullPathAll = `${file.fpath.split('/Initial')[0]}/Final_Scan/${file.fname}`;
//             } else {
//               fullPathAll = `${file.fpath}/Final_Scan/${file.fname}`;
//             }
//           } else {
//             fullPathAll = `${file.fpath.split('/Initial')[0]}/Initial_Scan/${file.fname}`;
//           }
    
//           const encodedFullPathAll = encodeURIComponent(fullPathAll);
//           try {
//             const response = await axios(`${getState().environment.API_URL}commonBucketFileCheck?fullPath=${encodedFullPathAll}`, {
//               method: 'GET',
//               headers: {
//                 'Access-Control-Allow-Origin': '*',
//                 'Content-Type': 'application/json',
//                 sessionid: getState().user.userDetails.s || ''
//               }
//             });
            
//             if (statusUpdate && newArrayOrderno.length > 0) {
//               downloadStatusUpdate(newArrayOrderno, '1', dispatch, getState);
//             }
//             getCompleteOrderData(dispatch, getState);
//             window.open(response.data.signedUrl);
//           } catch (error) {
            
//             failedFiles.push({
//               fname: file.fname,
//               orderno: file.orderno
//             });
//           }
//         }
        
//         isDownloading = false;
//         dispatch({ type: STORE_PROGRESS_DOWNLOADING, isDownloading } as AnyAction);
        
//         // Show any failed files
//         if (failedFiles.length > 0) {
//           showErrorWithFailedFiles(failedFiles, dispatch);
//         }
//       } else {
//         // Handle default case (neither 'W' nor 'O')
//         for (const file of allData) {
//           if (file.status === '10' || file.status === '14') {
//             if (file.fpath.indexOf('/Initial') !== -1) {
//               fullPathAll = `${file.fpath.split('/Initial')[0]}/Final_Scan/${file.fname}`;
//             } else {
//               fullPathAll = `${file.fpath}/Final_Scan/${file.fname}`;
//             }
//           } else {
//             fullPathAll = `${file.fpath.split('/Initial')[0]}/Initial_Scan/${file.fname}`;
//           }
    
//           const encodedFullPathAll = encodeURIComponent(fullPathAll);
//           try {
//             const response = await axios(`${getState().environment.API_URL}getDownloadUrlLocal?fullPath=${encodedFullPathAll}`, {
//               method: 'GET',
//               headers: {
//                 'Access-Control-Allow-Origin': '*',
//                 'Content-Type': 'application/json',
//                 sessionid: getState().user.userDetails.s || ''
//               }
//             });
            
//             if (statusUpdate && newArrayOrderno.length > 0) {
//               downloadStatusUpdate(newArrayOrderno, '1', dispatch, getState);
//             }
//             getCompleteOrderData(dispatch, getState);
//             window.open(response.data.signedUrl);
//           } catch (error) {
            
//             failedFiles.push({
//               fname: file.fname,
//               orderno: file.orderno
//             });
//           }
//         }
        
//         isDownloading = false;
//         dispatch({ type: STORE_PROGRESS_DOWNLOADING, isDownloading } as AnyAction);
        
//         // Show any failed files
//         if (failedFiles.length > 0) {
//           showErrorWithFailedFiles(failedFiles, dispatch);
//         }
//       }
//     } else {
//       // Single file download  
//       if (allData && allData[0]) {
//         // Removed the shadowed failedFiles declaration
        
//         if (allData[0].status === '10' || allData[0].status === '14') {
//           const orderArr = {
//             orderno: allData[0].orderno
//           };

//           newArrayOrderno.push(orderArr);

//           if (allData[0].fpath.indexOf('/Initial') !== -1) {
//             fullPathAll = `${allData[0].fpath.split('/Initial')[0]}/Final_Scan/${allData[0].fname}`;
//           } else {
//             fullPathAll = `${allData[0].fpath}/Final_Scan/${allData[0].fname}`;
//           }
//         } else {
//           fullPathAll = `${allData[0].fpath.split('/Initial')[0]}/Initial_Scan/${allData[0].fname}`;
//         }

//         const encodedFullPathAll = encodeURIComponent(fullPathAll);
        
//         const apiUrl = 
//         allData[0].filetag === 'W' ? 'getDownloadUrl' :
//         allData[0].filetag === 'O' ? 'getODownloadUrl' :
//         allData[0].filetag === 'OW' ? 'commonBucketFileCheck' :
//         'getDownloadUrlLocal';
        
//         try {
//           const response = await axios(`${getState().environment.API_URL}${apiUrl}?fullPath=${encodedFullPathAll}`, {
//             method: 'GET',
//             headers: {
//               'Access-Control-Allow-Origin': '*',
//               'Content-Type': 'application/json',
//               sessionid: getState().user.userDetails.s || ''
//             }
//           });
          
//           if (statusUpdate && newArrayOrderno.length > 0) {
//             downloadStatusUpdate(newArrayOrderno, '1', dispatch, getState);
//           }
//           getCompleteOrderData(dispatch, getState);
//           window.open(response.data.signedUrl);
//         } catch (error) {
          
//           failedFiles.push({
//             fname: allData[0].fname,
//             orderno: allData[0].orderno
//           });
          
//           // Show any failed files
//           if (failedFiles.length > 0) {
//             showErrorWithFailedFiles(failedFiles, dispatch);
//           } else {
//             // const errorFileUploadedOpen = true;
//             const errorfilemsg = 'Something went wrong!';
//             // dispatch({ type: STORE_ERROR_FILES_UPLOADED, errorFileUploadedOpen } as AnyAction);
//             dispatch({ type: STORE_ERROR_FILES_UPLOADED_MSG, errorfilemsg } as AnyAction);
//           }
//         }
//       }
//     }
//     return true;
//   };
// };

// comment 29-04-2025--09.37 PM
// export const onbulkDownload = (allData: RowDataCompleted[] | RowDataCompleted, statusUpdate: boolean) => {
//   return async (dispatch: Dispatch<AppState>, getState: () => AppState) => {

//     const newArray: Array<object> = [];
//     const newArrayOrderno: Array<object> = [];
//     let fullPathAll;
//     let isDownloading = false;
//     const failedFiles: Array<{fname: string, orderno: string}> = [];
    
//     if (Array.isArray(allData) && allData.length > 1) {
//       isDownloading = true;
//       dispatch({ type: STORE_PROGRESS_DOWNLOADING, isDownloading } as AnyAction);
//       allData.map((arr) => {
//         if (arr.status === '10' || arr.status === '14') {
//           if (arr.fpath.indexOf('/Initial') !== -1) {
//             fullPathAll = `${arr.fpath.split('/Initial')[0]}/Final_Scan/${arr.fname}`;
//           } else {
//             fullPathAll = `${arr.fpath}/Final_Scan/${arr.fname}`;
//           }
    
//           const orderArr = {
//             orderno: arr.orderno
//           };
//           newArrayOrderno.push(orderArr);
//         } else {
//           fullPathAll = `${arr.fpath.split('/Initial')[0]}/Initial_Scan/${arr.fname}`;
//         }
    
//         const fileValue = {
//           name: arr.fname,
//           key: `${fullPathAll}`
//         };
//         newArray.push(fileValue);
//       });
    
//       // Removing the filetag conditionals and using commonBucketFileCheck for all files
//       for (const file of allData) {
//         if (file.status === '10' || file.status === '14') {
//           if (file.fpath.indexOf('/Initial') !== -1) {
//             fullPathAll = `${file.fpath.split('/Initial')[0]}/Final_Scan/${file.fname}`;
//           } else {
//             fullPathAll = `${file.fpath}/Final_Scan/${file.fname}`;
//           }
//         } else {
//           fullPathAll = `${file.fpath.split('/Initial')[0]}/Initial_Scan/${file.fname}`;
//         }

//         const encodedFullPathAll = encodeURIComponent(fullPathAll);
//         try {
//           const response = await axios(`${getState().environment.API_URL}downloadMultifile?fullPath=${encodedFullPathAll}`, {
//             method: 'GET',
//             headers: {
//               'Access-Control-Allow-Origin': '*',
//               'Content-Type': 'application/json',
//               sessionid: getState().user.userDetails.s || ''
//             }
//           });
//           console.log(response, 'res test 1');
          
//           if (statusUpdate && newArrayOrderno.length > 0) {
//             downloadStatusUpdate(newArrayOrderno, '1', dispatch, getState);
//           }
//           getCompleteOrderData(dispatch, getState);
//           console.log(response.data, 'res test 2');
//           console.log(response.data.signedUrl, 'res test 21');
          
//           window.open(response.data.signedUrl);
//         } catch (error) {
//           failedFiles.push({
//             fname: file.fname,
//             orderno: file.orderno
//           });
//         }
//       }
      
//       isDownloading = false;
//       dispatch({ type: STORE_PROGRESS_DOWNLOADING, isDownloading } as AnyAction);
      
//       // Show any failed files
//       if (failedFiles.length > 0) {
//         showErrorWithFailedFiles(failedFiles, dispatch);
//       } else {
//         alert('All files downloaded');
//       }
//     } else {
//       // Single file download  
//       if (allData && allData[0]) {
//         if (allData[0].status === '10' || allData[0].status === '14') {
//           const orderArr = {
//             orderno: allData[0].orderno
//           };

//           newArrayOrderno.push(orderArr);

//           if (allData[0].fpath.indexOf('/Initial') !== -1) {
//             fullPathAll = `${allData[0].fpath.split('/Initial')[0]}/Final_Scan/${allData[0].fname}`;
//           } else {
//             fullPathAll = `${allData[0].fpath}/Final_Scan/${allData[0].fname}`;
//           }
//         } else {
//           fullPathAll = `${allData[0].fpath.split('/Initial')[0]}/Initial_Scan/${allData[0].fname}`;
//         }

//         const encodedFullPathAll = encodeURIComponent(fullPathAll);
        
//         // Use commonBucketFileCheck for single file download too
//         const apiUrl = 'commonBucketFileCheck';
        
//         try {
//           const response = await axios(`${getState().environment.API_URL}${apiUrl}?fullPath=${encodedFullPathAll}`, {
//             method: 'GET',
//             headers: {
//               'Access-Control-Allow-Origin': '*',
//               'Content-Type': 'application/json',
//               sessionid: getState().user.userDetails.s || ''
//             }
//           });
//           console.log(response, 'res test 3');
//           if (statusUpdate && newArrayOrderno.length > 0) {
//             downloadStatusUpdate(newArrayOrderno, '1', dispatch, getState);
//           }
//           getCompleteOrderData(dispatch, getState);
//           console.log(response.data.signedUrl, 'signerUrl test'); 
//           window.open(response.data.signedUrl);
//         } catch (error) {
//           failedFiles.push({
//             fname: allData[0].fname,
//             orderno: allData[0].orderno
//           });
          
//           // Show any failed files
//           if (failedFiles.length > 0) {
//             showErrorWithFailedFiles(failedFiles, dispatch);
//           } else {
//             const errorfilemsg = 'Something went wrong!';
//             dispatch({ type: STORE_ERROR_FILES_UPLOADED_MSG, errorfilemsg } as AnyAction);
//           }
//         }
//       }
//     }
//     return true;
//   };
// };
// comment for 30.04.2025---03:33 PM
// export const onbulkDownload = (allData: RowDataCompleted[] | RowDataCompleted, statusUpdate: boolean) => {
//   console.log(allData, 'allData>>>>>>');
  
//   return async (dispatch: Dispatch<AppState>, getState: () => AppState) => {

//     // const allData = getState().completeOrder.completeOrderData;
//     const newArray: Array<object> = [];
//     const newArrayOrderno: Array<object> = [];
//     let fullPathAll;
//     let isDownloading = false;

//     if (Array.isArray(allData) && allData.length > 1) {

//       isDownloading = true;
//       dispatch({ type: STORE_PROGRESS_DOWNLOADING, isDownloading } as AnyAction);

//       allData.map((arr, index) => {
//       console.log(arr, 'rrrrrrrrrrrrrrrr');
      
//       if (arr.status === '10' || arr.status === '14') {
//           if (arr.fpath.indexOf('/Initial') !== -1) {
//             fullPathAll = `${arr.fpath.split('/Initial')[0]}/Final_Scan/${arr.fname}`;
//           } else {
//             fullPathAll = `${arr.fpath}/Final_Scan/${arr.fname}`;
//           }

//           const fileValue = {
//             name: arr.fname,
//             key: `${fullPathAll}`
//           };

//           const orderArr = {
//             orderno: arr.orderno
//           };

//           newArray.push(fileValue);
//           newArrayOrderno.push(orderArr);

//         } else {
//           fullPathAll = `${arr.fpath.split('/Initial')[0]}/Initial_Scan/${arr.fname}`;

//           const fileValue = {
//             name: arr.fname,
//             key: `${fullPathAll}`
//           };

//           newArray.push(fileValue);
//         }

//       });

//       axios(`${getState().environment.API_URL}downloadMultifile`, {
//         method: 'POST',
//         headers: {
//           'Access-Control-Allow-Origin': '*',
//           'Content-Type': 'application/json',
//         },
//         data: newArray
//       }).then(response => {
//         isDownloading = false;
//         dispatch({ type: STORE_PROGRESS_DOWNLOADING, isDownloading } as AnyAction);
//         if (statusUpdate && newArrayOrderno.length > 0) {
//           downloadStatusUpdate(newArrayOrderno, '1', dispatch, getState);
//         }
//         getCompleteOrderData(dispatch, getState);
//         console.log(response.data, 'response.data>>>>>>>');
//         console.log(response, 'jjjjjjjjjjjjj');
//         console.log(response.data.signedUrl, 'nnnnnnnnnnnnnnnn');
        
//         window.open(response.data.signedUrl);

//       }).catch(error => {

//         const errorFileUploadedOpen = true;
//         const errorfilemsg = 'Something went wrong!';
//         dispatch({ type: STORE_ERROR_FILES_UPLOADED, errorFileUploadedOpen } as AnyAction);
//         dispatch({ type: STORE_ERROR_FILES_UPLOADED_MSG, errorfilemsg } as AnyAction);

//         isDownloading = false;
//         dispatch({ type: STORE_PROGRESS_DOWNLOADING, isDownloading } as AnyAction);
//         // ==> console.error(error);
//       });

//     } else {

//       if (allData && allData[0]) {
//         console.log(allData, 'allData[][][][][][');
         
//         if (allData[0].status === '10' || allData[0].status === '14') {

//           const orderArr = {
//             orderno: allData[0].orderno
//           };

//           newArrayOrderno.push(orderArr);

//           if (allData[0].fpath.indexOf('/Initial') !== -1) {
//             fullPathAll = `${allData[0].fpath.split('/Initial')[0]}/Final_Scan/${allData[0].fname}`;
//           } else {
//             fullPathAll = `${allData[0].fpath}/Final_Scan/${allData[0].fname}`;
//           }
//         } else {
//           fullPathAll = `${allData[0].fpath.split('/Initial')[0]}/Initial_Scan/${allData[0].fname}`;
//         }

//         const encodedFullPathAll = encodeURIComponent(fullPathAll);

//         axios(`${getState().environment.API_URL}commonBucketFileCheck?fullPath=${encodedFullPathAll}`, {
//           method: 'GET',
//           headers: {
//             'Access-Control-Allow-Origin': '*',
//             'Content-Type': 'application/json',
//             sessionid: getState().user.userDetails.s || ''
//           }
//         }).then(response => {
//           if (statusUpdate && newArrayOrderno.length > 0) {
//             downloadStatusUpdate(newArrayOrderno, '1', dispatch, getState);
//           }
//           getCompleteOrderData(dispatch, getState);
//           console.log(response, 'ooooooooooooooo');
//           console.log(response.data.signedUrl, 'iiiiiiiiiiiiiiii');
//           console.log(response.data, 'response.data<<<<<<<<<<<');
          
//           window.open(response.data.signedUrl);

//         }).catch(error => {
//           const errorFileUploadedOpen = true;
//           const errorfilemsg = 'Something went wrong!';
//           dispatch({ type: STORE_ERROR_FILES_UPLOADED, errorFileUploadedOpen } as AnyAction);
//           dispatch({ type: STORE_ERROR_FILES_UPLOADED_MSG, errorfilemsg } as AnyAction);
//           // ==> console.error(error);
//         });
//       }
//     }
//     return true;
//   };
// };
// comment 01.05.2025 -- 06:28
// export const onbulkDownload = (allData: RowDataCompleted[] | RowDataCompleted, statusUpdate: boolean) => {
//   console.log(allData, 'allData>>>>>>');
  
//   return async (dispatch: Dispatch<AppState>, getState: () => AppState) => {

//     // const allData = getState().completeOrder.completeOrderData;

//     const newArray: Array<object> = [];
//     const newArrayOrderno: Array<object> = [];
//     let fullPathAll;
//     let isDownloading = false;

//     if (Array.isArray(allData) && allData.length > 1) {

//       isDownloading = true;
//       dispatch({ type: STORE_PROGRESS_DOWNLOADING, isDownloading } as AnyAction);

//       allData.map((arr, index) => {

//         if (arr.status === '10' || arr.status === '14') {
//           if (arr.fpath.indexOf('/Initial') !== -1) {
//             fullPathAll = `${arr.fpath.split('/Initial')[0]}/Final_Scan/${arr.fname}`;
//           } else {
//             fullPathAll = `${arr.fpath}/Final_Scan/${arr.fname}`;
//           }

//           const fileValue = {
//             name: arr.fname,
//             key: `${fullPathAll}`
//           };

//           const orderArr = {
//             orderno: arr.orderno
//           };

//           newArray.push(fileValue);
//           newArrayOrderno.push(orderArr);

//         } else {
//           fullPathAll = `${arr.fpath.split('/Initial')[0]}/Initial_Scan/${arr.fname}`;

//           const fileValue = {
//             name: arr.fname,
//             key: `${fullPathAll}`
//           };

//           newArray.push(fileValue);
//         }

//       });

//       axios(`${getState().environment.API_URL}downloadMultifile`, {
//         method: 'POST',
//         headers: {
//           'Access-Control-Allow-Origin': '*',
//           'Content-Type': 'application/json',
//         },
//         data: newArray
//       }).then(response => {
//         isDownloading = false;
//         dispatch({ type: STORE_PROGRESS_DOWNLOADING, isDownloading } as AnyAction);
//         if (statusUpdate && newArrayOrderno.length > 0) {
//           downloadStatusUpdate(newArrayOrderno, '1', dispatch, getState);
//         }
//         getCompleteOrderData(dispatch, getState);
//         window.open(response.data.signedUrl);

//       }).catch(error => {

//         const errorFileUploadedOpen = true;
//         const errorfilemsg = 'Something went wrong!';
//         dispatch({ type: STORE_ERROR_FILES_UPLOADED, errorFileUploadedOpen } as AnyAction);
//         dispatch({ type: STORE_ERROR_FILES_UPLOADED_MSG, errorfilemsg } as AnyAction);

//         isDownloading = false;
//         dispatch({ type: STORE_PROGRESS_DOWNLOADING, isDownloading } as AnyAction);
//         // ==> console.error(error);
//       });

//     } else {

//       if (allData && allData[0]) {

//         if (allData[0].status === '10' || allData[0].status === '14') {

//           const orderArr = {
//             orderno: allData[0].orderno
//           };

//           newArrayOrderno.push(orderArr);

//           if (allData[0].fpath.indexOf('/Initial') !== -1) {
//             fullPathAll = `${allData[0].fpath.split('/Initial')[0]}/Final_Scan/${allData[0].fname}`;
//           } else {
//             fullPathAll = `${allData[0].fpath}/Final_Scan/${allData[0].fname}`;
//           }
//         } else {
//           fullPathAll = `${allData[0].fpath.split('/Initial')[0]}/Initial_Scan/${allData[0].fname}`;
//         }

//         const encodedFullPathAll = encodeURIComponent(fullPathAll);

//         axios(`${getState().environment.API_URL}commonBucketFileCheck?fullPath=${encodedFullPathAll}`, {
//           method: 'GET',
//           headers: {
//             'Access-Control-Allow-Origin': '*',
//             'Content-Type': 'application/json',
//             sessionid: getState().user.userDetails.s || ''
//           }
//         }).then(response => {
//           if (statusUpdate && newArrayOrderno.length > 0) {
//             downloadStatusUpdate(newArrayOrderno, '1', dispatch, getState);
//           }
//           getCompleteOrderData(dispatch, getState);

//           window.open(response.data.signedUrl);

//         }).catch(error => {
//           const errorFileUploadedOpen = true;
//           const errorfilemsg = 'Something went wrong!';
//           dispatch({ type: STORE_ERROR_FILES_UPLOADED, errorFileUploadedOpen } as AnyAction);
//           dispatch({ type: STORE_ERROR_FILES_UPLOADED_MSG, errorfilemsg } as AnyAction);
//           // ==> console.error(error);
//         });
//       }
//     }
//     return true;
//   };
// };
// current working test and Live environment component 08.05.2025--06:49 PM
// export const onbulkDownload = (allData: RowDataCompleted[] | RowDataCompleted, statusUpdate: boolean) => {
//   return async (dispatch: Dispatch<AppState>, getState: () => AppState) => {
//     const newArray: Array<object> = [];
//     const newArrayOrderno: Array<object> = [];
//     const failedFiles: Array<{ fname: string; orderno: string }> = [];

//     let fullPathAll: string;
//     let isDownloading = false;

//     if (Array.isArray(allData) && allData.length > 1) {
//       isDownloading = true;
//       dispatch({ type: STORE_PROGRESS_DOWNLOADING, isDownloading } as AnyAction);

//       allData.forEach((arr) => {
//         if (arr.status === '10' || arr.status === '14') {
//           fullPathAll = arr.fpath.includes('/Initial')
//             ? `${arr.fpath.split('/Initial')[0]}/Final_Scan/${arr.fname}`
//             : `${arr.fpath}/Final_Scan/${arr.fname}`;

//           newArray.push({ name: arr.fname, key: fullPathAll });
//           newArrayOrderno.push({ orderno: arr.orderno });
//         } else {
//           fullPathAll = `${arr.fpath.split('/Initial')[0]}/Initial_Scan/${arr.fname}`;
//           newArray.push({ name: arr.fname, key: fullPathAll });
//         }
//       });
//       console.log(newArray, 'newArray Test');
      
//       try {
//         const response = await axios(`${getState().environment.API_URL}downloadMultifile`, {
//           method: 'POST',
//           headers: {
//             'Access-Control-Allow-Origin': '*',
//             'Content-Type': 'application/json',
//           },
//           data: newArray,
//         });

//         if (statusUpdate && newArrayOrderno.length > 0) {
//           downloadStatusUpdate(newArrayOrderno, '1', dispatch, getState);
//         }

//         getCompleteOrderData(dispatch, getState);
//         window.open(response.data.signedUrl);
//         if (failedFiles.length === 0) {
//           alert('All files download initiated successfully');
//         }
//       } catch (error) {
//         failedFiles.push(...allData.map(item => ({ fname: item.fname, orderno: item.orderno })));
//         showErrorWithFailedFiles(failedFiles, dispatch);
//       }

//       isDownloading = false;
//       dispatch({ type: STORE_PROGRESS_DOWNLOADING, isDownloading } as AnyAction);
//     } else {
//       // single file
//       const file = Array.isArray(allData) ? allData[0] : allData;
//       if (file) {
//         if (file.status === '10' || file.status === '14') {
//           newArrayOrderno.push({ orderno: file.orderno });

//           fullPathAll = file.fpath.includes('/Initial')
//             ? `${file.fpath.split('/Initial')[0]}/Final_Scan/${file.fname}`
//             : `${file.fpath}/Final_Scan/${file.fname}`;
//         } else {
//           fullPathAll = `${file.fpath.split('/Initial')[0]}/Initial_Scan/${file.fname}`;
//         }

//         const encodedFullPathAll = encodeURIComponent(fullPathAll);

//         try {
//           const response = await axios(`${getState().environment.API_URL}commonBucketFileCheck?fullPath=${encodedFullPathAll}`, {
//             method: 'GET',
//             headers: {
//               'Access-Control-Allow-Origin': '*',
//               'Content-Type': 'application/json',
//               sessionid: getState().user.userDetails.s || ''
//             }
//           });

//           if (statusUpdate && newArrayOrderno.length > 0) {
//             downloadStatusUpdate(newArrayOrderno, '1', dispatch, getState);
//           }

//           getCompleteOrderData(dispatch, getState);
//           window.open(response.data.signedUrl);
//           if (failedFiles.length === 0) {
//             alert('All files download initiated successfully');
//           }
//         } catch (error) {
//           failedFiles.push({ fname: file.fname, orderno: file.orderno });
//           showErrorWithFailedFiles(failedFiles, dispatch);
//         }
//       }
//     }

//     return true;
//   };
// };
// comment for 09.05.2025 // 12.05.2025 12:58 PM
export const onbulkDownload = (allData: RowDataCompleted[] | RowDataCompleted, statusUpdate: boolean) => {
  return async (dispatch: Dispatch<AppState>, getState: () => AppState) => {
    const newArray: Array<object> = [];
    const newArrayOrderno: Array<object> = [];
    const failedFiles: Array<{ fname: string; orderno: string }> = [];

    let fullPathAll: string;
    let isDownloading = false;
     
    const showErrorWithTimeout = (message: string) => {
      const errorFileUploadedOpen = true;
      dispatch({ type: STORE_ERROR_FILES_UPLOADED, errorFileUploadedOpen } as AnyAction);
      dispatch({ type: STORE_ERROR_FILES_UPLOADED_MSG, errorfilemsg: message } as AnyAction);
      // Set timeout to clear error after 25 seconds
      setTimeout(
        () => {
          dispatch({ type: STORE_ERROR_FILES_UPLOADED, errorFileUploadedOpen: false } as AnyAction);
        }, 
        25000
      );
    };

    if (Array.isArray(allData) && allData.length > 1) {
      isDownloading = true;
      dispatch({ type: STORE_PROGRESS_DOWNLOADING, isDownloading } as AnyAction);

      allData.forEach((arr) => {
        if (arr.status === '10' || arr.status === '14') {
          fullPathAll = arr.fpath.includes('/Initial')
            ? `${arr.fpath.split('/Initial')[0]}/Final_Scan/${arr.fname}`
            : `${arr.fpath}/Final_Scan/${arr.fname}`;

          newArray.push({ name: arr.fname, key: fullPathAll, userName: getState().user.userDetails.userName || '' });
          newArrayOrderno.push({ orderno: arr.orderno, userName: getState().user.userDetails.userName || '' });
        } else {
          fullPathAll = `${arr.fpath.split('/Initial')[0]}/Initial_Scan/${arr.fname}`;
          newArray.push({ name: arr.fname, key: fullPathAll, userName: getState().user.userDetails.userName || '' });
        }
      });
      // console.log(newArray, 'newArray Test');
      
      try {
        const response = await axios(`${getState().environment.API_URL}downloadAllFilesInOneZip`, {
          method: 'POST',
          headers: {
            'Access-Control-Allow-Origin': '*',
            'Content-Type': 'application/json',
          },
          data: newArray,
        });

        if (statusUpdate && newArrayOrderno.length > 0) {
          downloadStatusUpdate(newArrayOrderno, '1', dispatch, getState);
        }
       
        if (response.data.status && response.data.localFilePath) {
          const fileUrl = `${getState().environment.API_URL}${response.data.localFilePath}`;
          // console.log(fileUrl, 'fileUrlTest');
          // console.log(response.data.fileName, 'responseTest');
          const link = document.createElement('a');
          link.href = fileUrl;
          link.setAttribute('download', response.data.fileName || 'all_stl_files.zip');
          document.body.appendChild(link);
          link.click();
          link.remove();
          if (Array.isArray(response.data.failedFiles) && response.data.failedFiles.length === 0) {
            alert('All files downloaded successfully.');
          }
        } else {
          showErrorWithTimeout('Failed to get download path.');
        }
      } catch (error) {
        failedFiles.push(...allData.map(item => ({ fname: item.fname, orderno: item.orderno })));
        showErrorWithFailedFiles(failedFiles, dispatch);
      }

      isDownloading = false;
      dispatch({ type: STORE_PROGRESS_DOWNLOADING, isDownloading } as AnyAction);
    } else {
      // single file
      const file = Array.isArray(allData) ? allData[0] : allData;
      if (file) {
        if (file.status === '10' || file.status === '14') {
          newArrayOrderno.push({ orderno: file.orderno });

          fullPathAll = file.fpath.includes('/Initial')
            ? `${file.fpath.split('/Initial')[0]}/Final_Scan/${file.fname}`
            : `${file.fpath}/Final_Scan/${file.fname}`;
        } else {
          fullPathAll = `${file.fpath.split('/Initial')[0]}/Initial_Scan/${file.fname}`;
        }

        const encodedFullPathAll = encodeURIComponent(fullPathAll);

        try {
          const response = await axios(`${getState().environment.API_URL}commonBucketFileCheck?fullPath=${encodedFullPathAll}`, {
            method: 'GET',
            headers: {
              'Access-Control-Allow-Origin': '*',
              'Content-Type': 'application/json',
              sessionid: getState().user.userDetails.s || ''
            }
          });

          if (statusUpdate && newArrayOrderno.length > 0) {
            downloadStatusUpdate(newArrayOrderno, '1', dispatch, getState);
          }

          getCompleteOrderData(dispatch, getState);
          window.open(response.data.signedUrl);
          if (failedFiles.length === 0) {
            alert('All files download initiated successfully');
          }
        } catch (error) {
          failedFiles.push({ fname: file.fname, orderno: file.orderno });
          showErrorWithFailedFiles(failedFiles, dispatch);
        }
      }
    }

    return true;
  };
};

// comment 28.04.2025 --- 09:16 AM
// export const onbulkDownload = (allData: RowDataCompleted[] | RowDataCompleted, statusUpdate: boolean) => {
//   return async (dispatch: Dispatch<AppState>, getState: () => AppState) => {

//     const newArray: Array<object> = [];
//     const newArrayOrderno: Array<object> = [];
//     let fullPathAll;
//     let isDownloading = false;
//     const failedFiles: Array<{fname: string, orderno: string}> = [];
    
//     if (Array.isArray(allData) && allData.length > 1) {
//       isDownloading = true;
//       dispatch({ type: STORE_PROGRESS_DOWNLOADING, isDownloading } as AnyAction);
//       allData.map((arr) => {
//         if (arr.status === '10' || arr.status === '14') {
//           if (arr.fpath.indexOf('/Initial') !== -1) {
//             fullPathAll = `${arr.fpath.split('/Initial')[0]}/Final_Scan/${arr.fname}`;
//           } else {
//             fullPathAll = `${arr.fpath}/Final_Scan/${arr.fname}`;
//           }
    
//           const orderArr = {
//             orderno: arr.orderno
//           };
//           newArrayOrderno.push(orderArr);
//         } else {
//           fullPathAll = `${arr.fpath.split('/Initial')[0]}/Initial_Scan/${arr.fname}`;
//         }
    
//         const fileValue = {
//           name: arr.fname,
//           key: `${fullPathAll}`
//         };
//         newArray.push(fileValue);
//       });
    
//       // Removing the filetag conditionals and using commonBucketFileCheck for all files
//       for (const file of allData) {
//         if (file.status === '10' || file.status === '14') {
//           if (file.fpath.indexOf('/Initial') !== -1) {
//             fullPathAll = `${file.fpath.split('/Initial')[0]}/Final_Scan/${file.fname}`;
//           } else {
//             fullPathAll = `${file.fpath}/Final_Scan/${file.fname}`;
//           }
//         } else {
//           fullPathAll = `${file.fpath.split('/Initial')[0]}/Initial_Scan/${file.fname}`;
//         }

//         const encodedFullPathAll = encodeURIComponent(fullPathAll);
//         try {
//           const response = await axios(`${getState().environment.API_URL}downloadMultifile?fullPath=${encodedFullPathAll}`, {
//             method: 'GET',
//             headers: {
//               'Access-Control-Allow-Origin': '*',
//               'Content-Type': 'application/json',
//               sessionid: getState().user.userDetails.s || ''
//             }
//           });
//           console.log(response, 'res test 1');
          
//           if (statusUpdate && newArrayOrderno.length > 0) {
//             downloadStatusUpdate(newArrayOrderno, '1', dispatch, getState);
//           }
//           getCompleteOrderData(dispatch, getState);
//           console.log(response.data, 'res test 2');
//           console.log(response.data.signedUrl, 'res test 21');
          
//           window.open(response.data.signedUrl);
//         } catch (error) {
//           failedFiles.push({
//             fname: file.fname,
//             orderno: file.orderno
//           });
//         }
//       }
      
//       isDownloading = false;
//       dispatch({ type: STORE_PROGRESS_DOWNLOADING, isDownloading } as AnyAction);
      
//       // Show any failed files
//       if (failedFiles.length > 0) {
//         showErrorWithFailedFiles(failedFiles, dispatch);
//       } else {
//         alert('All files downloaded');
//       }
//     } else {
//       // Single file download  
//       if (allData && allData[0]) {
//         if (allData[0].status === '10' || allData[0].status === '14') {
//           const orderArr = {
//             orderno: allData[0].orderno
//           };

//           newArrayOrderno.push(orderArr);

//           if (allData[0].fpath.indexOf('/Initial') !== -1) {
//             fullPathAll = `${allData[0].fpath.split('/Initial')[0]}/Final_Scan/${allData[0].fname}`;
//           } else {
//             fullPathAll = `${allData[0].fpath}/Final_Scan/${allData[0].fname}`;
//           }
//         } else {
//           fullPathAll = `${allData[0].fpath.split('/Initial')[0]}/Initial_Scan/${allData[0].fname}`;
//         }

//         const encodedFullPathAll = encodeURIComponent(fullPathAll);
        
//         // Use commonBucketFileCheck for single file download too
//         const apiUrl = 'downloadMultifile';
        
//         try {
//           const response = await axios(`${getState().environment.API_URL}${apiUrl}?fullPath=${encodedFullPathAll}`, {
//             method: 'GET',
//             headers: {
//               'Access-Control-Allow-Origin': '*',
//               'Content-Type': 'application/json',
//               sessionid: getState().user.userDetails.s || ''
//             }
//           });
//           console.log(response, 'res test 3');
//           if (statusUpdate && newArrayOrderno.length > 0) {
//             downloadStatusUpdate(newArrayOrderno, '1', dispatch, getState);
//           }
//           getCompleteOrderData(dispatch, getState);
//           console.log(response.data.signedUrl, 'signerUrl test'); 
//           window.open(response.data.signedUrl);
//         } catch (error) {
//           failedFiles.push({
//             fname: allData[0].fname,
//             orderno: allData[0].orderno
//           });
          
//           // Show any failed files
//           if (failedFiles.length > 0) {
//             showErrorWithFailedFiles(failedFiles, dispatch);
//           } else {
//             const errorfilemsg = 'Something went wrong!';
//             dispatch({ type: STORE_ERROR_FILES_UPLOADED_MSG, errorfilemsg } as AnyAction);
//           }
//         }
//       }
//     }
//     return true;
//   };
// };

// comment in 19.03.2025

// export const onBulkDownloadIndividual = (allData: RowDataCompleted[] | RowDataCompleted, statusUpdate: boolean) => {
//   console.log(allData, '80000');
//   return async (dispatch: Dispatch<AppState>, getState: () => AppState) => {

//     const newArray: Array<object> = [];
//     const newArrayOrderno: Array<object> = [];
//     let fullPathAll;
//     const failedFiles: Array<{fname: string, orderno: string}> = [];

//     if (Array.isArray(allData) && allData.length > 1) {
//       dispatch({ type: STORE_PROGRESS_DOWNLOADING, isDownloading: true } as AnyAction);

//       for (const arr of allData) {
//         let fileValue = {
//           name: '',
//           key: ''
//         };

//         if (arr.status === '10') {
//           console.log('Processing status 10:', arr); // Logs only for status 10
//         }

//         if (arr.status === '14') {
//           console.log('Processing status 14:', arr); // Logs only for status 14
//         }

//         let orderArr = {
//           orderno: ''
//         };

//         if (arr.status === '10' || arr.status === '14') {
//           if (arr.fpath.indexOf('/Initial') !== -1) {
//             fullPathAll = `${arr.fpath.split('/Initial')[0]}/Final_Scan/${arr.fname}`;
            
//           } else {
//             fullPathAll = `${arr.fpath}/Final_Scan/${arr.fname}`;
//           }

//           fileValue = {
//             name: arr.fname,
//             key: `${fullPathAll}`
//           };
//           orderArr = {
//             orderno: arr.orderno
//           };

//         } else {
//           fullPathAll = `${arr.fpath.split('/Initial')[0]}/Initial_Scan/${arr.fname}`;
//           fileValue = {
//             name: arr.fname,
//             key: `${fullPathAll}`
//           };
//           newArray.push(fileValue);
//         }

//         const encodedFullPathAll = encodeURIComponent(fileValue.key); 
        
//         const apiUrl = 
//         arr.filetag === 'W' ? 'getDownloadUrl' :
//         arr.filetag === 'O' ? 'getODownloadUrl' :
//         'getDownloadUrlLocal';
        
//         try {
//           const response = await axios(`${getState().environment.API_URL}${apiUrl}?fullPath=${encodedFullPathAll}`, {
//             method: 'GET',
//             headers: {
//               'Access-Control-Allow-Origin': '*',
//               'Content-Type': 'application/json',
//               sessionid: getState().user.userDetails.s || ''
//             }
//           });
          
//           console.log(response, 'responseresponseresponse');
          
//           if (statusUpdate && orderArr.orderno) {
//             downloadStatusUpdate([orderArr], '1', dispatch, getState);
//           }
//           console.log(response.data.signedUrl, 'response.data.signedUrl 1111');
//           window.open(response.data.signedUrl);
//         } catch (error) {
//           failedFiles.push({
//             fname: arr.fname,
//             orderno: arr.orderno
//           });
//         }
//       }

//       dispatch({ type: STORE_PROGRESS_DOWNLOADING, isDownloading: false } as AnyAction);
//       getCompleteOrderData(dispatch, getState);
      
//       // Show any failed files after all downloads are attempted
//       if (failedFiles.length > 0) {
//         showErrorWithFailedFiles(failedFiles, dispatch);
//       }
//     } else {
//       // Single file download
//       if (allData && allData[0]) {
//         if (allData[0].status === '10' || allData[0].status === '14') {
//           const orderArr = {
//             orderno: allData[0].orderno
//           };

//           newArrayOrderno.push(orderArr);

//           if (allData[0].fpath.indexOf('/Initial') !== -1) {
//             fullPathAll = `${allData[0].fpath.split('/Initial')[0]}/Final_Scan/${allData[0].fname}`;
//           } else {
//             fullPathAll = `${allData[0].fpath}/Final_Scan/${allData[0].fname}`;
//           }
//         } else {
//           fullPathAll = `${allData[0].fpath.split('/Initial')[0]}/Initial_Scan/${allData[0].fname}`;
//         }

//         const encodedFullPathAll = encodeURIComponent(fullPathAll);
//         console.log(encodedFullPathAll, 'encodedFullPathAll3333');
        
//         const apiUrl = 
//         allData[0].filetag === 'W' ? 'getDownloadUrl' :
//         allData[0].filetag === 'O' ? 'getODownloadUrl' :
//         'getDownloadUrlLocal';
        
//         try {
//           const response = await axios(`${getState().environment.API_URL}${apiUrl}?fullPath=${encodedFullPathAll}`, {
//             method: 'GET',
//             headers: {
//               'Access-Control-Allow-Origin': '*',
//               'Content-Type': 'application/json',
//               sessionid: getState().user.userDetails.s || ''
//             }
//           });
          
//           if (statusUpdate && newArrayOrderno.length > 0) {
//             downloadStatusUpdate(newArrayOrderno, '1', dispatch, getState);
//           }
//           getCompleteOrderData(dispatch, getState);
//           console.log(response, 'response2222');
//           console.log(response.data.signedUrl, 'response.data.signedUrl');
//           window.open(response.data.signedUrl);
//         } catch (error) {
//           failedFiles.push({
//             fname: allData[0].fname,
//             orderno: allData[0].orderno
//           });
          
//           // Show any failed files
//           if (failedFiles.length > 0) {
//             showErrorWithFailedFiles(failedFiles, dispatch);
//           } else {
//             // const errorFileUploadedOpen = true;
//             const errorfilemsg = 'Something went wrong!';
//             // dispatch({ type: STORE_ERROR_FILES_UPLOADED, errorFileUploadedOpen } as AnyAction);
//             dispatch({ type: STORE_ERROR_FILES_UPLOADED_MSG, errorfilemsg } as AnyAction);
//           }
//         }
//       }
//     }
//     return true;
//   };
// };

// update code comment 03.04.2025 --- 10.14 PM / 11.04.2025 // working fine
// export const onBulkDownloadIndividual = (allData: RowDataCompleted[] | RowDataCompleted, statusUpdate: boolean = true) => {
//   console.log(allData, '80000');
//   return async (dispatch: Dispatch<AppState>, getState: () => AppState) => {

//     const newArray: Array<object> = [];
//     const newArrayOrderno: Array<object> = [];
//     let fullPathAll;
//     const failedFiles: Array<{fname: string, orderno: string}> = [];

//     if (Array.isArray(allData) && allData.length > 1) {
//       dispatch({ type: STORE_PROGRESS_DOWNLOADING, isDownloading: true } as AnyAction);

//       for (const arr of allData) {
//         let fileValue = {
//           name: '',
//           key: ''
//         };

//         if (arr.status === '10') {
//           console.log('Processing status 10:', arr); // Logs only for status 10
//         }

//         if (arr.status === '14') {
//           console.log('Processing status 14:', arr); // Logs only for status 14
//         }

//         let orderArr = {
//           orderno: ''
//         };

//         if (arr.status === '10' || arr.status === '14') {
//           if (arr.fpath.indexOf('/Initial') !== -1) {
//             fullPathAll = `${arr.fpath.split('/Initial')[0]}/Final_Scan/${arr.fname}`;
            
//           } else {
//             fullPathAll = `${arr.fpath}/Final_Scan/${arr.fname}`;
//           }

//           fileValue = {
//             name: arr.fname,
//             key: `${fullPathAll}`
//           };
//           orderArr = {
//             orderno: arr.orderno
//           };

//         } else {
//           fullPathAll = `${arr.fpath.split('/Initial')[0]}/Initial_Scan/${arr.fname}`;
//           fileValue = {
//             name: arr.fname,
//             key: `${fullPathAll}`
//           };
//           newArray.push(fileValue);
//         }

//         const encodedFullPathAll = encodeURIComponent(fileValue.key); 
        
//         const apiUrl = 
//         arr.filetag === 'W' ? 'getDownloadUrl' :
//         arr.filetag === 'O' ? 'getODownloadUrl' :
//         arr.filetag === 'OW' ? 'commonBucketFileCheck' :
//         'getDownloadUrlLocal';
        
//         try {
//           const response = await axios(`${getState().environment.API_URL}${apiUrl}?fullPath=${encodedFullPathAll}`, {
//             method: 'GET',
//             headers: {
//               'Access-Control-Allow-Origin': '*',
//               'Content-Type': 'application/json',
//               sessionid: getState().user.userDetails.s || ''
//             }
//           });
          
//           console.log(response, 'responseresponseresponse');
          
//           if (statusUpdate && orderArr.orderno) {
//             downloadStatusUpdate([orderArr], '1', dispatch, getState);
//           }
//           console.log(response.data.signedUrl, 'response.data.signedUrl 1111');
//           window.open(response.data.signedUrl);
//         } catch (error) {
//           failedFiles.push({
//             fname: arr.fname,
//             orderno: arr.orderno
//           });
//         }
//       }

//       dispatch({ type: STORE_PROGRESS_DOWNLOADING, isDownloading: false } as AnyAction);
//       getCompleteOrderData(dispatch, getState);
      
//       // Show any failed files after all downloads are attempted
//       if (failedFiles.length > 0) {
//         showErrorWithFailedFiles(failedFiles, dispatch);
//       }
//     } else {
//       // Single file download
//       if (allData && allData[0]) {
//         if (allData[0].status === '10' || allData[0].status === '14') {
//           const orderArr = {
//             orderno: allData[0].orderno
//           };

//           newArrayOrderno.push(orderArr);

//           if (allData[0].fpath.indexOf('/Initial') !== -1) {
//             fullPathAll = `${allData[0].fpath.split('/Initial')[0]}/Final_Scan/${allData[0].fname}`;
//           } else {
//             fullPathAll = `${allData[0].fpath}/Final_Scan/${allData[0].fname}`;
//           }
//         } else {
//           fullPathAll = `${allData[0].fpath.split('/Initial')[0]}/Initial_Scan/${allData[0].fname}`;
//         }

//         const encodedFullPathAll = encodeURIComponent(fullPathAll);
//         console.log(encodedFullPathAll, 'encodedFullPathAll3333');
        
//         const apiUrl = 
//         allData[0].filetag === 'W' ? 'getDownloadUrl' :
//         allData[0].filetag === 'O' ? 'getODownloadUrl' :
//         allData[0].filetag === 'OW' ? 'commonBucketFileCheck' :
//         'getDownloadUrlLocal';
        
//         try {
//           const response = await axios(`${getState().environment.API_URL}${apiUrl}?fullPath=${encodedFullPathAll}`, {
//             method: 'GET',
//             headers: {
//               'Access-Control-Allow-Origin': '*',
//               'Content-Type': 'application/json',
//               sessionid: getState().user.userDetails.s || ''
//             }
//           });
          
//           if (statusUpdate && newArrayOrderno.length > 0) {
//             downloadStatusUpdate(newArrayOrderno, '1', dispatch, getState);
//           }
//           getCompleteOrderData(dispatch, getState);
//           console.log(response, 'response2222');
//           console.log(response.data.signedUrl, 'response.data.signedUrl');
//           window.open(response.data.signedUrl);
//         } catch (error) {
//           failedFiles.push({
//             fname: allData[0].fname,
//             orderno: allData[0].orderno
//           });
          
//           // Show any failed files
//           if (failedFiles.length > 0) {
//             showErrorWithFailedFiles(failedFiles, dispatch);
//           } else {
//             // const errorFileUploadedOpen = true;
//             const errorfilemsg = 'Something went wrong!';
//             // dispatch({ type: STORE_ERROR_FILES_UPLOADED, errorFileUploadedOpen } as AnyAction);
//             dispatch({ type: STORE_ERROR_FILES_UPLOADED_MSG, errorfilemsg } as AnyAction);
//           }
//         }
//       }
//     }
//     return true;
//   };
// };

// comments for 25.04.2025 -- 05:22 PM
// export const onBulkDownloadIndividual = (allData: RowDataCompleted[] | RowDataCompleted, statusUpdate: boolean = true) => {
//   console.log(allData, '80000');
//   return async (dispatch: Dispatch<AppState>, getState: () => AppState) => {

//     const newArray: Array<object> = [];
//     const newArrayOrderno: Array<object> = [];
//     let fullPathAll;
//     const failedFiles: Array<{fname: string, orderno: string}> = [];

//     if (Array.isArray(allData) && allData.length > 1) {
//       dispatch({ type: STORE_PROGRESS_DOWNLOADING, isDownloading: true } as AnyAction);

//       // const totalFileCount = allData.length;
//       // console.log('total file count : ', totalFileCount);

//       for (const arr of allData) {
//         let fileValue = {
//           name: '',
//           key: ''
//         };

//         if (arr.status === '10') {
//           console.log('Processing status 10:', arr); 
//         }

//         if (arr.status === '14') {
//           console.log('Processing status 14:', arr); 
//         }

//         let orderArr = {
//           orderno: ''
//         };

//         if (arr.status === '10' || arr.status === '14') {
//           if (arr.fpath.indexOf('/Initial') !== -1) {
//             fullPathAll = `${arr.fpath.split('/Initial')[0]}/Final_Scan/${arr.fname}`;
            
//           } else {
//             fullPathAll = `${arr.fpath}/Final_Scan/${arr.fname}`;
//           }

//           fileValue = {
//             name: arr.fname,
//             key: `${fullPathAll}`
//           };
//           orderArr = {
//             orderno: arr.orderno
//           };

//         } else {
//           fullPathAll = `${arr.fpath.split('/Initial')[0]}/Initial_Scan/${arr.fname}`;
//           fileValue = {
//             name: arr.fname,
//             key: `${fullPathAll}`
//           };
//           newArray.push(fileValue);
//         }

//         const encodedFullPathAll = encodeURIComponent(fileValue.key); 
        
//         // Use commonBucketFileCheck for all file tags
//         const apiUrl = 'commonBucketFileCheck';
        
//         try {
//           const response = await axios(`${getState().environment.API_URL}${apiUrl}?fullPath=${encodedFullPathAll}`, {
//             method: 'GET',
//             headers: {
//               'Access-Control-Allow-Origin': '*',
//               'Content-Type': 'application/json',
//               sessionid: getState().user.userDetails.s || ''
//             }
//           });
          
//           console.log(response, 'responseresponseresponse');
          
//           if (statusUpdate && orderArr.orderno) {
//             downloadStatusUpdate([orderArr], '1', dispatch, getState);
//           }
//           console.log(response.data.signedUrl, 'response.data.signedUrl 1111');
//           window.open(response.data.signedUrl);
//         } catch (error) {
//           console.log('Download failed:');
//           if (error.response) {
//             console.log('Response data:', error.response.data);
//             console.log('Response status:', error.response.status);
//             console.log('Response headers:', error.response.headers);
//           } else if (error.request) {
//             console.log('Request made but no response received:', error.request);
//           } else {
//             console.log('Error message:', error.message);
//           }
//           failedFiles.push({
//             fname: arr.fname,
//             orderno: arr.orderno
//           });
//         }

//         // if (totalFileCount > 25 && totalFileCount < 50) {
//         //   await new Promise(f => setTimeout(f, 1000));
//         // }

//         // if (totalFileCount > 50) {
//         //   await new Promise(f => setTimeout(f, 3000));
//         // }
//       }

//       dispatch({ type: STORE_PROGRESS_DOWNLOADING, isDownloading: false } as AnyAction);
//       getCompleteOrderData(dispatch, getState);
      
//       // Show any failed files after all downloads are attempted
//       if (failedFiles.length > 0) {
//         showErrorWithFailedFiles(failedFiles, dispatch);
//       }
//     } else {
//       // Single file download
//       if (allData && allData[0]) {
//         if (allData[0].status === '10' || allData[0].status === '14') {
//           const orderArr = {
//             orderno: allData[0].orderno
//           };

//           newArrayOrderno.push(orderArr);

//           if (allData[0].fpath.indexOf('/Initial') !== -1) {
//             fullPathAll = `${allData[0].fpath.split('/Initial')[0]}/Final_Scan/${allData[0].fname}`;
//           } else {
//             fullPathAll = `${allData[0].fpath}/Final_Scan/${allData[0].fname}`;
//           }
//         } else {
//           fullPathAll = `${allData[0].fpath.split('/Initial')[0]}/Initial_Scan/${allData[0].fname}`;
//         }

//         const encodedFullPathAll = encodeURIComponent(fullPathAll);
//         console.log(encodedFullPathAll, 'encodedFullPathAll3333');
        
//         // Use commonBucketFileCheck for all file tags
//         const apiUrl = 'commonBucketFileCheck';
        
//         try {
//           const response = await axios(`${getState().environment.API_URL}${apiUrl}?fullPath=${encodedFullPathAll}`, {
//             method: 'GET',
//             headers: {
//               'Access-Control-Allow-Origin': '*',
//               'Content-Type': 'application/json',
//               sessionid: getState().user.userDetails.s || ''
//             }
//           });
          
//           if (statusUpdate && newArrayOrderno.length > 0) {
//             downloadStatusUpdate(newArrayOrderno, '1', dispatch, getState);
//           }
//           getCompleteOrderData(dispatch, getState);
//           console.log(response, 'response2222');
//           console.log(response.data.signedUrl, 'response.data.signedUrl');
//           window.open(response.data.signedUrl);
//         } catch (error) {
//           console.log('Download failed:');
//           if (error.response) {
//             console.log('Response data:', error.response.data);
//             console.log('Response status:', error.response.status);
//             console.log('Response headers:', error.response.headers);
//           } else if (error.request) {
//             console.log('Request made but no response received:', error.request);
//           } else {
//             console.log('Error message:', error.message);
//           }
//           failedFiles.push({
//             fname: allData[0].fname,
//             orderno: allData[0].orderno
//           });
          
//           // Show any failed files
//           if (failedFiles.length > 0) {
//             showErrorWithFailedFiles(failedFiles, dispatch);
//           } else {
//             const errorfilemsg = 'Something went wrong!';
//             dispatch({ type: STORE_ERROR_FILES_UPLOADED_MSG, errorfilemsg } as AnyAction);
//           }
//         }
//       }
//     }
//     return true;
//   };
// };
// comment from 25.04.2025 --- 11:52PM
// export const onBulkDownloadIndividual = (allData: RowDataCompleted[] | RowDataCompleted, statusUpdate: boolean = true) => {
//   console.log(allData, '80000');
//   return async (dispatch: Dispatch<AppState>, getState: () => AppState) => {
//     const newArray: Array<object> = [];
//     const newArrayOrderno: Array<object> = [];
//     let fullPathAll;
//     const failedFiles: Array<{ fname: string, orderno: string }> = [];

//     if (Array.isArray(allData) && allData.length > 1) {
//       dispatch({ type: STORE_PROGRESS_DOWNLOADING, isDownloading: true } as AnyAction);

//       // let totalFileCount = allData.length;
//       let successFileCount = 0;
//       let failedFileCount = 0;

//       for (const arr of allData) {
//         let fileValue = {
//           name: '',
//           key: ''
//         };

//         if (arr.status === '10') {
//           console.log('Processing status 10:', arr);
//         }

//         if (arr.status === '14') {
//           console.log('Processing status 14:', arr);
//         }

//         let orderArr = {
//           orderno: ''
//         };

//         if (arr.status === '10' || arr.status === '14') {
//           if (arr.fpath.indexOf('/Initial') !== -1) {
//             fullPathAll = `${arr.fpath.split('/Initial')[0]}/Final_Scan/${arr.fname}`;
//           } else {
//             fullPathAll = `${arr.fpath}/Final_Scan/${arr.fname}`;
//           }

//           fileValue = {
//             name: arr.fname,
//             key: `${fullPathAll}`
//           };
//           orderArr = {
//             orderno: arr.orderno
//           };

//         } else {
//           fullPathAll = `${arr.fpath.split('/Initial')[0]}/Initial_Scan/${arr.fname}`;
//           fileValue = {
//             name: arr.fname,
//             key: `${fullPathAll}`
//           };
//           newArray.push(fileValue);
//         }

//         const encodedFullPathAll = encodeURIComponent(fileValue.key);
//         const apiUrl = 'commonBucketFileCheck';

//         try {
//           const response = await axios(`${getState().environment.API_URL}${apiUrl}?fullPath=${encodedFullPathAll}`, {
//             method: 'GET',
//             headers: {
//               'Access-Control-Allow-Origin': '*',
//               'Content-Type': 'application/json',
//               sessionid: getState().user.userDetails.s || ''
//             }
//           });

//           if (statusUpdate && orderArr.orderno) {
//             downloadStatusUpdate([orderArr], '1', dispatch, getState);
//             successFileCount = successFileCount + 1;
//           }

//           // await new Promise(f => setTimeout(f, 660000));

//           try {
//             const response1 = await axios(response.data.signedUrl, {
//               responseType: 'blob',
//               onDownloadProgress: (e) => {
//                 const percent = Math.round((e.loaded * 100) / (e.total || 1));
//                 console.log('percentage : ', percent);
//               },
//             });
//             const blob = new Blob([response1.data]);
//             const blobUrl = window.URL.createObjectURL(blob);

//             const link = document.createElement('a');
//             link.href = blobUrl;
//             link.download = arr.fname;
//             link.click();

//             link.remove();
//             window.URL.revokeObjectURL(blobUrl);
//             successFileCount = successFileCount + 1;
//           } catch {
//             failedFileCount = failedFileCount + 1;
//           }

//           console.log('Failed Files Count : ', failedFileCount);

//           console.log(response.data.signedUrl, 'response.data.signedUrl 1111');
//           // window.open(response.data.signedUrl);

//         } catch (error) {
//           failedFileCount = failedFileCount + 1;
          
//           failedFiles.push({
//             fname: arr.fname,
//             orderno: arr.orderno
//           });

//           console.log('Download failed:');
//           if (error.response) {
//             console.log('Response data:', error.response.data);
//             console.log('Response status:', error.response.status);
//             console.log('Response headers:', error.response.headers);
//           } else if (error.request) {
//             console.log('Request made but no response received:', error.request);
//           } else {
//             console.log('Error message:', error.message);
//           }

//           failedFiles.push({
//             fname: arr.fname,
//             orderno: arr.orderno
//           });
//         }

//         if (allData.length > 25 && allData.length < 50) {
//           await new Promise(f => setTimeout(f, 1000));
//         } else if (allData.length >= 50) {
//           await new Promise(f => setTimeout(f, 2000));
//         }
//       }

//       dispatch({ type: STORE_PROGRESS_DOWNLOADING, isDownloading: false } as AnyAction);
//       getCompleteOrderData(dispatch, getState);

//       if (failedFiles.length > 0 || failedFileCount > 0) {
//         showErrorWithFailedFiles(failedFiles, dispatch);
//       }
//     } else {
//       // Single file download
//       if (allData && allData[0]) {
//         if (allData[0].status === '10' || allData[0].status === '14') {
//           const orderArr = {
//             orderno: allData[0].orderno
//           };

//           newArrayOrderno.push(orderArr);

//           if (allData[0].fpath.indexOf('/Initial') !== -1) {
//             fullPathAll = `${allData[0].fpath.split('/Initial')[0]}/Final_Scan/${allData[0].fname}`;
//           } else {
//             fullPathAll = `${allData[0].fpath}/Final_Scan/${allData[0].fname}`;
//           }
//         } else {
//           fullPathAll = `${allData[0].fpath.split('/Initial')[0]}/Initial_Scan/${allData[0].fname}`;
//         }

//         const encodedFullPathAll = encodeURIComponent(fullPathAll);
//         const apiUrl = 'commonBucketFileCheck';

//         try {
//           const response = await axios(`${getState().environment.API_URL}${apiUrl}?fullPath=${encodedFullPathAll}`, {
//             method: 'GET',
//             headers: {
//               'Access-Control-Allow-Origin': '*',
//               'Content-Type': 'application/json',
//               sessionid: getState().user.userDetails.s || ''
//             }
//           });

//           if (statusUpdate && newArrayOrderno.length > 0) {
//             downloadStatusUpdate(newArrayOrderno, '1', dispatch, getState);
//           }

//           getCompleteOrderData(dispatch, getState);
//           window.open(response.data.signedUrl);
//         } catch (error) {
//           console.log('Download failed:');
//           if (error.response) {
//             console.log('Response data:', error.response.data);
//             console.log('Response status:', error.response.status);
//             console.log('Response headers:', error.response.headers);
//           } else if (error.request) {
//             console.log('Request made but no response received:', error.request);
//           } else {
//             console.log('Error message:', error.message);
//           }

//           failedFiles.push({
//             fname: allData[0].fname,
//             orderno: allData[0].orderno
//           });

//           if (failedFiles.length > 0 ) {
//             showErrorWithFailedFiles(failedFiles, dispatch);
//           } else {
//             const errorfilemsg = 'Something went wrong!';
//             dispatch({ type: STORE_ERROR_FILES_UPLOADED_MSG, errorfilemsg } as AnyAction);
//           }
//         }
//       }
//     }

//     return true;
//   };
// };
// export const onBulkDownloadIndividual = (allData: RowDataCompleted[] | RowDataCompleted, statusUpdate: boolean = true) => {
//   return async (dispatch: Dispatch<AppState>, getState: () => AppState) => {
//     const newArray: Array<object> = [];
//     const newArrayOrderno: Array<object> = [];
//     const failedFiles: Array<{ fname: string; orderno: string }> = [];

//     let fullPathAll;

//     if (Array.isArray(allData) && allData.length > 1) {
//       dispatch({ type: STORE_PROGRESS_DOWNLOADING, isDownloading: true } as AnyAction);

//       let failedFileCount = 0;

//       for (const arr of allData) {
//         let fileValue = { name: '', key: '' };
//         let orderArr = { orderno: '' };

//         if (arr.status === '10' || arr.status === '14') {
//           if (arr.fpath.indexOf('/Initial') !== -1) {
//             fullPathAll = `${arr.fpath.split('/Initial')[0]}/Final_Scan/${arr.fname}`;
//           } else {
//             fullPathAll = `${arr.fpath}/Final_Scan/${arr.fname}`;
//           }

//           fileValue = { name: arr.fname, key: fullPathAll };
//           orderArr = { orderno: arr.orderno };
//         } else {
//           fullPathAll = `${arr.fpath.split('/Initial')[0]}/Initial_Scan/${arr.fname}`;
//           fileValue = { name: arr.fname, key: fullPathAll };
//           newArray.push(fileValue);
//         }

//         const encodedFullPathAll = encodeURIComponent(fileValue.key);
//         const apiUrl = 'commonBucketFileCheck';

//         try {
//           const response = await axios(`${getState().environment.API_URL}${apiUrl}?fullPath=${encodedFullPathAll}`, {
//             method: 'GET',
//             headers: {
//               'Access-Control-Allow-Origin': '*',
//               'Content-Type': 'application/json',
//               sessionid: getState().user.userDetails.s || ''
//             }
//           });

//           if (statusUpdate && orderArr.orderno) {
//             downloadStatusUpdate([orderArr], '1', dispatch, getState);
//           }
          
//           console.log('downloading file =====> ', arr.fname);
//           axios.get(response.data.signedUrl, {
//             responseType: 'blob',
            // onDownloadProgress: (e) => {
            //   const percent = Math.round((e.loaded * 100) / (e.total || 1));
            //   console.log(percent);
            //   dispatch({ type: STORE_PROGRESS_DOWNLOADING, isDownloading: true } as AnyAction);
            // }
//           })
//             .then(res => {
//               console.log(res.data);
//               const blob = new Blob([res.data]);
//               const blobUrl = window.URL.createObjectURL(blob);
//               const link = document.createElement('a');
//               link.href = blobUrl;
//               link.download = arr.fname;
//               link.click();
//               window.URL.revokeObjectURL(blobUrl);
//             })
//             .catch(err => {
//               console.log('Failed to download file => ', arr.fname);
//             })
//             .finally(() => {
//               console.log('Inside Finally');
//             });

//           //   const blob = new Blob([blobResponse.data]);
//           //   const blobUrl = window.URL.createObjectURL(blob);

//           //   const link = document.createElement('a');
//           //   link.href = blobUrl;
//           //   link.download = arr.fname;
//           //   link.click();
//           //   link.remove();
//           //   window.URL.revokeObjectURL(blobUrl);
//           // } catch {
//           //   failedFileCount++;
//           //   failedFiles.push({ fname: arr.fname, orderno: arr.orderno });
//           // }

//           // try {
//           //   await axios.head(response.data.signedUrl, {
//           //     headers: {
//           //       sessionid: getState().user.userDetails.s || ''
//           //     }
//           //   });
//           //   window.open(response.data.signedUrl);
//           // } catch (err) {
//           //   console.log('File not available in new tab:', arr.fname);
//           //   failedFileCount++;
//           //   failedFiles.push({ fname: arr.fname, orderno: arr.orderno });
//           // }
//         } catch (error) {
//           failedFileCount++;
//           failedFiles.push({ fname: arr.fname, orderno: arr.orderno });

//           console.log('Download failed:');
//           if (error.response) {
//             console.log('Response data:', error.response.data);
//             console.log('Response status:', error.response.status);
//             console.log('Response headers:', error.response.headers);
//           } else if (error.request) {
//             console.log('No response received:', error.request);
//           } else {
//             console.log('Error message:', error.message);
//           }
//         }
//       }
      
//       dispatch({ type: STORE_PROGRESS_DOWNLOADING, isDownloading: false } as AnyAction);

//       getCompleteOrderData(dispatch, getState);

//       if (failedFiles.length > 0 || failedFileCount > 0) {
//         console.log('Failed Files COUNT ========> ', failedFileCount);
//         showErrorWithFailedFiles(failedFiles, dispatch);
//       }
//     } else {
//       const file = Array.isArray(allData) ? allData[0] : allData;

//       if (file) {
//         if (file.status === '10' || file.status === '14') {
//           newArrayOrderno.push({ orderno: file.orderno });

//           if (file.fpath.indexOf('/Initial') !== -1) {
//             fullPathAll = `${file.fpath.split('/Initial')[0]}/Final_Scan/${file.fname}`;
//           } else {
//             fullPathAll = `${file.fpath}/Final_Scan/${file.fname}`;
//           }
//         } else {
//           fullPathAll = `${file.fpath.split('/Initial')[0]}/Initial_Scan/${file.fname}`;
//         }

//         const encodedFullPathAll = encodeURIComponent(fullPathAll);
//         const apiUrl = 'commonBucketFileCheck';

//         try {
//           const response = await axios(`${getState().environment.API_URL}${apiUrl}?fullPath=${encodedFullPathAll}`, {
//             method: 'GET',
//             headers: {
//               'Access-Control-Allow-Origin': '*',
//               'Content-Type': 'application/json',
//               sessionid: getState().user.userDetails.s || ''
//             }
//           });

//           if (statusUpdate && newArrayOrderno.length > 0) {
//             downloadStatusUpdate(newArrayOrderno, '1', dispatch, getState);
//           }

//           getCompleteOrderData(dispatch, getState);

//           try {
//             await axios.head(response.data.signedUrl, {
//               headers: {
//                 sessionid: getState().user.userDetails.s || ''
//               }
//             });
//             window.open(response.data.signedUrl);
//           } catch (err) {
//             console.log('Single file download failed in new tab:', file.fname);
//             failedFiles.push({ fname: file.fname, orderno: file.orderno });
//             showErrorWithFailedFiles(failedFiles, dispatch);
//           }
//         } catch (error) {
//           console.log('Download failed:');
//           if (error.response) {
//             console.log('Response data:', error.response.data);
//             console.log('Response status:', error.response.status);
//             console.log('Response headers:', error.response.headers);
//           } else if (error.request) {
//             console.log('No response received:', error.request);
//           } else {
//             console.log('Error message:', error.message);
//           }

//           failedFiles.push({ fname: file.fname, orderno: file.orderno });

//           if (failedFiles.length > 0) {
//             showErrorWithFailedFiles(failedFiles, dispatch);
//           } else {
//             dispatch({
//               type: STORE_ERROR_FILES_UPLOADED_MSG,
//               errorfilemsg: 'Something went wrong!',
//             } as AnyAction);
//           }
//         }
//       }
//     }

//     return true;
//   };
// };
export const onBulkDownloadIndividual = (
  allData: RowDataCompleted[] | RowDataCompleted,
  statusUpdate: boolean = true
) => {
  return async (dispatch: Dispatch<AppState>, getState: () => AppState) => {
    const failedFiles: Array<{ fname: string; orderno: string }> = [];
    let fullPathAll: string;

    if (Array.isArray(allData) && allData.length > 1) {
      dispatch({ type: STORE_PROGRESS_DOWNLOADING, isDownloading: true } as AnyAction);

      const downloadPromises = allData.map(async (arr) => {
        let fileValue = { name: '', key: '' };
        let orderArr = { orderno: '' };

        if (arr.status === '10' || arr.status === '14') {
          fullPathAll = arr.fpath.includes('/Initial')
            ? `${arr.fpath.split('/Initial')[0]}/Final_Scan/${arr.fname}`
            : `${arr.fpath}/Final_Scan/${arr.fname}`;

          fileValue = { name: arr.fname, key: fullPathAll };
          orderArr = { orderno: arr.orderno };
        } else {
          fullPathAll = `${arr.fpath.split('/Initial')[0]}/Initial_Scan/${arr.fname}`;
          fileValue = { name: arr.fname, key: fullPathAll };
        }

        const encodedFullPathAll = encodeURIComponent(fileValue.key);
        const apiUrl = 'commonBucketFileCheck';

        try {
          const response = await axios(`${getState().environment.API_URL}${apiUrl}?fullPath=${encodedFullPathAll}`, {
            method: 'GET',
            headers: {
              'Access-Control-Allow-Origin': '*',
              'Content-Type': 'application/json',
              sessionid: getState().user.userDetails.s || ''
            }
          });
          
          if (statusUpdate && orderArr.orderno) {
            downloadStatusUpdate([orderArr], '1', dispatch, getState);
          }

          const downloadResponse = await axios.get(response.data.signedUrl, {
            responseType: 'blob',
            // onDownloadProgress: (e) => {
            //   const percent = Math.round((e.loaded * 100) / (e.total || 1));
            //   console.log(percent);
            // }
          });
          
          const blob = new Blob([downloadResponse.data]);
          const blobUrl = window.URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = blobUrl;
          link.download = arr.fname;
          link.click();
          window.URL.revokeObjectURL(blobUrl);

        } catch (error) {
          failedFiles.push({ fname: arr.fname, orderno: arr.orderno });

          if (error.response) {
            console.log('Response data:', error.response.data);
          } else if (error.request) {
            console.log('No response received:', error.request);
          } else {
            console.log('Error message:', error.message);
          }
        }
      });

      // Wait for all downloads to be triggered
      await Promise.all(downloadPromises);

      // Add a short delay to allow browser download to begin
      await new Promise((resolve) => setTimeout(resolve, 1000));

      dispatch({ type: STORE_PROGRESS_DOWNLOADING, isDownloading: false } as AnyAction);
      getCompleteOrderData(dispatch, getState);

      if (failedFiles.length > 0) {
        showErrorWithFailedFiles(failedFiles, dispatch);
      } else {
        alert('All files downloaded');
      }

    } else {
      // Handling single file
      const file = Array.isArray(allData) ? allData[0] : allData;

      if (file) {
        dispatch({ type: STORE_PROGRESS_DOWNLOADING, isDownloading: true } as AnyAction);

        try {
          if (file.status === '10' || file.status === '14') {
            fullPathAll = file.fpath.includes('/Initial')
              ? `${file.fpath.split('/Initial')[0]}/Final_Scan/${file.fname}`
              : `${file.fpath}/Final_Scan/${file.fname}`;
          } else {
            fullPathAll = `${file.fpath.split('/Initial')[0]}/Initial_Scan/${file.fname}`;
          }

          const encodedFullPathAll = encodeURIComponent(fullPathAll);
          const apiUrl = 'commonBucketFileCheck';

          const response = await axios(`${getState().environment.API_URL}${apiUrl}?fullPath=${encodedFullPathAll}`, {
            method: 'GET',
            headers: {
              'Access-Control-Allow-Origin': '*',
              'Content-Type': 'application/json',
              sessionid: getState().user.userDetails.s || ''
            }
          });

          if (statusUpdate) {
            downloadStatusUpdate([{ orderno: file.orderno }], '1', dispatch, getState);
          }

          const downloadResponse = await axios.get(response.data.signedUrl, {
            responseType: 'blob',
          });

          const blob = new Blob([downloadResponse.data]);
          const blobUrl = window.URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = blobUrl;
          link.download = file.fname;
          link.click();
          window.URL.revokeObjectURL(blobUrl);

          // Add a short delay
          await new Promise((resolve) => setTimeout(resolve, 1000));

          getCompleteOrderData(dispatch, getState);

        } catch (error) {
          failedFiles.push({ fname: file.fname, orderno: file.orderno });

          if (error.response) {
            console.log('Response data:', error.response.data);
          } else if (error.request) {
            console.log('No response received:', error.request);
          } else {
            console.log('Error message:', error.message);
          }
        }

        dispatch({ type: STORE_PROGRESS_DOWNLOADING, isDownloading: false } as AnyAction);

        if (failedFiles.length > 0) {
          showErrorWithFailedFiles(failedFiles, dispatch);
        }
      }
    }

    return true;
  };
};

// expires date 
// export const onBulkDownloadIndividual = (allData: RowDataCompleted[] | RowDataCompleted, statusUpdate: boolean = true) => {
//   console.log(allData, '80000');
//   return async (dispatch: Dispatch<AppState>, getState: () => AppState) => {

//     const newArray: Array<object> = [];
//     const newArrayOrderno: Array<object> = [];
//     let fullPathAll;
//     const failedFiles: Array<{fname: string, orderno: string, reason?: string}> = [];
//     const expiredFiles: Array<{fname: string, orderno: string}> = [];

//     if (Array.isArray(allData) && allData.length > 1) {
//       dispatch({ type: STORE_PROGRESS_DOWNLOADING, isDownloading: true } as AnyAction);

//       for (const arr of allData) {
//         let fileValue = {
//           name: '',
//           key: ''
//         };

//         if (arr.status === '10') {
//           console.log('Processing status 10:', arr); // Logs only for status 10
//         }

//         if (arr.status === '14') {
//           console.log('Processing status 14:', arr); // Logs only for status 14
//         }

//         let orderArr = {
//           orderno: ''
//         };

//         if (arr.status === '10' || arr.status === '14') {
//           if (arr.fpath.indexOf('/Initial') !== -1) {
//             fullPathAll = `${arr.fpath.split('/Initial')[0]}/Final_Scan/${arr.fname}`;
            
//           } else {
//             fullPathAll = `${arr.fpath}/Final_Scan/${arr.fname}`;
//           }

//           fileValue = {
//             name: arr.fname,
//             key: `${fullPathAll}`
//           };
//           orderArr = {
//             orderno: arr.orderno
//           };

//         } else {
//           fullPathAll = `${arr.fpath.split('/Initial')[0]}/Initial_Scan/${arr.fname}`;
//           fileValue = {
//             name: arr.fname,
//             key: `${fullPathAll}`
//           };
//           newArray.push(fileValue);
//         }

//         const encodedFullPathAll = encodeURIComponent(fileValue.key); 
        
//         const apiUrl = 
//         arr.filetag === 'W' ? 'getDownloadUrl' :
//         arr.filetag === 'O' ? 'getODownloadUrl' :
//         'getDownloadUrlLocal';
        
//         try {
//           const response = await axios(`${getState().environment.API_URL}${apiUrl}?fullPath=${encodedFullPathAll}`, {
//             method: 'GET',
//             headers: {
//               'Access-Control-Allow-Origin': '*',
//               'Content-Type': 'application/json',
//               sessionid: getState().user.userDetails.s || ''
//             }
//           });
          
//           console.log(response, 'responseresponseresponse');
          
//           if (statusUpdate && orderArr.orderno) {
//             downloadStatusUpdate([orderArr], '1', dispatch, getState);
//           }
//           console.log(response.data.signedUrl, 'response.data.signedUrl 1111');
//           window.open(response.data.signedUrl);
//         } catch (error) {
//           if (isExpirationError(error)) {
//             expiredFiles.push({
//               fname: arr.fname,
//               orderno: arr.orderno
//             });
//           } else {
//             failedFiles.push({
//               fname: arr.fname,
//               orderno: arr.orderno,
//               reason: error.response?.data?.message || 'Download failed'
//             });
//           }
//         }
//       }

//       dispatch({ type: STORE_PROGRESS_DOWNLOADING, isDownloading: false } as AnyAction);
//       getCompleteOrderData(dispatch, getState);
//       if (expiredFiles.length > 0) {
//         console.log('Expired Files:', expiredFiles);
//         const expiredFilesList = expiredFiles
//           .map(file => `${file.orderno || ''}_${file.fname || ''}`)
//           .filter(name => name.trim() !== '_')
//           .join(', ');

//         const errorfilemsg = `The following file URLs have expired (time limit reached): ${expiredFilesList}`;

//         dispatch({ type: STORE_FAILED_FILES, failedFiles: expiredFiles } as AnyAction);
//         dispatch({ type: SHOW_FAILED_FILES_DIALOG, showFailedFilesDialog: true } as AnyAction);
//         dispatch({ type: STORE_ERROR_FILES_UPLOADED_MSG, errorfilemsg } as AnyAction);
//       }
//       // Handle other failed files after expired files
//       if (failedFiles.length > 0) {
//         console.log('Failed Files:', failedFiles);
//         showErrorWithFailedFiles(failedFiles, dispatch);
//       }

//     } else {
//       // Single file download
//       if (allData && allData[0]) {
//         if (allData[0].status === '10' || allData[0].status === '14') {
//           const orderArr = {
//             orderno: allData[0].orderno
//           };

//           newArrayOrderno.push(orderArr);

//           if (allData[0].fpath.indexOf('/Initial') !== -1) {
//             fullPathAll = `${allData[0].fpath.split('/Initial')[0]}/Final_Scan/${allData[0].fname}`;
//           } else {
//             fullPathAll = `${allData[0].fpath}/Final_Scan/${allData[0].fname}`;
//           }
//         } else {
//           fullPathAll = `${allData[0].fpath.split('/Initial')[0]}/Initial_Scan/${allData[0].fname}`;
//         }

//         const encodedFullPathAll = encodeURIComponent(fullPathAll);
//         console.log(encodedFullPathAll, 'encodedFullPathAll3333');
        
//         const apiUrl = 
//         allData[0].filetag === 'W' ? 'getDownloadUrl' :
//         allData[0].filetag === 'O' ? 'getODownloadUrl' :
//         'getDownloadUrlLocal';
        
//         try {
//           const response = await axios(`${getState().environment.API_URL}${apiUrl}?fullPath=${encodedFullPathAll}`, {
//             method: 'GET',
//             headers: {
//               'Access-Control-Allow-Origin': '*',
//               'Content-Type': 'application/json',
//               sessionid: getState().user.userDetails.s || ''
//             }
//           });
          
//           if (statusUpdate && newArrayOrderno.length > 0) {
//             downloadStatusUpdate(newArrayOrderno, '1', dispatch, getState);
//           }
//           getCompleteOrderData(dispatch, getState);
//           console.log(response, 'response2222');
//           console.log(response.data.signedUrl, 'response.data.signedUrl');
//           window.open(response.data.signedUrl);
//         } catch (error) {
//           // Create single file error handlers for expiration and other errors
//           if (isExpirationError(error)) {
//             const errorfilemsg = `The file URL has expired (time limit reached). Please try downloading again.`;
//             dispatch({ type: STORE_FAILED_FILES, failedFiles: [{
//               fname: allData[0].fname,
//               orderno: allData[0].orderno,
//               reason: 'URL expired'
//             }] } as AnyAction);
//             dispatch({ type: SHOW_FAILED_FILES_DIALOG, showFailedFilesDialog: true } as AnyAction);
//             dispatch({ type: STORE_ERROR_FILES_UPLOADED_MSG, errorfilemsg } as AnyAction);
//           } else {
//             // Handle other errors
//             failedFiles.push({
//               fname: allData[0].fname,
//               orderno: allData[0].orderno,
//               reason: error.response?.data?.message || 'Download failed'
//             });
//             console.log('Failed Files 123:', failedFiles);
//             // Show any failed files after download attempt
//             showErrorWithFailedFiles(failedFiles, dispatch);
//           }
//         }
//       }
//     }
//     return true;
//   };
// };

// export const onBulkDownloadIndividual = (allData: RowDataCompleted[] | RowDataCompleted, statusUpdate: boolean) => {
//   console.log(allData, '80000');
//   return async (dispatch: Dispatch<AppState>, getState: () => AppState) => {
//     const downloadQueue: Array<{
//       url: string;
//       headers: Record<string, string>;
//       filename: string;
//       orderArr: { orderno: string };
//     }> = [];
//     const failedFiles: Array<{fname: string, orderno: string}> = [];

//     if (Array.isArray(allData) && allData.length > 1) {
//       dispatch({ type: STORE_PROGRESS_DOWNLOADING, isDownloading: true } as AnyAction);

//       // Prepare all downloads first
//       for (const arr of allData) {
//         let fileValue = {
//           name: '',
//           key: ''
//         };

//         let orderArr = {
//           orderno: ''
//         };
        
//         let fullPathAll: string;

//         if (arr.status === '10' || arr.status === '14') {
//           if (arr.fpath.indexOf('/Initial') !== -1) {
//             fullPathAll = `${arr.fpath.split('/Initial')[0]}/Final_Scan/${arr.fname}`;
//           } else {
//             fullPathAll = `${arr.fpath}/Final_Scan/${arr.fname}`;
//           }

//           fileValue = {
//             name: arr.fname,
//             key: `${fullPathAll}`
//           };
//           orderArr = {
//             orderno: arr.orderno
//           };
//         } else {
//           fullPathAll = `${arr.fpath.split('/Initial')[0]}/Initial_Scan/${arr.fname}`;
//           fileValue = {
//             name: arr.fname,
//             key: `${fullPathAll}`
//           };
//         }

//         const encodedFullPathAll = encodeURIComponent(fileValue.key); 
        
//         const apiUrl = 
//           arr.filetag === 'W' ? 'getDownloadUrl' :
//           arr.filetag === 'O' ? 'getODownloadUrl' :
//           'getDownloadUrlLocal';
        
//         // Add to download queue
//         downloadQueue.push({
//           url: `${getState().environment.API_URL}${apiUrl}?fullPath=${encodedFullPathAll}`,
//           headers: {
//             'Access-Control-Allow-Origin': '*',
//             'Content-Type': 'application/json',
//             sessionid: getState().user.userDetails.s || ''
//           },
//           filename: arr.fname,
//           orderArr: orderArr
//         });
//       }

//       // Configure concurrency
//       const MAX_CONCURRENT_DOWNLOADS = 10; // Adjust based on browser/server capabilities
      
//       // Process downloads in batches
//       for (let i = 0; i < downloadQueue.length; i += MAX_CONCURRENT_DOWNLOADS) {
//         const batch = downloadQueue.slice(i, i + MAX_CONCURRENT_DOWNLOADS);
        
//        // Instead of Promise.allSettled, use Promise.all with try/catch for each promise
//         const batchResults = await Promise.all(
//           batch.map(async item => {
//             try {
//               const response = await axios(item.url, {
//                 method: 'GET',
//                 headers: item.headers
//               });
              
//               if (statusUpdate && item.orderArr.orderno) {
//                 downloadStatusUpdate([item.orderArr], '1', dispatch, getState);
//               }
              
//               await fetchAndDownloadFile(response.data.signedUrl, item.filename);
//               return { success: true, item };
//             } catch (error) {
//               return { success: false, item };
//             }
//           })
//         );

//         // Process results
//         batchResults.forEach((result) => {
//           if (!result.success) {
//             failedFiles.push({
//               fname: result.item.filename,
//               orderno: result.item.orderArr.orderno || ''
//             });
//           }
//         });
//         // Small delay between batches to prevent overloading
//         await new Promise(resolve => setTimeout(resolve, 300));
//       }

//       dispatch({ type: STORE_PROGRESS_DOWNLOADING, isDownloading: false } as AnyAction);
//       getCompleteOrderData(dispatch, getState);
      
//       if (failedFiles.length > 0) {
//         showErrorWithFailedFiles(failedFiles, dispatch);
//       }
//     } else {
//       // Single file download - keep as is for simplicity
//       if (allData && allData[0]) {
//         const newArrayOrderno: Array<object> = [];
//         let fullPathAll: string;
        
//         if (allData[0].status === '10' || allData[0].status === '14') {
//           const orderArr = {
//             orderno: allData[0].orderno
//           };

//           newArrayOrderno.push(orderArr);

//           if (allData[0].fpath.indexOf('/Initial') !== -1) {
//             fullPathAll = `${allData[0].fpath.split('/Initial')[0]}/Final_Scan/${allData[0].fname}`;
//           } else {
//             fullPathAll = `${allData[0].fpath}/Final_Scan/${allData[0].fname}`;
//           }
//         } else {
//           fullPathAll = `${allData[0].fpath.split('/Initial')[0]}/Initial_Scan/${allData[0].fname}`;
//         }

//         const encodedFullPathAll = encodeURIComponent(fullPathAll);
        
//         const apiUrl = 
//           allData[0].filetag === 'W' ? 'getDownloadUrl' :
//           allData[0].filetag === 'O' ? 'getODownloadUrl' :
//           'getDownloadUrlLocal';
        
//         try {
//           const response = await axios(`${getState().environment.API_URL}${apiUrl}?fullPath=${encodedFullPathAll}`, {
//             method: 'GET',
//             headers: {
//               'Access-Control-Allow-Origin': '*',
//               'Content-Type': 'application/json',
//               sessionid: getState().user.userDetails.s || ''
//             }
//           });
          
//           if (statusUpdate && newArrayOrderno.length > 0) {
//             downloadStatusUpdate(newArrayOrderno, '1', dispatch, getState);
//           }
          
//           getCompleteOrderData(dispatch, getState);
//           await fetchAndDownloadFile(response.data.signedUrl, allData[0].fname);
//         } catch (error) {
//           failedFiles.push({
//             fname: allData[0].fname,
//             orderno: allData[0].orderno
//           });
          
//           if (failedFiles.length > 0) {
//             showErrorWithFailedFiles(failedFiles, dispatch);
//           } else {
//             const errorfilemsg = 'Something went wrong!';
//             dispatch({ type: STORE_ERROR_FILES_UPLOADED_MSG, errorfilemsg } as AnyAction);
//           }
//         }
//       }
//     }
//     return true;
//   };
// };

// // Improved version of fetchAndDownloadFile with timeout and better error handling
// async function fetchAndDownloadFile(url: string, filename: string): Promise<boolean> {
//   try {
//     const controller = new AbortController();
//     const timeoutId = setTimeout(() => controller.abort(), 30000); // 30 second timeout
    
//     const response = await fetch(url, { signal: controller.signal });
//     clearTimeout(timeoutId);
    
//     if (!response.ok) {
//       throw new Error(`HTTP error! status: ${response.status}`);
//     }
    
//     const blob = await response.blob();
//     const objectUrl = URL.createObjectURL(blob);
    
//     const link = document.createElement('a');
//     link.href = objectUrl;
//     link.download = filename;
//     document.body.appendChild(link);
//     link.click();
    
//     setTimeout(() => (document.body.removeChild(link), URL.revokeObjectURL(objectUrl)), 100);
//     return true;
//   } catch (error) {
//     console.error(`Error downloading file ${filename}:`, error);
//     throw error;
//   }
// }

// export const onBulkDownloadStl = (allData: RowDataCompleted[] | RowDataCompleted, filetype: string, statusUpdate: boolean) => {
//   console.log(allData, 'ccccccccccccccc');
  
//   return async (dispatch: Dispatch<AppState>, getState: () => AppState) => {

//     const getFilesOrder: Array<string> = [];
//     let isDownloading = false;

//     if (Array.isArray(allData)) {
//       allData.map((orderNos) => {
//         getFilesOrder.push(orderNos.orderno);
//       });
//     } else if (typeof allData === 'object') {
//       getFilesOrder.push(allData.orderno);
//     }

//     if (getFilesOrder.length > 0) {

//       axios(`${getState().environment.API_URL}getAllFiles`, {
//         method: 'POST',
//         headers: {
//           'Access-Control-Allow-Origin': '*',
//           'Content-Type': 'application/json',
//           sessionid: getState().user.userDetails.s || ''
//         },
//         data: {
//           caseno: getFilesOrder.toString(),
//           filetype: filetype || 'stl'
//         }
//       }).then(response => {
//         const allDataStl = response.data;

//         if (allDataStl.length > 0) {
//           const stlFiles: GetAllFileData[] = allDataStl.filter((fileEach: GetAllFileData) => fileEach.filetype === 'STL File');
//           if (stlFiles.length > 0) {

//             isDownloading = true;
//             dispatch({ type: STORE_PROGRESS_DOWNLOADING, isDownloading } as AnyAction);

//             const newArrayStl: Array<object> = [];
//             const newArrayOrdernoStl: Array<object> = [];

//             stlFiles.map((stlFile) => {

//               const fileValue = {
//                 name: (stlFile.filename).split('/').reverse()[0],
//                 key: stlFile.filename
//               };

//               const orderArr = {
//                 orderno: stlFile.caseno
//               };

//               newArrayStl.push(fileValue);
//               newArrayOrdernoStl.push(orderArr);

//             });

//             axios(`${getState().environment.API_URL}downloadMultifile`, {
//               method: 'POST',
//               headers: {
//                 'Access-Control-Allow-Origin': '*',
//                 'Content-Type': 'application/json',
//               },
//               data: newArrayStl
//             }).then(responseStl => {

//               isDownloading = false;
//               dispatch({ type: STORE_PROGRESS_DOWNLOADING, isDownloading } as AnyAction);
//               if (statusUpdate) {
//                 downloadStatusUpdate(newArrayOrdernoStl, '1', dispatch, getState);
//               }

//               window.open(responseStl.data.signedUrl);

//               getCompleteOrderData(dispatch, getState);

//             }).catch(error => {

//               isDownloading = false;
//               dispatch({ type: STORE_PROGRESS_DOWNLOADING, isDownloading } as AnyAction);
//               // ==> console.error(error);

//             });
//           } else {
//             const errorFileUploadedOpen = true;
//             const errorfilemsg = 'No files found';
//             dispatch({ type: STORE_ERROR_FILES_UPLOADED, errorFileUploadedOpen } as AnyAction);
//             dispatch({ type: STORE_ERROR_FILES_UPLOADED_MSG, errorfilemsg } as AnyAction);
//           }
//         } else {
//           const errorFileUploadedOpen = true;
//           const errorfilemsg = 'Something went wrong!';
//           dispatch({ type: STORE_ERROR_FILES_UPLOADED, errorFileUploadedOpen } as AnyAction);
//           dispatch({ type: STORE_ERROR_FILES_UPLOADED_MSG, errorfilemsg } as AnyAction);
//         }

//       }).catch(error => {

//         const errorFileUploadedOpen = true;
//         const errorfilemsg = 'Something went wrong!';
//         dispatch({ type: STORE_ERROR_FILES_UPLOADED, errorFileUploadedOpen } as AnyAction);
//         dispatch({ type: STORE_ERROR_FILES_UPLOADED_MSG, errorfilemsg } as AnyAction);

//         isDownloading = false;
//         dispatch({ type: STORE_PROGRESS_DOWNLOADING, isDownloading } as AnyAction);
//         // ==> console.error(error);

//       });
//     } else {
//       const errorFileUploadedOpen = true;
//       const errorfilemsg = 'Something went wrong!';
//       dispatch({ type: STORE_ERROR_FILES_UPLOADED, errorFileUploadedOpen } as AnyAction);
//       dispatch({ type: STORE_ERROR_FILES_UPLOADED_MSG, errorfilemsg } as AnyAction);
//     }
//     return true;
//   };
// };

// this code is working of individually for OCI and WASABI in STL FILE

// export const onBulkDownloadStl = (allData: RowDataCompleted[] | RowDataCompleted, filetype: string, statusUpdate: boolean) => {
//   console.log(allData, 'xxxxxxxxxxxxxxxxxxxxxx');
//   return async (dispatch: Dispatch<AppState>, getState: () => AppState) => {
//     const newArrayOrderno: Array<object> = [];
//     // let fullPathAll;
//     const getFilesOrder: Array<string> = [];
//     let isDownloading = false;

//     if (Array.isArray(allData)) {
//       allData.map((orderNos) => {
//         getFilesOrder.push(orderNos.orderno);
//       });
//     } else if (typeof allData === 'object') {
//       getFilesOrder.push(allData.orderno);
//     }

//     if (getFilesOrder.length > 0) {
//       axios(`${getState().environment.API_URL}getAllFiles`, {
//         method: 'POST',
//         headers: {
//           'Access-Control-Allow-Origin': '*',
//           'Content-Type': 'application/json',
//           sessionid: getState().user.userDetails.s || ''
//         },
//         data: {
//           caseno: getFilesOrder.toString(),
//           filetype: filetype || 'stl'
//         }
//       }).then(async response => {
//         const allDataStl = response.data;
//         console.log(allDataStl, 'allDataStl');
        
//         if (allDataStl.length > 0) {
//           console.log(allDataStl, 'aaaaaaaaaaaaaaaaaa');
//           const stlFiles: GetAllFileData[] = allDataStl.filter((fileEach: GetAllFileData) => fileEach.filetype === 'STL File');
//           if (stlFiles.length > 0) {
//             isDownloading = true;
//             dispatch({ type: STORE_PROGRESS_DOWNLOADING, isDownloading } as AnyAction);

//             // const newArrayStl: Array<object> = [];
//             const newArrayStl: Array<{name: string, key: string}> = [];
//             const newArrayOrdernoStl: Array<object> = [];

//             stlFiles.map((stlFile) => {
//               const fileValue = {
//                 name: (stlFile.filename).split('/').reverse()[0],
//                 key: stlFile.filename
//               };

//               const orderArr = {
//                 orderno: stlFile.caseno
//               };

//               newArrayStl.push(fileValue);
//               newArrayOrdernoStl.push(orderArr);
//             });
//             console.log(newArrayStl, 'newArrayStl');
//             console.log(newArrayOrdernoStl, 'newArrayOrdernoStl');
//             const dataToProcess = Array.isArray(allData) ? allData : [allData];
//             console.log(dataToProcess, 'dataToProcess');
            
//             if (dataToProcess[0].filetag === 'W') {
             
//               // const dataToProcess = Array.isArray(allData) ? allData : [allData];
//               for (const file of newArrayStl) {
//                 console.log(file, 'gggggggggggggggg');
               
//                 const encodedFullPathAll = encodeURIComponent(file.key);
//                 await axios(`${getState().environment.API_URL}getDownloadUrl?fullPath=${encodedFullPathAll}`, {
//                   method: 'GET',
//                   headers: {
//                     'Access-Control-Allow-Origin': '*',
//                     'Content-Type': 'application/json',
//                     sessionid: getState().user.userDetails.s || ''
//                   }
//                 }).then(downloadResponse => {  // Changed from 'response' to 'downloadResponse'
//                   if (statusUpdate && newArrayOrderno.length > 0) {
//                     downloadStatusUpdate(newArrayOrderno, '1', dispatch, getState);
//                   }
//                   getCompleteOrderData(dispatch, getState);
//                   window.open(downloadResponse.data.signedUrl);  // Updated to use new variable name
//                 }).catch(error => {
//                   const errorFileUploadedOpen = true;
//                   const errorfilemsg = 'Something went wrong!';
//                   dispatch({ type: STORE_ERROR_FILES_UPLOADED, errorFileUploadedOpen } as AnyAction);
//                   dispatch({ type: STORE_ERROR_FILES_UPLOADED_MSG, errorfilemsg } as AnyAction);
//                 });
//               }
              
//               isDownloading = false;
//               dispatch({ type: STORE_PROGRESS_DOWNLOADING, isDownloading } as AnyAction);
//             } else {
//               // Handle non-W filetag files with bulk download
//               await axios(`${getState().environment.API_URL}downloadMultifile`, {
//                 method: 'POST',
//                 headers: {
//                   'Access-Control-Allow-Origin': '*',
//                   'Content-Type': 'application/json',
//                 },
//                 data: newArrayStl
//               }).then(responseStl => {
//                 if (statusUpdate) {
//                   downloadStatusUpdate(newArrayOrdernoStl, '1', dispatch, getState);
//                 }
//                 window.open(responseStl.data.signedUrl);
//                 getCompleteOrderData(dispatch, getState);
//               }).catch(error => {
//                 const errorFileUploadedOpen = true;
//                 const errorfilemsg = 'Something went wrong!';
//                 dispatch({ type: STORE_ERROR_FILES_UPLOADED, errorFileUploadedOpen } as AnyAction);
//                 dispatch({ type: STORE_ERROR_FILES_UPLOADED_MSG, errorfilemsg } as AnyAction);
//               });
//             }

//             isDownloading = false;
//             dispatch({ type: STORE_PROGRESS_DOWNLOADING, isDownloading } as AnyAction);
//           } else {
//             const errorFileUploadedOpen = true;
//             const errorfilemsg = 'No files found';
//             dispatch({ type: STORE_ERROR_FILES_UPLOADED, errorFileUploadedOpen } as AnyAction);
//             dispatch({ type: STORE_ERROR_FILES_UPLOADED_MSG, errorfilemsg } as AnyAction);
//           }
//         } else {
//           const errorFileUploadedOpen = true;
//           const errorfilemsg = 'Something went wrong!';
//           dispatch({ type: STORE_ERROR_FILES_UPLOADED, errorFileUploadedOpen } as AnyAction);
//           dispatch({ type: STORE_ERROR_FILES_UPLOADED_MSG, errorfilemsg } as AnyAction);
//         }
//       }).catch(error => {
//         const errorFileUploadedOpen = true;
//         const errorfilemsg = 'Something went wrong!';
//         dispatch({ type: STORE_ERROR_FILES_UPLOADED, errorFileUploadedOpen } as AnyAction);
//         dispatch({ type: STORE_ERROR_FILES_UPLOADED_MSG, errorfilemsg } as AnyAction);
//         isDownloading = false;
//         dispatch({ type: STORE_PROGRESS_DOWNLOADING, isDownloading } as AnyAction);
//       });
//     } else {
//       const errorFileUploadedOpen = true;
//       const errorfilemsg = 'Something went wrong!';
//       dispatch({ type: STORE_ERROR_FILES_UPLOADED, errorFileUploadedOpen } as AnyAction);
//       dispatch({ type: STORE_ERROR_FILES_UPLOADED_MSG, errorfilemsg } as AnyAction);
//     }
//     return true;
//   };
// };

// This code is working on correctly
// export const onBulkDownloadStl = (allData: RowDataCompleted[] | RowDataCompleted, filetype: string, statusUpdate: boolean) => {
//   console.log(allData, 'xxxxxxxxxxxxxxxxxxxxxx');
//   return async (dispatch: Dispatch<AppState>, getState: () => AppState) => {
//     const getFilesOrder: Array<string> = [];
//     let isDownloading = false;

//     if (Array.isArray(allData)) {
//       allData.map((orderNos) => {
//         getFilesOrder.push(orderNos.orderno);
//       });
//     } else if (typeof allData === 'object') {
//       getFilesOrder.push(allData.orderno);
//     }

//     if (getFilesOrder.length > 0) {
//       isDownloading = true;
//       dispatch({ type: STORE_PROGRESS_DOWNLOADING, isDownloading } as AnyAction);
      
//       axios(`${getState().environment.API_URL}getAllFiles`, {
//         method: 'POST',
//         headers: {
//           'Access-Control-Allow-Origin': '*',
//           'Content-Type': 'application/json',
//           sessionid: getState().user.userDetails.s || ''
//         },
//         data: {
//           caseno: getFilesOrder.toString(),
//           filetype: filetype || 'stl'
//         }
//       }).then(async response => {
//         const allDataStl = response.data;
//         console.log(allDataStl, 'allDataStl');
        
//         if (allDataStl.length > 0) {
//           console.log(allDataStl, 'aaaaaaaaaaaaaaaaaa');
//           const stlFiles: GetAllFileData[] = allDataStl.filter((fileEach: GetAllFileData) => fileEach.filetype === 'STL File');
          
//           if (stlFiles.length > 0) {
//             const caseNoToFiletag = new Map();
//             const dataToProcess = Array.isArray(allData) ? allData : [allData];
//             dataToProcess.forEach(item => {
//               caseNoToFiletag.set(item.orderno, item.filetag);
//             });

//             const filesToDownload: Array<{name: string, key: string, caseno: string, filetag: string}> = [];

//             stlFiles.map((stlFile) => {
//               const filetag = caseNoToFiletag.get(stlFile.caseno) || '';
              
//               const fileValue = {
//                 name: (stlFile.filename).split('/').reverse()[0],
//                 key: stlFile.filename,
//                 caseno: stlFile.caseno,
//                 filetag: filetag  
//               };

//               filesToDownload.push(fileValue);
//             });
            
//             console.log(filesToDownload, 'filesToDownload');
            
//             try {
//               const downloadResponse = await axios(`${getState().environment.API_URL}downloadAllFilesInOneZip`, {
//                 method: 'POST',
//                 headers: {
//                   'Access-Control-Allow-Origin': '*',
//                   'Content-Type': 'application/json',
//                   sessionid: getState().user.userDetails.s || ''
//                 },
//                 data: filesToDownload
//               });
              
//               if (downloadResponse.data.failedFiles && downloadResponse.data.failedFiles.length > 0) {
                
//                 const failedFilesList = downloadResponse.data.failedFiles
//                   .map((file: {name: string, caseno: string}) => `${file.caseno}_${file.name}`)
//                   .join(', ');
                
//                 const errorFileUploadedOpen = true;
//                 const errorfilemsg = `The following files could not be downloaded: ${failedFilesList}`;
//                 dispatch({ type: STORE_ERROR_FILES_UPLOADED, errorFileUploadedOpen } as AnyAction);
//                 dispatch({ type: STORE_ERROR_FILES_UPLOADED_MSG, errorfilemsg } as AnyAction);
//               }
              
//               if (statusUpdate) {
//                 const ordernosToUpdate = Array.from(new Set(filesToDownload.map(file => file.caseno)))
//                   .map(caseno => ({orderno: caseno}));
//                 downloadStatusUpdate(ordernosToUpdate, '1', dispatch, getState);
//               }
//               window.open(downloadResponse.data.signedUrl);
              
//             } catch (error) {
//               if (error.response && error.response.data && error.response.data.failedFiles) {
//                 const failedFilesList = error.response.data.failedFiles
//                   .map((file: {name: string, caseno: string}) => `${file.caseno}_${file.name}`)
//                   .join(', ');
                
//                 const errorFileUploadedOpen = true;
//                 const errorfilemsg = `Failed to download files: ${failedFilesList}`;
//                 dispatch({ type: STORE_ERROR_FILES_UPLOADED, errorFileUploadedOpen } as AnyAction);
//                 dispatch({ type: STORE_ERROR_FILES_UPLOADED_MSG, errorfilemsg } as AnyAction);
//               } else {
//                 const errorFileUploadedOpen = true;
//                 const errorfilemsg = 'Something went wrong with download!';
//                 dispatch({ type: STORE_ERROR_FILES_UPLOADED, errorFileUploadedOpen } as AnyAction);
//                 dispatch({ type: STORE_ERROR_FILES_UPLOADED_MSG, errorfilemsg } as AnyAction);
//               }
//             }

//             getCompleteOrderData(dispatch, getState);
            
//             isDownloading = false;
//             dispatch({ type: STORE_PROGRESS_DOWNLOADING, isDownloading } as AnyAction);
//           } else {
//             const errorFileUploadedOpen = true;
//             const errorfilemsg = 'No files found';
//             dispatch({ type: STORE_ERROR_FILES_UPLOADED, errorFileUploadedOpen } as AnyAction);
//             dispatch({ type: STORE_ERROR_FILES_UPLOADED_MSG, errorfilemsg } as AnyAction);
//             isDownloading = false;
//             dispatch({ type: STORE_PROGRESS_DOWNLOADING, isDownloading } as AnyAction);
//           }
//         } else {
//           const errorFileUploadedOpen = true;
//           const errorfilemsg = 'Something went wrong!';
//           dispatch({ type: STORE_ERROR_FILES_UPLOADED, errorFileUploadedOpen } as AnyAction);
//           dispatch({ type: STORE_ERROR_FILES_UPLOADED_MSG, errorfilemsg } as AnyAction);
//           isDownloading = false;
//           dispatch({ type: STORE_PROGRESS_DOWNLOADING, isDownloading } as AnyAction);
//         }
//       }).catch(error => {
//         const errorFileUploadedOpen = true;
//         const errorfilemsg = 'Something went wrong!';
//         dispatch({ type: STORE_ERROR_FILES_UPLOADED, errorFileUploadedOpen } as AnyAction);
//         dispatch({ type: STORE_ERROR_FILES_UPLOADED_MSG, errorfilemsg } as AnyAction);
//         isDownloading = false;
//         dispatch({ type: STORE_PROGRESS_DOWNLOADING, isDownloading } as AnyAction);
//       });
//     } else {
//       const errorFileUploadedOpen = true;
//       const errorfilemsg = 'Something went wrong!';
//       dispatch({ type: STORE_ERROR_FILES_UPLOADED, errorFileUploadedOpen } as AnyAction);
//       dispatch({ type: STORE_ERROR_FILES_UPLOADED_MSG, errorfilemsg } as AnyAction);
//     }
//     return true;
//   };
// };

// comment from 27.04.2025
// export const onBulkDownloadStl = (allData: RowDataCompleted[] | RowDataCompleted, filetype: string, statusUpdate: boolean) => {
//   return async (dispatch: Dispatch<AppState>, getState: () => AppState) => {
//     const getFilesOrder: Array<string> = [];
//     let isDownloading = false;

//     if (Array.isArray(allData)) {
//       allData.map((orderNos) => {
//         getFilesOrder.push(orderNos.orderno);
//       });
//     } else if (typeof allData === 'object') {
//       getFilesOrder.push(allData.orderno);
//     }

//     // Helper function to show error message with timeout
//     const showErrorWithTimeout = (message: string) => {
//       const errorFileUploadedOpen = true;
//       dispatch({ type: STORE_ERROR_FILES_UPLOADED, errorFileUploadedOpen } as AnyAction);
//       dispatch({ type: STORE_ERROR_FILES_UPLOADED_MSG, errorfilemsg: message } as AnyAction);
//      // Set timeout to clear error after 5 seconds
//       setTimeout(
//         () => {
//           dispatch({ type: STORE_ERROR_FILES_UPLOADED, errorFileUploadedOpen: false } as AnyAction);
//         }, 
//         25000
//       );
//     };

//     if (getFilesOrder.length > 0) {
//       isDownloading = true;
//       dispatch({ type: STORE_PROGRESS_DOWNLOADING, isDownloading } as AnyAction);
      
//       axios(`${getState().environment.API_URL}getAllFiles`, {
//         method: 'POST',
//         headers: {
//           'Access-Control-Allow-Origin': '*',
//           'Content-Type': 'application/json',
//           sessionid: getState().user.userDetails.s || ''
//         },
//         data: {
//           caseno: getFilesOrder.toString(),
//           filetype: filetype || 'stl'
//         }
//       }).then(async response => {
//         const allDataStl = response.data;
        
//         if (allDataStl.length > 0) {
//           const stlFiles: GetAllFileData[] = allDataStl.filter((fileEach: GetAllFileData) => fileEach.filetype === 'STL File');
          
//           if (stlFiles.length > 0) {
//             const caseNoToFiletag = new Map();
//             const dataToProcess = Array.isArray(allData) ? allData : [allData];
//             dataToProcess.forEach(item => {
//               caseNoToFiletag.set(item.orderno, item.filetag);
//             });

//             const filesToDownload: Array<{name: string, key: string, caseno: string, filetag: string}> = [];

//             stlFiles.map((stlFile) => {
//               const filetag = caseNoToFiletag.get(stlFile.caseno) || '';
              
//               const fileValue = {
//                 name: (stlFile.filename).split('/').reverse()[0],
//                 key: stlFile.filename,
//                 caseno: stlFile.caseno,
//                 filetag: filetag  
//               };

//               filesToDownload.push(fileValue);
//             });
                        
//             try {
//               const downloadResponse = await axios(`${getState().environment.API_URL}downloadAllFilesInOneZip`, {
//                 method: 'POST',
//                 headers: {
//                   'Access-Control-Allow-Origin': '*',
//                   'Content-Type': 'application/json',
//                   sessionid: getState().user.userDetails.s || ''
//                 },
//                 data: filesToDownload
//               });
              
//               if (downloadResponse.data.failedFiles && downloadResponse.data.failedFiles.length > 0) {
//                 const failedFilesList = downloadResponse.data.failedFiles
//                   .map((file: {name: string, caseno: string}) => `${file.caseno}_${file.name}`)
//                   .join(', ');
                
//                 showErrorWithTimeout(`The following files could not be downloaded: ${failedFilesList}`);
//               }
              
//               if (statusUpdate) {
//                 const ordernosToUpdate = Array.from(new Set(filesToDownload.map(file => file.caseno)))
//                   .map(caseno => ({orderno: caseno}));
//                 downloadStatusUpdate(ordernosToUpdate, '1', dispatch, getState);
//               }
//               window.open(downloadResponse.data.signedUrl);
              
//             } catch (error) {
//               if (error.response && error.response.data && error.response.data.failedFiles) {
//                 const failedFilesList = error.response.data.failedFiles
//                   .map((file: {name: string, caseno: string}) => `${file.caseno}_${file.name}`)
//                   .join(', ');
                
//                 showErrorWithTimeout(`Failed to download files: ${failedFilesList}`);
//               } else {
//                 showErrorWithTimeout('Something went wrong with download!');
//               }
//             }

//             getCompleteOrderData(dispatch, getState);
            
//             isDownloading = false;
//             dispatch({ type: STORE_PROGRESS_DOWNLOADING, isDownloading } as AnyAction);
//           } else {
//             showErrorWithTimeout('No files found');
//             isDownloading = false;
//             dispatch({ type: STORE_PROGRESS_DOWNLOADING, isDownloading } as AnyAction);
//           }
//         } else {
//           showErrorWithTimeout('Something went wrong!');
//           isDownloading = false;
//           dispatch({ type: STORE_PROGRESS_DOWNLOADING, isDownloading } as AnyAction);
//         }
//       }).catch(error => {
//         showErrorWithTimeout('Something went wrong!');
//         isDownloading = false;
//         dispatch({ type: STORE_PROGRESS_DOWNLOADING, isDownloading } as AnyAction);
//       });
//     } else {
//       showErrorWithTimeout('Something went wrong!');
//     }
//     return true;
//   };
// };
// working fine 28.04.2025--05:21 PM
// export const onBulkDownloadStl = (allData: RowDataCompleted[] | RowDataCompleted, filetype: string, statusUpdate: boolean) => {
//   return async (dispatch: Dispatch<AppState>, getState: () => AppState) => {
//     const getFilesOrder: Array<string> = [];
//     let isDownloading = false;
//     console.log(allData, 'allData ::::::::::');
    
//     if (Array.isArray(allData)) {
//       allData.map((orderNos) => {
//         getFilesOrder.push(orderNos.orderno);
//       });
//     } else if (typeof allData === 'object') {
//       getFilesOrder.push(allData.orderno);
//     }

//     // Helper function to show error message with timeout
//     const showErrorWithTimeout = (message: string) => {
//       const errorFileUploadedOpen = true;
//       dispatch({ type: STORE_ERROR_FILES_UPLOADED, errorFileUploadedOpen } as AnyAction);
//       dispatch({ type: STORE_ERROR_FILES_UPLOADED_MSG, errorfilemsg: message } as AnyAction);
//      // Set timeout to clear error after 25 seconds
//       setTimeout(
//         () => {
//           dispatch({ type: STORE_ERROR_FILES_UPLOADED, errorFileUploadedOpen: false } as AnyAction);
//         }, 
//         25000
//       );
//     };
//     console.log(getFilesOrder, 'getFilesOrder <<<<<<<<');
    
//     if (getFilesOrder.length > 0) {
//       isDownloading = true;
//       dispatch({ type: STORE_PROGRESS_DOWNLOADING, isDownloading } as AnyAction);
      
//       axios(`${getState().environment.API_URL}getAllFiles`, {
//         method: 'POST',
//         headers: {
//           'Access-Control-Allow-Origin': '*',
//           'Content-Type': 'application/json',
//           sessionid: getState().user.userDetails.s || ''
//         },
//         data: {
//           caseno: getFilesOrder.toString(),
//           filetype: filetype || 'stl'
//         }
//       }).then(async response => {
//         const allDataStl = response.data;
//         console.log(allDataStl, 'allDataStl <<<<<>>>>>>>>>');
        
//         if (allDataStl.length > 0) {
//           const stlFiles: GetAllFileData[] = allDataStl.filter((fileEach: GetAllFileData) => fileEach.filetype === 'STL File');
//           console.log(stlFiles, 'stlFiles...........');
          
//           if (stlFiles.length > 0) {
//             const caseNoToFiletag = new Map();
//             const dataToProcess = Array.isArray(allData) ? allData : [allData];
//             dataToProcess.forEach(item => {
//               caseNoToFiletag.set(item.orderno, item.filetag);
//             });

//             const filesToDownload: Array<{name: string, key: string, caseno: string, filetag: string}> = [];
//             console.log(caseNoToFiletag, 'caseNoToFiletag');
            
//             stlFiles.map((stlFile) => {
//               const filetag = caseNoToFiletag.get(stlFile.caseno) || '';
//               console.log(stlFile, 'FInal valuuuuuueeeeee');
              
//               const fileValue = {
//                 name: (stlFile.filename).split('/').reverse()[0],
//                 key: stlFile.filename,
//                 caseno: stlFile.caseno,
//                 filetag: filetag  
//               };

//               filesToDownload.push(fileValue);
//             });
                        
//             try {
//               const downloadResponse = await axios(`${getState().environment.API_URL}downloadAllFilesInOneZip`, {
//                 method: 'POST',
//                 headers: {
//                   'Access-Control-Allow-Origin': '*',
//                   'Content-Type': 'application/json',
//                   sessionid: getState().user.userDetails.s || ''
//                 },
//                 data: filesToDownload
//               });
              
//               if (downloadResponse.data.failedFiles && downloadResponse.data.failedFiles.length > 0) {
//                 // Convert the failed files to the format expected by showErrorWithFailedFiles
//                 const formattedFailedFiles = downloadResponse.data.failedFiles.map(
//                   (file: {name: string, caseno: string}) => ({
//                     fname: file.name,
//                     orderno: file.caseno,
//                     fileType: 'STL',
//                   })
//                 );
                
//                 // Use the external showErrorWithFailedFiles function
//                 showErrorWithFailedFiles(formattedFailedFiles, dispatch);
//               } else {
//                 alert('All files downloaded');
//               }
              
//               if (statusUpdate) {
//                 const ordernosToUpdate = Array.from(new Set(filesToDownload.map(file => file.caseno)))
//                   .map(caseno => ({orderno: caseno}));
//                 downloadStatusUpdate(ordernosToUpdate, '1', dispatch, getState);
//               }
//               window.open(downloadResponse.data.signedUrl);
              
//             } catch (error) {
//               if (error.response && error.response.data && error.response.data.failedFiles) {
//                 // Convert the failed files to the format expected by showErrorWithFailedFiles
//                 const formattedFailedFiles = error.response.data.failedFiles.map(
//                   (file: {name: string, caseno: string}) => ({
//                     fname: file.name,
//                     orderno: file.caseno,
//                     fileType: 'STL',
//                   })
//                 );
                
//                 // Use the external showErrorWithFailedFiles function
//                 showErrorWithFailedFiles(formattedFailedFiles, dispatch);
//               } else {
//                 showErrorWithTimeout('Something went wrong with download!');
//               }
//             }

//             getCompleteOrderData(dispatch, getState);
            
//             isDownloading = false;
//             dispatch({ type: STORE_PROGRESS_DOWNLOADING, isDownloading } as AnyAction);
//           } else {
//             showErrorWithTimeout('No files found');
//             isDownloading = false;
//             dispatch({ type: STORE_PROGRESS_DOWNLOADING, isDownloading } as AnyAction);
//           }
//         } else {
//           showErrorWithTimeout('Something went wrong!');
//           isDownloading = false;
//           dispatch({ type: STORE_PROGRESS_DOWNLOADING, isDownloading } as AnyAction);
//         }
//       }).catch(error => {
//         showErrorWithTimeout('Something went wrong!');
//         isDownloading = false;
//         dispatch({ type: STORE_PROGRESS_DOWNLOADING, isDownloading } as AnyAction);
//       });
//     } else {
//       showErrorWithTimeout('Something went wrong!');
//     }
//     return true;
//   };
// };
// comment 01.05.2025
// export const onBulkDownloadStl = (allData: RowDataCompleted[] | RowDataCompleted, filetype: string, statusUpdate: boolean) => {
//   return async (dispatch: Dispatch<AppState>, getState: () => AppState) => {
//     const getFilesOrder: Array<string> = [];
//     let isDownloading = false;
//     console.log(allData, 'allData ::::::::::');
    
//     if (Array.isArray(allData)) {
//       allData.map((orderNos) => {
//         getFilesOrder.push(orderNos.orderno);
//       });
//     } else if (typeof allData === 'object') {
//       getFilesOrder.push(allData.orderno);
//     }

//     const showErrorWithTimeout = (message: string) => {
//       const errorFileUploadedOpen = true;
//       dispatch({ type: STORE_ERROR_FILES_UPLOADED, errorFileUploadedOpen } as AnyAction);
//       dispatch({ type: STORE_ERROR_FILES_UPLOADED_MSG, errorfilemsg: message } as AnyAction);
//      // Set timeout to clear error after 25 seconds
//       setTimeout(
//         () => {
//           dispatch({ type: STORE_ERROR_FILES_UPLOADED, errorFileUploadedOpen: false } as AnyAction);
//         }, 
//         25000
//       );
//     };
//     console.log(getFilesOrder, 'getFilesOrder <<<<<<<<');
    
//     if (getFilesOrder.length > 0) {
//       isDownloading = true;
//       dispatch({ type: STORE_PROGRESS_DOWNLOADING, isDownloading } as AnyAction);
      
//       axios(`${getState().environment.API_URL}getAllFiles`, {
//         method: 'POST',
//         headers: {
//           'Access-Control-Allow-Origin': '*',
//           'Content-Type': 'application/json',
//           sessionid: getState().user.userDetails.s || ''
//         },
//         data: {
//           caseno: getFilesOrder.toString(),
//           filetype: filetype || 'stl'
//         }
//       }).then(async response => {
//         const allDataStl = response.data;
//         console.log(allDataStl, 'allDataStl <<<<<>>>>>>>>>');
        
//         if (allDataStl.length > 0) {
//           const stlFiles: GetAllFileData[] = allDataStl.filter((fileEach: GetAllFileData) => fileEach.filetype === 'STL File');
//           console.log(stlFiles, 'stlFiles...........');
          
//           if (stlFiles.length > 0) {
//             const caseNoToFiletag = new Map();
//             const dataToProcess = Array.isArray(allData) ? allData : [allData];
//             dataToProcess.forEach(item => {
//               caseNoToFiletag.set(item.orderno, item.filetag);
//             });

//             const uniqueCaseNumbers = new Set(stlFiles.map(file => file.caseno));
//             const totalUniqueCaseCount = uniqueCaseNumbers.size;
            
//             const filesToDownload: Array<{name: string, key: string, caseno: string, filetag: string, totalUniqueCaseCount: number}> = [];
            
//             stlFiles.map((stlFile) => {
//               const filetag = caseNoToFiletag.get(stlFile.caseno) || '';
              
//               const fileValue = {
//                 name: (stlFile.filename).split('/').reverse()[0],
//                 key: stlFile.filename,
//                 caseno: stlFile.caseno,
//                 filetag: filetag,
//                 totalUniqueCaseCount: totalUniqueCaseCount
//               };

//               filesToDownload.push(fileValue);
//             });
                        
//             try {
//               const downloadResponse = await axios(`${getState().environment.API_URL}downloadAllFilesInOneZip`, {
//                 method: 'POST',
//                 headers: {
//                   'Access-Control-Allow-Origin': '*',
//                   'Content-Type': 'application/json',
//                   sessionid: getState().user.userDetails.s || ''
//                 },
//                 data: filesToDownload
//               });
              
//               if (downloadResponse.data.failedFiles && downloadResponse.data.failedFiles.length > 0) {
//                 const formattedFailedFiles = downloadResponse.data.failedFiles.map(
//                   (file: {name: string, caseno: string, STLCaseCount: string}) => ({
//                     fname: file.name,
//                     orderno: file.caseno,
//                     fileType: 'STL',
//                     caseCount: file.STLCaseCount
//                   })
//                 );
                
//                 showErrorWithFailedFiles(formattedFailedFiles, dispatch);
//               } 
              
//               if (statusUpdate) {
//                 const ordernosToUpdate = Array.from(new Set(filesToDownload.map(file => file.caseno)))
//                   .map(caseno => ({orderno: caseno}));
//                 downloadStatusUpdate(ordernosToUpdate, '1', dispatch, getState);
//               }
//               window.open(downloadResponse.data.signedUrl);
//               // alert('All STL files download initiated successfully.');
//             } catch (error) {
//               if (error.response && error.response.data && error.response.data.failedFiles) {
//                 const formattedFailedFiles = error.response.data.failedFiles.map(
//                   (file: {name: string, caseno: string}) => ({
//                     fname: file.name,
//                     orderno: file.caseno,
//                     fileType: 'STL',
//                   })
//                 );
                
//                 showErrorWithFailedFiles(formattedFailedFiles, dispatch);
//               } else {
//                 showErrorWithTimeout('Something went wrong with download!');
//               }
//             }

//             getCompleteOrderData(dispatch, getState);
            
//             isDownloading = false;
//             dispatch({ type: STORE_PROGRESS_DOWNLOADING, isDownloading } as AnyAction);
//           } else {
//             showErrorWithTimeout('No files found');
//             isDownloading = false;
//             dispatch({ type: STORE_PROGRESS_DOWNLOADING, isDownloading } as AnyAction);
//           }
//         } else {
//           showErrorWithTimeout('Something went wrong!');
//           isDownloading = false;
//           dispatch({ type: STORE_PROGRESS_DOWNLOADING, isDownloading } as AnyAction);
//         }
//       }).catch(error => {
//         showErrorWithTimeout('Something went wrong!');
//         isDownloading = false;
//         dispatch({ type: STORE_PROGRESS_DOWNLOADING, isDownloading } as AnyAction);
//       });
//     } else {
//       showErrorWithTimeout('Something went wrong!');
//     }
//     return true;
//   };
// };
// comment 02.05.2025 --- 12:48
// export const onBulkDownloadStl = (allData: RowDataCompleted[] | RowDataCompleted, filetype: string, statusUpdate: boolean) => {
//   return async (dispatch: Dispatch<AppState>, getState: () => AppState) => {
//     const getFilesOrder: Array<string> = [];
//     let isDownloading = false;

//     if (Array.isArray(allData)) {
//       allData.map((orderNos) => {
//         getFilesOrder.push(orderNos.orderno);
//       });
//     } else if (typeof allData === 'object') {
//       getFilesOrder.push(allData.orderno);
//     }

    // const showErrorWithTimeout = (message: string) => {
    //   const errorFileUploadedOpen = true;
    //   dispatch({ type: STORE_ERROR_FILES_UPLOADED, errorFileUploadedOpen } as AnyAction);
    //   dispatch({ type: STORE_ERROR_FILES_UPLOADED_MSG, errorfilemsg: message } as AnyAction);
    //  // Set timeout to clear error after 25 seconds
    //   setTimeout(
    //     () => {
    //       dispatch({ type: STORE_ERROR_FILES_UPLOADED, errorFileUploadedOpen: false } as AnyAction);
    //     }, 
    //     25000
    //   );
    // };

//     if (getFilesOrder.length > 0) {
//       isDownloading = true;
//       dispatch({ type: STORE_PROGRESS_DOWNLOADING, isDownloading } as AnyAction);

//       axios(`${getState().environment.API_URL}getAllFiles`, {
//         method: 'POST',
//         headers: {
//           'Access-Control-Allow-Origin': '*',
//           'Content-Type': 'application/json',
//           sessionid: getState().user.userDetails.s || ''
//         },
//         data: {
//           caseno: getFilesOrder.toString(),
//           filetype: filetype || 'stl'
//         }
//       }).then(async response => {
//         const allDataStl = response.data;

//         if (allDataStl.length > 0) {
//           const stlFiles: GetAllFileData[] = allDataStl.filter((fileEach: GetAllFileData) => fileEach.filetype === 'STL File');

//           if (stlFiles.length > 0) {
//             const caseNoToFiletag = new Map();
//             const dataToProcess = Array.isArray(allData) ? allData : [allData];
//             dataToProcess.forEach(item => {
//               caseNoToFiletag.set(item.orderno, item.filetag);
//             });

//             const uniqueCaseNumbers = new Set(stlFiles.map(file => file.caseno));
//             const totalUniqueCaseCount = uniqueCaseNumbers.size;

//             const filesToDownload: Array<{ name: string, key: string, caseno: string, filetag: string, totalUniqueCaseCount: number }> = [];

//             stlFiles.map((stlFile) => {
//               const filetag = caseNoToFiletag.get(stlFile.caseno) || '';

//               const fileValue = {
//                 name: (stlFile.filename).split('/').reverse()[0],
//                 key: stlFile.filename,
//                 caseno: stlFile.caseno,
//                 filetag: filetag,
//                 totalUniqueCaseCount: totalUniqueCaseCount
//               };

//               filesToDownload.push(fileValue);
//             });

//             try {
//               const downloadResponse = await axios(`${getState().environment.API_URL}downloadAllFilesInOneZip`, {
//                 method: 'POST',
//                 headers: {
//                   'Access-Control-Allow-Origin': '*',
//                   'Content-Type': 'application/json',
//                   sessionid: getState().user.userDetails.s || ''
//                 },
//                 data: filesToDownload
//               });

//               if (downloadResponse.data.failedFiles && downloadResponse.data.failedFiles.length > 0) {
//                 const formattedFailedFiles = downloadResponse.data.failedFiles.map(
//                   (file: { name: string, caseno: string, STLCaseCount: string }) => ({
//                     fname: file.name,
//                     orderno: file.caseno,
//                     fileType: 'STL',
//                     caseCount: file.STLCaseCount
//                   })
//                 );
//                 showErrorWithFailedFiles(formattedFailedFiles, dispatch);
//               }

//               if (statusUpdate) {
//                 const ordernosToUpdate = Array.from(new Set(filesToDownload.map(file => file.caseno)))
//                   .map(caseno => ({ orderno: caseno }));
//                 downloadStatusUpdate(ordernosToUpdate, '1', dispatch, getState);
//               }
//               const fileBlob = await axios.get(downloadResponse.data.signedUrl, { responseType: 'blob' });
//               const url = window.URL.createObjectURL(new Blob([fileBlob.data]));
//               const link = document.createElement('a');
//               link.href = url;

//               const fullFileName = downloadResponse.data.fileName || 'all_stl_files.zip';
//               const fileName = fullFileName.split('/').pop() || 'all_stl_files.zip';
//               link.setAttribute('download', fileName);

//               document.body.appendChild(link);
//               link.click();
//               link.remove();
//               if (downloadResponse?.data?.failedFiles?.length === 0) {
//                 alert('All STL files download successfully.');
//               }
             
//             } catch (error) {
//               if (error.response && error.response.data && error.response.data.failedFiles) {
//                 const formattedFailedFiles = error.response.data.failedFiles.map(
//                   (file: { name: string, caseno: string }) => ({
//                     fname: file.name,
//                     orderno: file.caseno,
//                     fileType: 'STL',
//                   })
//                 );
//                 showErrorWithFailedFiles(formattedFailedFiles, dispatch);
//               } else {
//                 showErrorWithTimeout('Something went wrong with download!');
//               }
//             }

//             getCompleteOrderData(dispatch, getState);
//             isDownloading = false;
//             dispatch({ type: STORE_PROGRESS_DOWNLOADING, isDownloading } as AnyAction);
//           } else {
//             showErrorWithTimeout('No files found');
//             isDownloading = false;
//             dispatch({ type: STORE_PROGRESS_DOWNLOADING, isDownloading } as AnyAction);
//           }
//         } else {
//           showErrorWithTimeout('Something went wrong!');
//           isDownloading = false;
//           dispatch({ type: STORE_PROGRESS_DOWNLOADING, isDownloading } as AnyAction);
//         }
//       }).catch(error => {
//         showErrorWithTimeout('Something went wrong!');
//         isDownloading = false;
//         dispatch({ type: STORE_PROGRESS_DOWNLOADING, isDownloading } as AnyAction);
//       });
//     } else {
//       showErrorWithTimeout('Something went wrong!');
//     }
//     return true;
//   };
// };
// comment for 02.05.2025 --- 09:57 PM
// export const onBulkDownloadStl = (
//   allData: RowDataCompleted[] | RowDataCompleted,
//   filetype: string,
//   statusUpdate: boolean
// ) => {
//   return async (dispatch: Dispatch<AppState>, getState: () => AppState) => {
//     const getFilesOrder: Array<string> = [];
//     let isDownloading = false;

//     if (Array.isArray(allData)) {
//       allData.map((orderNos) => {
//         getFilesOrder.push(orderNos.orderno);
//       });
//     } else if (typeof allData === 'object') {
//       getFilesOrder.push(allData.orderno);
//     }

//     const showErrorWithTimeout = (message: string) => {
//       const errorFileUploadedOpen = true;
//       dispatch({ type: STORE_ERROR_FILES_UPLOADED, errorFileUploadedOpen } as AnyAction);
//       dispatch({ type: STORE_ERROR_FILES_UPLOADED_MSG, errorfilemsg: message } as AnyAction);
//      // Set timeout to clear error after 25 seconds
//       setTimeout(
//         () => {
//           dispatch({ type: STORE_ERROR_FILES_UPLOADED, errorFileUploadedOpen: false } as AnyAction);
//         }, 
//         25000
//       );
//     };

//     if (getFilesOrder.length > 0) {
//       isDownloading = true;
//       dispatch({ type: STORE_PROGRESS_DOWNLOADING, isDownloading } as AnyAction);

//       axios(`${getState().environment.API_URL}getAllFiles`, {
//         method: 'POST',
//         headers: {
//           'Access-Control-Allow-Origin': '*',
//           'Content-Type': 'application/json',
//           sessionid: getState().user.userDetails.s || ''
//         },
//         data: {
//           caseno: getFilesOrder.toString(),
//           filetype: filetype || 'stl'
//         }
//       }).then(async response => {
//         const allDataStl = response.data;

//         if (allDataStl.length > 0) {
//           const stlFiles: GetAllFileData[] = allDataStl.filter((fileEach: GetAllFileData) => fileEach.filetype === 'STL File');

//           if (stlFiles.length > 0) {
//             const caseNoToFiletag = new Map();
//             const dataToProcess = Array.isArray(allData) ? allData : [allData];
//             dataToProcess.forEach(item => {
//               caseNoToFiletag.set(item.orderno, item.filetag);
//             });

//             const uniqueCaseNumbers = new Set(stlFiles.map(file => file.caseno));
//             const totalUniqueCaseCount = uniqueCaseNumbers.size;

//             const filesToDownload: Array<{ name: string, key: string, caseno: string, filetag: string, totalUniqueCaseCount: number }> = [];

//             stlFiles.map((stlFile) => {
//               const filetag = caseNoToFiletag.get(stlFile.caseno) || '';
//               const fileValue = {
//                 name: (stlFile.filename).split('/').reverse()[0],
//                 key: stlFile.filename,
//                 caseno: stlFile.caseno,
//                 filetag: filetag,
//                 totalUniqueCaseCount: totalUniqueCaseCount
//               };
//               filesToDownload.push(fileValue);
//             });

//             try {
//               const downloadResponse = await axios(`${getState().environment.API_URL}downloadAllFilesInOneZip`, {
//                 method: 'POST',
//                 headers: {
//                   'Access-Control-Allow-Origin': '*',
//                   'Content-Type': 'application/json',
//                   sessionid: getState().user.userDetails.s || ''
//                 },
//                 data: filesToDownload
//               });

//               const failedFiles = downloadResponse?.data?.failedFiles || [];

//               if (failedFiles.length > 0) {
//                 const formattedFailedFiles = failedFiles.map(
//                   (file: { name: string, caseno: string, STLCaseCount: string }) => ({
//                     fname: file.name,
//                     orderno: file.caseno,
//                     fileType: 'STL',
//                     caseCount: file.STLCaseCount
//                   })
//                 );
//                 showErrorWithFailedFiles(formattedFailedFiles, dispatch);
//               }

//               if (statusUpdate) {
//                 const ordernosToUpdate = Array.from(new Set(filesToDownload.map(file => file.caseno)))
//                   .map(caseno => ({ orderno: caseno }));
//                 downloadStatusUpdate(ordernosToUpdate, '1', dispatch, getState);
//               }

//               const fileBlob = await axios.get(downloadResponse.data.signedUrl, { responseType: 'blob' });
//               const url = window.URL.createObjectURL(new Blob([fileBlob.data]));
//               const link = document.createElement('a');
//               link.href = url;

//               const fullFileName = downloadResponse.data.fileName || 'all_stl_files.zip';
//               const fileName = fullFileName.split('/').pop() || 'all_stl_files.zip';
//               link.setAttribute('download', fileName);

//               document.body.appendChild(link);
//               link.click();
//               link.remove();

//               if (!failedFiles.length) {
//                 alert('All STL files downloaded successfully.');
//               }

//             } catch (error) {
//               if (error.response && error.response.data && error.response.data.failedFiles) {
//                 const formattedFailedFiles = error.response.data.failedFiles.map(
//                   (file: { name: string, caseno: string }) => ({
//                     fname: file.name,
//                     orderno: file.caseno,
//                     fileType: 'STL',
//                   })
//                 );
//                 showErrorWithFailedFiles(formattedFailedFiles, dispatch);
//               } else {
//                 showErrorWithTimeout('Something went wrong with download!');
//               }
//             }

//             getCompleteOrderData(dispatch, getState);
//             isDownloading = false;
//             dispatch({ type: STORE_PROGRESS_DOWNLOADING, isDownloading } as AnyAction);
//           } else {
//             showErrorWithTimeout('No files found');
//             isDownloading = false;
//             dispatch({ type: STORE_PROGRESS_DOWNLOADING, isDownloading } as AnyAction);
//           }
//         } else {
//           showErrorWithTimeout('Something went wrong!');
//           isDownloading = false;
//           dispatch({ type: STORE_PROGRESS_DOWNLOADING, isDownloading } as AnyAction);
//         }
//       }).catch(error => {
//         showErrorWithTimeout('Something went wrong!');
//         isDownloading = false;
//         dispatch({ type: STORE_PROGRESS_DOWNLOADING, isDownloading } as AnyAction);
//       });
//     } else {
//       showErrorWithTimeout('Something went wrong!');
//     }

//     return true;
//   };
// };
// export const onBulkDownloadStl = (
//   allData: RowDataCompleted[] | RowDataCompleted,
//   filetype: string,
//   statusUpdate: boolean
// ) => {
//   return async (dispatch: Dispatch<AppState>, getState: () => AppState) => {
//     const getFilesOrder: Array<string> = [];
//     let isDownloading = false;

//     if (Array.isArray(allData)) {
//       allData.map((orderNos) => {
//         getFilesOrder.push(orderNos.orderno);
//       });
//     } else if (typeof allData === 'object') {
//       getFilesOrder.push(allData.orderno);
//     }

//     const showErrorWithTimeout = (message: string) => {
//       const errorFileUploadedOpen = true;
//       dispatch({ type: STORE_ERROR_FILES_UPLOADED, errorFileUploadedOpen } as AnyAction);
//       dispatch({ type: STORE_ERROR_FILES_UPLOADED_MSG, errorfilemsg: message } as AnyAction);
//       // Set timeout to clear error after 25 seconds
//       setTimeout(
//         () => {
//           dispatch({ type: STORE_ERROR_FILES_UPLOADED, errorFileUploadedOpen: false } as AnyAction);
//         }, 
//         25000
//       );
//     };

//     if (getFilesOrder.length > 0) {
//       isDownloading = true;
//       dispatch({ type: STORE_PROGRESS_DOWNLOADING, isDownloading } as AnyAction);

//       axios(`${getState().environment.API_URL}getAllFiles`, {
//         method: 'POST',
//         headers: {
//           'Access-Control-Allow-Origin': '*',
//           'Content-Type': 'application/json',
//           sessionid: getState().user.userDetails.s || ''
//         },
//         data: {
//           caseno: getFilesOrder.toString(),
//           filetype: filetype || 'stl'
//         }
//       }).then(async axiosResponse => { // Renamed from 'response' to 'axiosResponse'
//         const allDataStl = axiosResponse.data;

//         if (allDataStl.length > 0) {
//           const stlFiles: GetAllFileData[] = allDataStl.filter((fileEach: GetAllFileData) => fileEach.filetype === 'STL File');

//           if (stlFiles.length > 0) {
//             const caseNoToFiletag = new Map();
//             const dataToProcess = Array.isArray(allData) ? allData : [allData];
//             dataToProcess.forEach(item => {
//               caseNoToFiletag.set(item.orderno, item.filetag);
//             });

//             const uniqueCaseNumbers = new Set(stlFiles.map(file => file.caseno));
//             const totalUniqueCaseCount = uniqueCaseNumbers.size;

//             const filesToDownload: Array<{ name: string, key: string, caseno: string, filetag: string, totalUniqueCaseCount: number }> = [];

//             stlFiles.map((stlFile) => {
//               const filetag = caseNoToFiletag.get(stlFile.caseno) || '';
//               const fileValue = {
//                 name: (stlFile.filename).split('/').reverse()[0],
//                 key: stlFile.filename,
//                 caseno: stlFile.caseno,
//                 filetag: filetag,
//                 totalUniqueCaseCount: totalUniqueCaseCount
//               };
//               filesToDownload.push(fileValue);
//             });

//             try {
//               // Modified to handle direct file download instead of signed URL
//               const downloadUrl = `${getState().environment.API_URL}downloadAllFilesInOneZip`;
              
//               // Create form data with the files to download
//               const formData = new FormData();
//               formData.append('data', JSON.stringify(filesToDownload));
              
//               // Direct download approach using fetch with blob
//               fetch(downloadUrl, {
//                 method: 'POST',
//                 headers: {
//                   'Access-Control-Allow-Origin': '*',
//                   'Content-Type': 'application/json',
//                   sessionid: getState().user.userDetails.s || ''
//                 },
//                 body: JSON.stringify(filesToDownload)
//               })
//               .then(fetchResponse => { // Renamed from 'response' to 'fetchResponse'
//                 // Check if response is ok
//                 if (!fetchResponse.ok) {
//                   return fetchResponse.json().then(errorData => {
//                     throw new Error(errorData.message || 'Download failed');
//                   });
//                 }
                
//                 // Get filename from content-disposition header if available
//                 const contentDisposition = fetchResponse.headers.get('content-disposition');
//                 let filename = 'stlfiledownload.zip';
                
//                 if (contentDisposition) {
//                   const filenameMatch = contentDisposition.match(/filename="(.+)"/);
//                   if (filenameMatch) {
//                     filename = filenameMatch[1];
//                   }
//                 }
                
//                 // Get the blob from response
//                 return fetchResponse.blob().then(blob => ({ blob, filename }));
//               })
//               .then(({ blob, filename }) => {
//                 // Create object URL and trigger download
//                 const url = window.URL.createObjectURL(blob);
//                 const link = document.createElement('a');
//                 link.href = url;
//                 link.setAttribute('download', filename);
//                 document.body.appendChild(link);
//                 link.click();
                
//                 setTimeout(() => { window.URL.revokeObjectURL(url); document.body.removeChild(link); }, 100);

//                 // Update status if needed
//                 if (statusUpdate) {
//                   const ordernosToUpdate = Array.from(new Set(filesToDownload.map(file => file.caseno)))
//                     .map(caseno => ({ orderno: caseno }));
//                   downloadStatusUpdate(ordernosToUpdate, '1', dispatch, getState);
//                 }
                
//                 alert('STL files downloaded successfully.');
//                 getCompleteOrderData(dispatch, getState);
//               })
//               .catch(error => {
//                 console.error('Download error:', error);
                
//                 // Handle failed files if available in error response
//                 if (error.response && error.response.data && error.response.data.failedFiles) {
//                   const formattedFailedFiles = error.response.data.failedFiles.map(
//                     (file: { name: string, caseno: string }) => ({
//                       fname: file.name,
//                       orderno: file.caseno,
//                       fileType: 'STL',
//                     })
//                   );
//                   showErrorWithFailedFiles(formattedFailedFiles, dispatch);
//                 } else {
//                   showErrorWithTimeout('Something went wrong with download!');
//                 }
//               })
//               .finally(() => {
//                 isDownloading = false;
//                 dispatch({ type: STORE_PROGRESS_DOWNLOADING, isDownloading } as AnyAction);
//               });

//             } catch (error) {
//               showErrorWithTimeout('Something went wrong with download!');
//               isDownloading = false;
//               dispatch({ type: STORE_PROGRESS_DOWNLOADING, isDownloading } as AnyAction);
//             }
//           } else {
//             showErrorWithTimeout('No files found');
//             isDownloading = false;
//             dispatch({ type: STORE_PROGRESS_DOWNLOADING, isDownloading } as AnyAction);
//           }
//         } else {
//           showErrorWithTimeout('Something went wrong!');
//           isDownloading = false;
//           dispatch({ type: STORE_PROGRESS_DOWNLOADING, isDownloading } as AnyAction);
//         }
//       }).catch(error => {
//         showErrorWithTimeout('Something went wrong!');
//         isDownloading = false;
//         dispatch({ type: STORE_PROGRESS_DOWNLOADING, isDownloading } as AnyAction);
//       });
//     } else {
//       showErrorWithTimeout('Something went wrong!');
//     }

//     return true;
//   };
// };
// comments for 03.05.2025
// export const onBulkDownloadStl = (
//   allData: RowDataCompleted[] | RowDataCompleted,
//   filetype: string,
//   statusUpdate: boolean
// ) => {
//   return async (dispatch: Dispatch<AppState>, getState: () => AppState) => {
//     const getFilesOrder: Array<string> = [];
//     let isDownloading = false;

//     console.log('Input allData:', allData);
//     console.log('Selected filetype:', filetype);
//     console.log('Status update required:', statusUpdate);

//     if (Array.isArray(allData)) {
//       allData.map((orderNos) => {
//         getFilesOrder.push(orderNos.orderno);
//       });
//     } else if (typeof allData === 'object') {
//       getFilesOrder.push(allData.orderno);
//     }

//     console.log('Order numbers to download:', getFilesOrder);

//     const showErrorWithTimeout = (message: string) => {
//       console.log('Error message triggered:', message);
//       const errorFileUploadedOpen = true;
//       dispatch({ type: STORE_ERROR_FILES_UPLOADED, errorFileUploadedOpen } as AnyAction);
//       dispatch({ type: STORE_ERROR_FILES_UPLOADED_MSG, errorfilemsg: message } as AnyAction);
//       setTimeout(
//         () => {
//           dispatch({ type: STORE_ERROR_FILES_UPLOADED, errorFileUploadedOpen: false } as AnyAction);
//         }, 
//         25000
//       );
//     };

//     if (getFilesOrder.length > 0) {
//       isDownloading = true;
//       dispatch({ type: STORE_PROGRESS_DOWNLOADING, isDownloading } as AnyAction);

//       axios(`${getState().environment.API_URL}getAllFiles`, {
//         method: 'POST',
//         headers: {
//           'Access-Control-Allow-Origin': '*',
//           'Content-Type': 'application/json',
//           sessionid: getState().user.userDetails.s || ''
//         },
//         data: {
//           caseno: getFilesOrder.toString(),
//           filetype: filetype || 'stl'
//         }
//       }).then(async axiosResponse => {
//         console.log('API response received for getAllFiles');

//         const allDataStl = axiosResponse.data;
//         console.log('Total files returned:', allDataStl.length);

//         if (allDataStl.length > 0) {
//           const stlFiles: GetAllFileData[] = allDataStl.filter((fileEach: GetAllFileData) => fileEach.filetype === 'STL File');

//           console.log('Filtered STL files:', stlFiles.length);

//           if (stlFiles.length > 0) {
//             const caseNoToFiletag = new Map();
//             const dataToProcess = Array.isArray(allData) ? allData : [allData];
//             dataToProcess.forEach(item => {
//               caseNoToFiletag.set(item.orderno, item.filetag);
//             });

//             const uniqueCaseNumbers = new Set(stlFiles.map(file => file.caseno));
//             const totalUniqueCaseCount = uniqueCaseNumbers.size;
//             console.log('Unique STL case numbers:', totalUniqueCaseCount);

//             const filesToDownload: Array<{ name: string, key: string, caseno: string, filetag: string, totalUniqueCaseCount: number }> = [];

//             stlFiles.map((stlFile) => {
//               const filetag = caseNoToFiletag.get(stlFile.caseno) || '';
//               const fileValue = {
//                 name: (stlFile.filename).split('/').reverse()[0],
//                 key: stlFile.filename,
//                 caseno: stlFile.caseno,
//                 filetag: filetag,
//                 totalUniqueCaseCount: totalUniqueCaseCount
//               };
//               filesToDownload.push(fileValue);
//             });

//             console.log('Prepared files for ZIP download:', filesToDownload);

//             try {
//               const downloadUrl = `${getState().environment.API_URL}downloadAllFilesInOneZip`;

//               const formData = new FormData();
//               formData.append('data', JSON.stringify(filesToDownload));

//               fetch(downloadUrl, {
//                 method: 'POST',
//                 headers: {
//                   'Access-Control-Allow-Origin': '*',
//                   'Content-Type': 'application/json',
//                   sessionid: getState().user.userDetails.s || ''
//                 },
//                 body: JSON.stringify(filesToDownload)
//               })
//               .then(fetchResponse => {
//                 console.log('Received response from ZIP download endpoint');

//                 if (!fetchResponse.ok) {
//                   return fetchResponse.json().then(errorData => {
//                     throw new Error(errorData.message || 'Download failed');
//                   });
//                 }

//                 const contentDisposition = fetchResponse.headers.get('content-disposition');
//                 let filename = 'stlfiledownload.zip';

//                 if (contentDisposition) {
//                   const filenameMatch = contentDisposition.match(/filename="(.+)"/);
//                   if (filenameMatch) {
//                     filename = filenameMatch[1];
//                   }
//                 }

//                 return fetchResponse.blob().then(blob => ({ blob, filename }));
//               })
//               .then(({ blob, filename }) => {
//                 console.log('Download blob received, filename:', filename);
//                 const url = window.URL.createObjectURL(blob);
//                 const link = document.createElement('a');
//                 link.href = url;
//                 link.setAttribute('download', filename);
//                 document.body.appendChild(link);
//                 link.click();

//                 setTimeout(() => { window.URL.revokeObjectURL(url); document.body.removeChild(link); }, 100);

//                 if (statusUpdate) {
//                   const ordernosToUpdate = Array.from(new Set(filesToDownload.map(file => file.caseno)))
//                     .map(caseno => ({ orderno: caseno }));
//                   console.log('Updating download status for:', ordernosToUpdate);
//                   downloadStatusUpdate(ordernosToUpdate, '1', dispatch, getState);
//                 }

//                 alert('STL files downloaded successfully.');
//                 getCompleteOrderData(dispatch, getState);
//               })
//               .catch(error => {
//                 console.log('Download error caught:', error);

//                 if (error.response && error.response.data && error.response.data.failedFiles) {
//                   const formattedFailedFiles = error.response.data.failedFiles.map(
//                     (file: { name: string, caseno: string }) => ({
//                       fname: file.name,
//                       orderno: file.caseno,
//                       fileType: 'STL',
//                     })
//                   );
//                   showErrorWithFailedFiles(formattedFailedFiles, dispatch);
//                 } else {
//                   showErrorWithTimeout('Something went wrong with download!');
//                 }
//               })
//               .finally(() => {
//                 isDownloading = false;
//                 dispatch({ type: STORE_PROGRESS_DOWNLOADING, isDownloading } as AnyAction);
//               });

//             } catch (error) {
//               console.log('Try-catch error during download:', error);
//               showErrorWithTimeout('Something went wrong with download!');
//               isDownloading = false;
//               dispatch({ type: STORE_PROGRESS_DOWNLOADING, isDownloading } as AnyAction);
//             }
//           } else {
//             showErrorWithTimeout('No files found');
//             isDownloading = false;
//             dispatch({ type: STORE_PROGRESS_DOWNLOADING, isDownloading } as AnyAction);
//           }
//         } else {
//           showErrorWithTimeout('Something went wrong!');
//           isDownloading = false;
//           dispatch({ type: STORE_PROGRESS_DOWNLOADING, isDownloading } as AnyAction);
//         }
//       }).catch(error => {
//         console.log('Axios error caught:', error);
//         showErrorWithTimeout('Something went wrong!');
//         isDownloading = false;
//         dispatch({ type: STORE_PROGRESS_DOWNLOADING, isDownloading } as AnyAction);
//       });
//     } else {
//       showErrorWithTimeout('Something went wrong!');
//     }

//     return true;
//   };
// };
export const onBulkDownloadStl = (
  allData: RowDataCompleted[] | RowDataCompleted,
  filetype: string,
  statusUpdate: boolean
) => {
  return async (dispatch: Dispatch<AppState>, getState: () => AppState) => {
    const getFilesOrder: Array<string> = [];
    let isDownloading = false;

    if (Array.isArray(allData)) {
      allData.map((orderNos) => {
        getFilesOrder.push(orderNos.orderno);
      });
    } else if (typeof allData === 'object') {
      getFilesOrder.push(allData.orderno);
    }

    const showErrorWithTimeout = (message: string) => {
      const errorFileUploadedOpen = true;
      dispatch({ type: STORE_ERROR_FILES_UPLOADED, errorFileUploadedOpen } as AnyAction);
      dispatch({ type: STORE_ERROR_FILES_UPLOADED_MSG, errorfilemsg: message } as AnyAction);
      // Set timeout to clear error after 25 seconds
      setTimeout(
        () => {
          dispatch({ type: STORE_ERROR_FILES_UPLOADED, errorFileUploadedOpen: false } as AnyAction);
        }, 
        25000
      );
    };

    if (getFilesOrder.length > 0) {
      isDownloading = true;
      dispatch({ type: STORE_PROGRESS_DOWNLOADING, isDownloading } as AnyAction);
      axios(`${getState().environment.API_URL}getAllFiles`, {
        method: 'POST',
        headers: {
          'Access-Control-Allow-Origin': '*',
          'Content-Type': 'application/json',
          sessionid: getState().user.userDetails.s || ''
        },
        data: {
          caseno: getFilesOrder.toString(),
          filetype: filetype || 'stl'
        }
      }).then(async response => {
        const allDataStl = response.data;

        if (allDataStl.length > 0) {
          const stlFiles: GetAllFileData[] = allDataStl.filter((fileEach: GetAllFileData) => fileEach.filetype === 'STL File');

          if (stlFiles.length > 0) {
            const caseNoToFiletag = new Map();
            const dataToProcess = Array.isArray(allData) ? allData : [allData];
            dataToProcess.forEach(item => {
              caseNoToFiletag.set(item.orderno, item.filetag);
            });
            const uniqueCaseNumbers = new Set(stlFiles.map(file => file.caseno));
            const totalUniqueCaseCount = uniqueCaseNumbers.size;

            const filesToDownload: Array<{ name: string, key: string, caseno: string, filetag: string, totalUniqueCaseCount: number }> = [];

            stlFiles.map((stlFile) => {
              const filetag = caseNoToFiletag.get(stlFile.caseno) || '';
              const fileValue = {
                name: (stlFile.filename).split('/').reverse()[0],
                key: stlFile.filename,
                caseno: stlFile.caseno,
                filetag: filetag,
                totalUniqueCaseCount: totalUniqueCaseCount,
                userName: getState().user.userDetails.userName || ''
              };
              filesToDownload.push(fileValue);
            });

            try {
              const downloadResponse = await axios(`${getState().environment.API_URL}downloadAllFilesInOneZip`, {
                method: 'POST',
                headers: {
                  'Access-Control-Allow-Origin': '*',
                  'Content-Type': 'application/json',
                  sessionid: getState().user.userDetails.s || ''
                },
                data: filesToDownload
              });
              const failedFiles = downloadResponse?.data?.failedFiles || [];

              if (failedFiles.length > 0) {
                
                const formattedFailedFiles = failedFiles.map(
                  (file: { name: string, caseno: string, STLCaseCount: string }) => ({
                    fname: file.name,
                    orderno: file.caseno,
                    fileType: 'STL',
                    caseCount: file.STLCaseCount
                  })
                );
                showErrorWithFailedFiles(formattedFailedFiles, dispatch);
              }

              if (statusUpdate) {
                const ordernosToUpdate = Array.from(new Set(filesToDownload.map(file => file.caseno)))
                  .map(caseno => ({ orderno: caseno }));
                downloadStatusUpdate(ordernosToUpdate, '1', dispatch, getState);
              }
              
              if (downloadResponse.data.status && downloadResponse.data.localFilePath) {
                const fileUrl = `${getState().environment.API_URL}${downloadResponse.data.localFilePath}`;
                const link = document.createElement('a');
                link.href = fileUrl;
                link.setAttribute('download', downloadResponse.data.fileName || 'all_stl_files.zip');
                document.body.appendChild(link);
                link.click();
                link.remove();

                if (!failedFiles.length) {
                  alert('All STL files downloaded successfully.');
                  // Add code for deleting the folder and Zip files with settimeout of 2 sec(set environment)
                }
              } else {
                showErrorWithTimeout('Failed to get download path.');
              }

            } catch (error) {
              console.error('Error during downloadAllFilesInOneZip:', error);
              if (error.response && error.response.data && error.response.data.failedFiles) {
                const formattedFailedFiles = error.response.data.failedFiles.map(
                  (file: { name: string, caseno: string }) => ({
                    fname: file.name,
                    orderno: file.caseno,
                    fileType: 'STL',
                  })
                );
                showErrorWithFailedFiles(formattedFailedFiles, dispatch);
              } else {
                showErrorWithTimeout('Something went wrong with download!');
              }
            }

            getCompleteOrderData(dispatch, getState);
            isDownloading = false;
            dispatch({ type: STORE_PROGRESS_DOWNLOADING, isDownloading } as AnyAction);
          } else {
            showErrorWithTimeout('No files found');
            isDownloading = false;
            dispatch({ type: STORE_PROGRESS_DOWNLOADING, isDownloading } as AnyAction);
          }
        } else {
          showErrorWithTimeout('Something went wrong!');
          isDownloading = false;
          dispatch({ type: STORE_PROGRESS_DOWNLOADING, isDownloading } as AnyAction);
        }
      }).catch(error => {
        showErrorWithTimeout('Something went wrong!');
        isDownloading = false;
        dispatch({ type: STORE_PROGRESS_DOWNLOADING, isDownloading } as AnyAction);
      });
    } else {
      showErrorWithTimeout('Something went wrong!');
    }

    return true;
  };
};

export const printClient = (completedData: RowDataCompleted) => {
  return async (dispatch: Dispatch<AppState>, getState: () => AppState) => {

    let fullPath = '';

    if (completedData.fpath.indexOf('/Initial') !== -1) {
      fullPath = `${completedData.fpath.split('/Initial')[0]}/Final_Scan/${completedData.fname}`;
    } else {
      fullPath = `${completedData.fpath}`;
    }

    const encodedFullPathAll = encodeURIComponent(fullPath);
    axios(`${getState().environment.API_URL}getDownloadUrl?fullPath=${encodedFullPathAll}`, {
      method: 'GET',
      headers: {
        'Access-Control-Allow-Origin': '*',
        'Content-Type': 'application/json',
        sessionid: getState().user.userDetails.s || ''
      }
    }).then(async (response) => {

      try {
        window.open(`mlcprintetec:${response.data.signedUrl}`);
      } catch (err) {
        dispatch(push('/app/printclient'));
      }

    }).catch(error => {
      const errorFileUploadedOpen = true;
      const errorfilemsg = 'Something went wrong!';
      dispatch({ type: STORE_ERROR_FILES_UPLOADED, errorFileUploadedOpen } as AnyAction);
      dispatch({ type: STORE_ERROR_FILES_UPLOADED_MSG, errorfilemsg } as AnyAction);
      // ==> console.error(error);
    });
  };
};

export const getManuFactCompletedData = async (dispatch: Dispatch<AppState>, getState: () => AppState) => {
 
  dispatch({ type: STORE_LOADER, loader: true } as AnyAction);
 
  axios({
      method: 'post',
      url: `${getState().environment.API_URL}loadOrderData?listType=mrecdon&userCode=${encodeURIComponent(getState().user.userDetails.userName)}&status=COMPLETED`,
      headers: {
          'Access-Control-Allow-Origin': '*',
          'Content-Type': 'application/json',
          sessionid: getState().user.userDetails.s || ''
      }
  }).then(function (response: AxiosResponse) {

      dispatch({ type: STORE_LOADER, loader: false } as AnyAction);
      if (response.data.length === 1) {

          if (response.data[0].orderno !== '') {

              const manucompleteOrderData: RowDataCompleted[] = response.data;
              dispatch({ type: STORE_MANUFACTCOMPLETEORDERDATA, manucompleteOrderData } as AnyAction);
          } else {

              const manucompleteOrderData: RowDataCompleted[] = [];
              dispatch({ type: STORE_MANUFACTCOMPLETEORDERDATA, manucompleteOrderData } as AnyAction);
          }

      } else {

          const manucompleteOrderData: RowDataCompleted[] = response.data;
          dispatch({ type: STORE_MANUFACTCOMPLETEORDERDATA, manucompleteOrderData } as AnyAction);
      }

  }).catch(function (error: AxiosError) {

      dispatch({ type: STORE_LOADER, loader: false } as AnyAction);

      const manucompleteOrderData: RowDataCompleted[] = [];
      dispatch({ type: STORE_MANUFACTCOMPLETEORDERDATA, manucompleteOrderData } as AnyAction);

  });

};

export const onManuFilterCompletedData = (data: ManuCompOrderFilterData) => {
  return async (dispatch: Dispatch<AppState>, getState: () => AppState) => {

    dispatch({ type: STORE_LOADER, loader: true } as AnyAction);

    await axios({
      method: 'post',
      url: `${getState().environment.API_URL}getfilterdata`,
      headers: {
        'Access-Control-Allow-Origin': '*',
        'Content-Type': 'application/json',
        sessionid: getState().user.userDetails.s || ''
      },
      data: {
        listType: 'mrecdon',
        data: {
          ...data, ...{
            fdate: commonDateFormat(data.fdate, 'date') || null,
            tdate: commonDateFormat(data.tdate, 'date') || null,
            pusername: getState().user.userDetails.userName
          }
        }
      }
    }).then(function (response: AxiosResponse) {

      dispatch({ type: STORE_LOADER, loader: false } as AnyAction);

      if (response.data.length === 1) {
        if (response.data[0].orderno !== '') {
          const manucompleteOrderData: RowDataCompleted[] = response.data;
          dispatch({ type: STORE_MANUFACTCOMPLETEORDERDATA, manucompleteOrderData } as AnyAction);
        } else {
          const manucompleteOrderData: RowDataCompleted[] = [];
          dispatch({ type: STORE_MANUFACTCOMPLETEORDERDATA, manucompleteOrderData } as AnyAction);
        }
      } else {
        const manucompleteOrderData: RowDataCompleted[] = response.data;
        dispatch({ type: STORE_MANUFACTCOMPLETEORDERDATA, manucompleteOrderData } as AnyAction);
      }

    }).catch(function (error: AxiosError) {

      dispatch({ type: STORE_LOADER, loader: false } as AnyAction);

      const manucompleteOrderData: RowDataCompleted[] = [];
      dispatch({ type: STORE_MANUFACTCOMPLETEORDERDATA, manucompleteOrderData } as AnyAction);
    });
    
  };
};



// WEBPACK FOOTER //
// ./src/actions/completeOrderAction.ts